import React from 'react';
import PropTypes from 'prop-types';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var ArrowUpContained01 = function ArrowUpContained01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.49 12.559a.75.75 0 00.961 1.152l-.96-1.152zm4.724-2.96l.48-.576a.75.75 0 00-.96 0l.48.576zm3.762 4.112a.75.75 0 00.96-1.152l-.96 1.152zm-7.525 0l4.243-3.535-.96-1.153L7.49 12.56l.96 1.152zm3.282-3.535l4.243 3.535.96-1.152-4.242-3.536-.96 1.153zM20.85 12A8.85 8.85 0 0112 20.85v1.5c5.716 0 10.35-4.634 10.35-10.35h-1.5zM12 20.85A8.85 8.85 0 013.15 12h-1.5c0 5.716 4.634 10.35 10.35 10.35v-1.5zM3.15 12A8.85 8.85 0 0112 3.15v-1.5C6.284 1.65 1.65 6.284 1.65 12h1.5zM12 3.15A8.85 8.85 0 0120.85 12h1.5c0-5.716-4.634-10.35-10.35-10.35v1.5z"
  }));
};

ArrowUpContained01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpContained01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowDownContained01 = function ArrowDownContained01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.936 11.376a.75.75 0 10-.96-1.153l.96 1.153zm-4.723 2.959l-.48.576a.75.75 0 00.96 0l-.48-.576zM8.45 10.223a.75.75 0 10-.96 1.153l.96-1.153zm7.525 0l-4.242 3.536.96 1.152 4.243-3.535-.96-1.153zm-3.282 3.536L8.45 10.223l-.96 1.153 4.243 3.535.96-1.152zM20.85 12A8.85 8.85 0 0112 20.85v1.5c5.716 0 10.35-4.634 10.35-10.35h-1.5zM12 20.85A8.85 8.85 0 013.15 12h-1.5c0 5.716 4.634 10.35 10.35 10.35v-1.5zM3.15 12A8.85 8.85 0 0112 3.15v-1.5C6.284 1.65 1.65 6.284 1.65 12h1.5zM12 3.15A8.85 8.85 0 0120.85 12h1.5c0-5.716-4.634-10.35-10.35-10.35v1.5z"
  }));
};

ArrowDownContained01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownContained01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowLeftContained01 = function ArrowLeftContained01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.559 16.51a.75.75 0 101.152-.961l-1.152.96zm-2.96-4.724l-.576-.48a.75.75 0 000 .96l.576-.48zm4.112-3.762a.75.75 0 10-1.152-.96l1.152.96zm0 7.525l-3.536-4.243-1.152.96 3.536 4.243 1.152-.96zm-3.536-3.283l3.536-4.242-1.152-.96-3.536 4.242 1.152.96zM12 3.15A8.85 8.85 0 0120.85 12h1.5c0-5.716-4.634-10.35-10.35-10.35v1.5zM20.85 12A8.85 8.85 0 0112 20.85v1.5c5.716 0 10.35-4.634 10.35-10.35h-1.5zM12 20.85A8.85 8.85 0 013.15 12h-1.5c0 5.716 4.634 10.35 10.35 10.35v-1.5zM3.15 12A8.85 8.85 0 0112 3.15v-1.5C6.284 1.65 1.65 6.284 1.65 12h1.5z"
  }));
};

ArrowLeftContained01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowLeftContained01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowRightContained01 = function ArrowRightContained01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.376 7.064a.75.75 0 00-1.153.96l1.152-.96zm2.959 4.723l.576.48a.75.75 0 000-.96l-.576.48zm-4.112 3.763a.75.75 0 001.152.96l-1.152-.96zm0-7.525l3.536 4.242 1.152-.96-3.535-4.243-1.153.96zm3.536 3.282l-3.536 4.243 1.152.96 3.536-4.243-1.152-.96zm-1.76-8.157A8.85 8.85 0 0120.85 12h1.5c0-5.716-4.633-10.35-10.35-10.35v1.5zM20.85 12A8.85 8.85 0 0112 20.85v1.5c5.717 0 10.35-4.634 10.35-10.35h-1.5zM12 20.85A8.85 8.85 0 013.15 12h-1.5c0 5.716 4.635 10.35 10.35 10.35v-1.5zM3.15 12A8.85 8.85 0 0112 3.15v-1.5C6.285 1.65 1.65 6.284 1.65 12h1.5z"
  }));
};

ArrowRightContained01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowRightContained01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowUpContained02 = function ArrowUpContained02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.277 10.717a.75.75 0 10.96 1.152l-.96-1.152zM12 7.757l.48-.576a.75.75 0 00-.96 0l.48.576zm3.762 4.112a.75.75 0 10.96-1.152l-.96 1.152zm-4.512 4.374a.75.75 0 001.5 0h-1.5zm-3.013-4.374l4.243-3.536-.96-1.152-4.243 3.536.96 1.152zm3.283-3.536l4.242 3.536.96-1.152L12.48 7.18l-.96 1.152zm-.27-.576v8.486h1.5V7.757h-1.5zm7.008-2.015a8.85 8.85 0 010 12.516l1.06 1.06c4.042-4.041 4.042-10.595 0-14.637l-1.06 1.061zm0 12.516a8.85 8.85 0 01-12.516 0l-1.06 1.06c4.041 4.042 10.595 4.042 14.636 0l-1.06-1.06zm-12.516 0a8.85 8.85 0 010-12.516l-1.06-1.06c-4.043 4.041-4.043 10.595 0 14.637l1.06-1.061zm0-12.516a8.85 8.85 0 0112.516 0l1.06-1.06C15.277.64 8.723.64 4.681 4.681l1.061 1.06z"
  }));
};

ArrowUpContained02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpContained02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowDownContained02 = function ArrowDownContained02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.723 13.283a.75.75 0 10-.96-1.152l.96 1.152zM12 16.243l-.48.576a.75.75 0 00.96 0l-.48-.576zM8.237 12.13a.75.75 0 10-.96 1.152l.96-1.152zm4.513-4.374a.75.75 0 00-1.5 0h1.5zm3.012 4.374l-4.242 3.536.96 1.152 4.243-3.536-.96-1.152zm-3.282 3.536L8.237 12.13l-.96 1.152 4.243 3.536.96-1.152zm.27.576V7.757h-1.5v8.486h1.5zm5.508 2.015a8.85 8.85 0 01-12.516 0l-1.06 1.06c4.041 4.042 10.595 4.042 14.636 0l-1.06-1.06zm-12.516 0a8.85 8.85 0 010-12.516l-1.06-1.06c-4.043 4.041-4.043 10.595 0 14.637l1.06-1.061zm0-12.516a8.85 8.85 0 0112.516 0l1.06-1.06C15.277.64 8.723.64 4.681 4.681l1.061 1.06zm12.516 0a8.85 8.85 0 010 12.516l1.06 1.06c4.042-4.041 4.042-10.595 0-14.637l-1.06 1.061z"
  }));
};

ArrowDownContained02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownContained02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowLeftContained02 = function ArrowLeftContained02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M10.717 16.723a.75.75 0 101.152-.96l-1.152.96zM7.757 12l-.576-.48a.75.75 0 000 .96l.576-.48zm4.112-3.762a.75.75 0 10-1.152-.96l1.152.96zm4.373 4.512a.75.75 0 100-1.5v1.5zm-4.373 3.013L8.333 11.52l-1.152.96 3.536 4.243 1.152-.96zM8.333 12.48l3.536-4.242-1.152-.96L7.18 11.52l1.152.96zm-.576.27h8.485v-1.5H7.758v1.5zM5.742 5.742a8.85 8.85 0 0112.516 0l1.06-1.06C15.277.64 8.723.64 4.681 4.681l1.061 1.06zm12.516 0a8.85 8.85 0 010 12.516l1.06 1.06c4.042-4.041 4.042-10.595 0-14.637l-1.06 1.061zm0 12.516a8.85 8.85 0 01-12.516 0l-1.06 1.06c4.041 4.042 10.595 4.042 14.636 0l-1.06-1.06zm-12.516 0a8.85 8.85 0 010-12.516l-1.06-1.06c-4.043 4.041-4.043 10.595 0 14.637l1.06-1.061z"
  }));
};

ArrowLeftContained02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowLeftContained02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowRightContained02 = function ArrowRightContained02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.283 7.277a.75.75 0 10-1.152.96l1.152-.96zM16.243 12l.576.48a.75.75 0 000-.96l-.576.48zm-4.112 3.763a.75.75 0 101.152.96l-1.152-.96zM7.757 11.25a.75.75 0 100 1.5v-1.5zm4.374-3.012l3.535 4.242 1.153-.96-3.536-4.243-1.152.96zm3.535 3.282l-3.535 4.243 1.152.96 3.536-4.243-1.153-.96zm.577-.27H7.757v1.5h8.486v-1.5zm2.015-5.508a8.85 8.85 0 010 12.516l1.06 1.06c4.042-4.041 4.042-10.595 0-14.637l-1.06 1.061zm0 12.516a8.85 8.85 0 01-12.516 0l-1.06 1.06c4.041 4.042 10.595 4.042 14.636 0l-1.06-1.06zm-12.516 0a8.85 8.85 0 010-12.516l-1.06-1.06c-4.043 4.041-4.043 10.595 0 14.637l1.06-1.061zm0-12.516a8.85 8.85 0 0112.516 0l1.06-1.06C15.277.64 8.723.64 4.681 4.681l1.061 1.06z"
  }));
};

ArrowRightContained02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowRightContained02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowUpLeftContained02 = function ArrowUpLeftContained02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.753 14.432a.75.75 0 101.494.136l-1.494-.136zM9 9l-.068-.747a.75.75 0 00-.68.68L9 9zm5.568.247a.75.75 0 00-.136-1.494l.136 1.494zm-.098 6.283a.75.75 0 101.06-1.06l-1.06 1.06zm-5.223-.962l.5-5.5-1.494-.136-.5 5.5 1.494.136zm-.18-4.821l5.5-.5-.135-1.494-5.5.5.136 1.494zM8.47 9.53l6 6 1.06-1.06-6-6-1.06 1.06zM12 3.15A8.85 8.85 0 0120.85 12h1.5c0-5.716-4.634-10.35-10.35-10.35v1.5zM20.85 12A8.85 8.85 0 0112 20.85v1.5c5.716 0 10.35-4.634 10.35-10.35h-1.5zM12 20.85A8.85 8.85 0 013.15 12h-1.5c0 5.716 4.634 10.35 10.35 10.35v-1.5zM3.15 12A8.85 8.85 0 0112 3.15v-1.5C6.284 1.65 1.65 6.284 1.65 12h1.5z"
  }));
};

ArrowUpLeftContained02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpLeftContained02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowUpRightContained02 = function ArrowUpRightContained02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9.568 7.753a.75.75 0 00-.136 1.494l.136-1.494zM15 9l.747-.068a.75.75 0 00-.68-.679L15 9zm-.247 5.568a.75.75 0 001.494-.136l-1.494.136zM8.47 14.47a.75.75 0 101.06 1.06l-1.06-1.06zm.962-5.223l5.5.5.136-1.494-5.5-.5-.136 1.494zm4.821-.18l.5 5.5 1.494-.135-.5-5.5-1.494.136zm.217-.597l-6 6 1.06 1.06 6-6-1.06-1.06zM20.85 12A8.85 8.85 0 0112 20.85v1.5c5.716 0 10.35-4.634 10.35-10.35h-1.5zM12 20.85A8.85 8.85 0 013.15 12h-1.5c0 5.716 4.634 10.35 10.35 10.35v-1.5zM3.15 12A8.85 8.85 0 0112 3.15v-1.5C6.284 1.65 1.65 6.284 1.65 12h1.5zM12 3.15A8.85 8.85 0 0120.85 12h1.5c0-5.716-4.634-10.35-10.35-10.35v1.5z"
  }));
};

ArrowUpRightContained02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpRightContained02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowDownLeftContained02 = function ArrowDownLeftContained02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M14.432 16.247a.75.75 0 10.136-1.494l-.136 1.494zM9 15l-.747.068a.75.75 0 00.679.679L9 15zm.247-5.568a.75.75 0 00-1.494.136l1.494-.136zm6.283.098a.75.75 0 00-1.06-1.06l1.06 1.06zm-.962 5.223l-5.5-.5-.136 1.494 5.5.5.136-1.494zm-4.821.18l-.5-5.5-1.494.135.5 5.5 1.494-.136zm-.217.597l6-6-1.06-1.06-6 6 1.06 1.06zM12 20.85A8.85 8.85 0 013.15 12h-1.5c0 5.716 4.634 10.35 10.35 10.35v-1.5zM3.15 12A8.85 8.85 0 0112 3.15v-1.5C6.284 1.65 1.65 6.284 1.65 12h1.5zM12 3.15A8.85 8.85 0 0120.85 12h1.5c0-5.716-4.634-10.35-10.35-10.35v1.5zM20.85 12A8.85 8.85 0 0112 20.85v1.5c5.716 0 10.35-4.634 10.35-10.35h-1.5z"
  }));
};

ArrowDownLeftContained02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownLeftContained02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowDownRightContained02 = function ArrowDownRightContained02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.247 9.568a.75.75 0 10-1.494-.136l1.494.136zM15 15l.068.747a.75.75 0 00.679-.679L15 15zm-5.568-.247a.75.75 0 10.136 1.494l-.136-1.494zM9.53 8.47a.75.75 0 10-1.06 1.06l1.06-1.06zm5.223.962l-.5 5.5 1.494.136.5-5.5-1.494-.136zm.179 4.821l-5.5.5.136 1.494 5.5-.5-.136-1.494zm.598.217l-6-6-1.06 1.06 6 6 1.06-1.06zM20.85 12A8.85 8.85 0 0112 20.85v1.5c5.716 0 10.35-4.634 10.35-10.35h-1.5zM12 20.85A8.85 8.85 0 013.15 12h-1.5c0 5.716 4.634 10.35 10.35 10.35v-1.5zM3.15 12A8.85 8.85 0 0112 3.15v-1.5C6.284 1.65 1.65 6.284 1.65 12h1.5zM12 3.15A8.85 8.85 0 0120.85 12h1.5c0-5.716-4.634-10.35-10.35-10.35v1.5z"
  }));
};

ArrowDownRightContained02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownRightContained02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ChevronUp = function ChevronUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.47 7.47a.75.75 0 011.06 0l7 7a.75.75 0 01-1.06 1.06L12 9.06l-6.47 6.47a.75.75 0 11-1.06-1.06l7-7z"
  }));
};

ChevronUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronUp.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ChevronDown = function ChevronDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.53 15.53a.75.75 0 01-1.06 0l-7-7a.75.75 0 011.06-1.06L12 13.94l6.47-6.47a.75.75 0 111.06 1.06l-7 7z"
  }));
};

ChevronDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronDown.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ChevronLeft = function ChevronLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47 12.53a.75.75 0 010-1.06l7-7a.75.75 0 111.06 1.06L9.06 12l6.47 6.47a.75.75 0 01-1.06 1.06l-7-7z"
  }));
};

ChevronLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronLeft.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ChevronRight = function ChevronRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 12a.75.75 0 01-.22.53l-7 7a.75.75 0 01-1.06-1.06L13.94 12 7.47 5.53a.75.75 0 011.06-1.06l7 7c.141.14.22.331.22.53z"
  }));
};

ChevronRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronRight.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowUp = function ArrowUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.477 4.262a.75.75 0 011.046 0l6.171 6a.75.75 0 11-1.045 1.076L12.75 6.575V19.2a.75.75 0 11-1.5 0V6.575l-4.899 4.763a.75.75 0 01-1.045-1.076l6.171-6z"
  }));
};

ArrowUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUp.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowDown = function ArrowDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.05a.75.75 0 01.75.75v12.625l4.899-4.763a.75.75 0 011.045 1.076l-6.171 6a.75.75 0 01-1.046 0l-6.171-6a.75.75 0 011.045-1.076l4.899 4.763V4.8a.75.75 0 01.75-.75z"
  }));
};

ArrowDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDown.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowRight = function ArrowRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.644 5.462a.75.75 0 011.06.015l5.834 6a.75.75 0 010 1.046l-5.834 6a.75.75 0 11-1.075-1.046l4.596-4.727H5a.75.75 0 010-1.5h12.225l-4.596-4.727a.75.75 0 01.015-1.06z"
  }));
};

ArrowRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowRight.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowLeft = function ArrowLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.356 5.462a.75.75 0 01.015 1.06L6.775 11.25H19a.75.75 0 010 1.5H6.775l4.596 4.727a.75.75 0 01-1.075 1.046l-5.834-6a.75.75 0 010-1.046l5.834-6a.75.75 0 011.06-.015z"
  }));
};

ArrowLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowLeft.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowUpLeft = function ArrowUpLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 8.861v6.711a.75.75 0 11-1.5 0V7.05a.75.75 0 01.75-.75h8.401a.75.75 0 010 1.5h-6.59l8.62 8.62a.75.75 0 11-1.062 1.06L7.8 8.861z"
  }));
};

ArrowUpLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpLeft.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowUpRight = function ArrowUpRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.708 7.08a.75.75 0 01.75-.75h8.522a.75.75 0 01.75.75v8.401a.75.75 0 11-1.5 0v-6.59l-8.62 8.62a.75.75 0 11-1.06-1.061l8.62-8.62H8.457a.75.75 0 01-.75-.75z"
  }));
};

ArrowUpRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpRight.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowDownLeft = function ArrowDownLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.48 6.52a.75.75 0 010 1.06L8.861 16.2h6.711a.75.75 0 110 1.5H7.05a.75.75 0 01-.75-.75V8.549a.75.75 0 111.5 0v6.59l8.62-8.619a.75.75 0 011.06 0z"
  }));
};

ArrowDownLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownLeft.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowDownRight = function ArrowDownRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52 6.52a.75.75 0 011.06 0l8.62 8.62V8.427a.75.75 0 111.5 0v8.522a.75.75 0 01-.75.75H8.549a.75.75 0 010-1.5h6.59L6.52 7.58a.75.75 0 010-1.06z"
  }));
};

ArrowDownRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownRight.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ChevronDoubleUp = function ChevronDoubleUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.33 18.53a.75.75 0 01-1.06 0L12 14.26l-4.27 4.27a.75.75 0 01-1.06-1.06l4.8-4.8a.75.75 0 011.06 0l4.8 4.8a.75.75 0 010 1.06zm0-7.2a.75.75 0 01-1.06 0L12 7.06l-4.27 4.27a.75.75 0 01-1.06-1.06l4.8-4.8a.75.75 0 011.06 0l4.8 4.8a.75.75 0 010 1.06z"
  }));
};

ChevronDoubleUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronDoubleUp.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ChevronDoubleDown = function ChevronDoubleDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67 5.47a.75.75 0 011.06 0L12 9.74l4.27-4.27a.75.75 0 011.06 1.06l-4.8 4.8a.75.75 0 01-1.06 0l-4.8-4.8a.75.75 0 010-1.06zm0 7.2a.75.75 0 011.06 0L12 16.94l4.27-4.27a.75.75 0 011.06 1.06l-4.8 4.8a.75.75 0 01-1.06 0l-4.8-4.8a.75.75 0 010-1.06z"
  }));
};

ChevronDoubleDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronDoubleDown.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ChevronDoubleLeft = function ChevronDoubleLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.53 6.67a.75.75 0 010 1.06L14.26 12l4.27 4.27a.75.75 0 01-1.06 1.06l-4.8-4.8a.75.75 0 010-1.06l4.8-4.8a.75.75 0 011.06 0zm-7.2 0a.75.75 0 010 1.06L7.06 12l4.27 4.27a.75.75 0 01-1.06 1.06l-4.8-4.8a.75.75 0 010-1.06l4.8-4.8a.75.75 0 011.06 0z"
  }));
};

ChevronDoubleLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronDoubleLeft.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ChevronDoubleRight = function ChevronDoubleRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47 17.33a.75.75 0 010-1.06L9.74 12 5.47 7.73a.75.75 0 011.06-1.06l4.8 4.8a.75.75 0 010 1.06l-4.8 4.8a.75.75 0 01-1.06 0zm7.2 0a.75.75 0 010-1.06L16.94 12l-4.27-4.27a.75.75 0 011.06-1.06l4.8 4.8a.75.75 0 010 1.06l-4.8 4.8a.75.75 0 01-1.06 0z"
  }));
};

ChevronDoubleRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronDoubleRight.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowUpSm = function ArrowUpSm(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.483 6.457a.75.75 0 011.034 0l4.375 4.167a.75.75 0 11-1.034 1.086L12.75 8.75V17a.75.75 0 01-1.5 0V8.75l-3.108 2.96a.75.75 0 01-1.034-1.086l4.375-4.167z"
  }));
};

ArrowUpSm.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpSm.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var DownArrowSm = function DownArrowSm(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.25a.75.75 0 01.75.75v8.25l3.108-2.96a.75.75 0 111.034 1.086l-4.375 4.167a.75.75 0 01-1.034 0l-4.375-4.167a.75.75 0 111.034-1.086l3.108 2.96V7a.75.75 0 01.75-.75z"
  }));
};

DownArrowSm.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
DownArrowSm.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowRightSm = function ArrowRightSm(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.316 7.082a.75.75 0 011.06.026l4.167 4.375a.75.75 0 010 1.034l-4.167 4.375a.75.75 0 11-1.086-1.034l2.96-3.108H7a.75.75 0 010-1.5h8.25l-2.96-3.108a.75.75 0 01.026-1.06z"
  }));
};

ArrowRightSm.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowRightSm.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowLeftSm = function ArrowLeftSm(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.684 7.082c.3.286.311.76.026 1.06L8.75 11.25H17a.75.75 0 010 1.5H8.75l2.96 3.108a.75.75 0 11-1.086 1.034l-4.167-4.375a.75.75 0 010-1.034l4.167-4.375a.75.75 0 011.06-.026z"
  }));
};

ArrowLeftSm.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowLeftSm.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowUpLeftSm = function ArrowUpLeftSm(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.526 7.99a.75.75 0 01-.739.76l-4.907.069 6.65 6.65a.75.75 0 11-1.06 1.061L8.819 9.88l-.07 4.907a.75.75 0 01-1.499-.021l.094-6.682a.75.75 0 01.74-.74l6.682-.094a.75.75 0 01.76.74z"
  }));
};

ArrowUpLeftSm.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpLeftSm.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowUpRightSm = function ArrowUpRightSm(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.474 7.99a.75.75 0 01.76-.74l6.682.094a.75.75 0 01.74.74l.094 6.682a.75.75 0 11-1.5.021l-.069-4.907-6.65 6.65a.75.75 0 01-1.061-1.06l6.65-6.65-4.907-.07a.75.75 0 01-.74-.76z"
  }));
};

ArrowUpRightSm.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpRightSm.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowDownLeftSm = function ArrowDownLeftSm(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.53 7.47a.75.75 0 010 1.06l-6.65 6.651 4.907.07a.75.75 0 11-.021 1.499l-6.682-.094a.75.75 0 01-.74-.74L7.25 9.234a.75.75 0 111.5-.021l.07 4.907 6.65-6.65a.75.75 0 011.06 0z"
  }));
};

ArrowDownLeftSm.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownLeftSm.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowDownRightSm = function ArrowDownRightSm(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47 7.47a.75.75 0 011.06 0l6.651 6.65.07-4.907a.75.75 0 111.499.021l-.094 6.682a.75.75 0 01-.74.74l-6.682.094a.75.75 0 11-.021-1.5l4.907-.069-6.65-6.65a.75.75 0 010-1.061z"
  }));
};

ArrowDownRightSm.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownRightSm.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowUp2 = function ArrowUp2(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.487 12.746l-3.473-3.5A.963.963 0 0012.385 9a.866.866 0 00-.629.246l-3.472 3.5a.847.847 0 00-.22.957.896.896 0 00.821.547h6.973a.858.858 0 00.793-.547c.137-.328.082-.71-.164-.957z"
  }));
};

ArrowUp2.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUp2.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowDown2 = function ArrowDown2(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.487 10.504l-3.473 3.5a.963.963 0 01-.629.246.866.866 0 01-.629-.246l-3.472-3.5a.847.847 0 01-.22-.957A.896.896 0 018.886 9h6.973c.355 0 .656.219.793.547.137.328.082.71-.164.957z"
  }));
};

ArrowDown2.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDown2.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowLeft2 = function ArrowLeft2(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.483 7.5l-3.5 3.473a.963.963 0 00-.246.629c0 .246.082.465.246.629l3.5 3.472a.847.847 0 00.957.22.896.896 0 00.547-.821V8.129a.858.858 0 00-.547-.793c-.328-.137-.71-.082-.957.164z"
  }));
};

ArrowLeft2.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowLeft2.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowRight2 = function ArrowRight2(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.241 7.5l3.5 3.473c.164.191.246.41.246.629a.867.867 0 01-.246.629l-3.5 3.472a.847.847 0 01-.957.22.895.895 0 01-.547-.821V8.129c0-.355.219-.656.547-.793.328-.137.71-.082.957.164z"
  }));
};

ArrowRight2.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowRight2.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowRefresh = function ArrowRefresh(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.05 3.15a8.901 8.901 0 00-7.708 4.427.756.756 0 01-.048.073h2.33a.75.75 0 110 1.5H1.8a.75.75 0 01-.75-.75V3.6a.75.75 0 011.5 0v4.05h.543a.75.75 0 01-.048-.827A10.401 10.401 0 0112.05 1.65a10.4 10.4 0 019.64 6.467.75.75 0 01-1.39.566 8.9 8.9 0 00-8.25-5.533zM2.723 14.905a.75.75 0 01.977.412 8.9 8.9 0 008.25 5.533 8.901 8.901 0 007.708-4.427.77.77 0 01.048-.073h-2.33a.75.75 0 010-1.5H22.2a.75.75 0 01.75.75v4.8a.75.75 0 01-1.5 0v-4.05h-.543a.75.75 0 01.048.827 10.401 10.401 0 01-9.004 5.173 10.4 10.4 0 01-9.64-6.467.75.75 0 01.412-.978z"
  }));
};

ArrowRefresh.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowRefresh.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowRotateLeft = function ArrowRotateLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3 3.15a8.846 8.846 0 00-7.667 4.426.758.758 0 01-.049.074H6.9a.75.75 0 010 1.5H2.1a.75.75 0 01-.75-.75V3.6a.75.75 0 111.5 0v4.05h.534a.75.75 0 01-.049-.826A10.346 10.346 0 0112.3 1.65c5.716 0 10.35 4.634 10.35 10.35 0 5.716-4.634 10.35-10.35 10.35-4.588 0-8.477-2.984-9.834-7.116a.75.75 0 011.425-.468A8.854 8.854 0 0012.3 20.85a8.85 8.85 0 000-17.7z"
  }));
};

ArrowRotateLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowRotateLeft.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArrowRotateRight = function ArrowRotateRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7 3.15a8.846 8.846 0 017.666 4.426c.016.026.032.05.05.074H17.1a.75.75 0 000 1.5h4.8a.75.75 0 00.75-.75V3.6a.75.75 0 00-1.5 0v4.05h-.534a.75.75 0 00.049-.826A10.346 10.346 0 0011.7 1.65C5.984 1.65 1.35 6.284 1.35 12c0 5.716 4.634 10.35 10.35 10.35 4.588 0 8.477-2.984 9.835-7.116a.75.75 0 00-1.425-.468 8.854 8.854 0 01-8.41 6.084 8.85 8.85 0 010-17.7z"
  }));
};

ArrowRotateRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowRotateRight.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FlipLeft = function FlipLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 19.2c0 .414.336.75.75.75h5.6a4.75 4.75 0 004.75-4.75v-1.785a4.75 4.75 0 00-4.75-4.75H4.194l3.294-3.338A.75.75 0 106.42 4.273L1.866 8.89a.75.75 0 000 1.053l4.554 4.616a.75.75 0 001.068-1.054l-3.294-3.339H17.6a3.25 3.25 0 013.25 3.25V15.2a3.25 3.25 0 01-3.25 3.25H12a.75.75 0 00-.75.75z"
  }));
};

FlipLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FlipLeft.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FlipRight = function FlipRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 19.2a.75.75 0 01-.75.75H6.4a4.75 4.75 0 01-4.75-4.75v-1.785a4.75 4.75 0 014.75-4.75h13.406l-3.294-3.338a.75.75 0 011.068-1.054l4.554 4.616a.75.75 0 010 1.053l-4.554 4.616a.75.75 0 01-1.068-1.054l3.294-3.339H6.4a3.25 3.25 0 00-3.25 3.25V15.2a3.25 3.25 0 003.25 3.25H12a.75.75 0 01.75.75z"
  }));
};

FlipRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FlipRight.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Upload01 = function Upload01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.286 4.273A4.964 4.964 0 006.36 9.86a.75.75 0 01-.462.788.75.75 0 01-.409.07 2.464 2.464 0 00-2.739 2.45c0 1.29 1.029 2.235 2.464 2.235a.75.75 0 010 1.5c-2.114 0-3.964-1.475-3.964-3.736a3.965 3.965 0 013.571-3.945 6.464 6.464 0 0111.836-3.58 5.75 5.75 0 016.093 5.74c0 2.647-1.78 4.65-4.145 5.3a.75.75 0 01-.398-1.446c1.788-.492 3.043-1.955 3.043-3.854a4.25 4.25 0 00-4.875-4.205.75.75 0 01-.762-.373 4.963 4.963 0 00-4.327-2.53zm.556 7.25a.75.75 0 01.538.228l3.283 3.383a.75.75 0 11-1.076 1.045l-1.995-2.056v6.354a.75.75 0 01-1.5 0v-6.352l-1.991 2.053a.75.75 0 01-1.077-1.044l3.28-3.383a.75.75 0 01.538-.228z"
  }));
};

Upload01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Upload01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Upload02 = function Upload02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 21.793a.75.75 0 01-.75-.75V10.797l-3.532 3.374a.75.75 0 11-1.036-1.085l4.8-4.585a.75.75 0 011.036 0l4.8 4.585a.75.75 0 11-1.036 1.085l-3.532-3.374v10.246a.75.75 0 01-.75.75zM3.6 9.53a.75.75 0 01-.75-.75V5.074c0-.758.299-1.487.833-2.025A2.841 2.841 0 015.7 2.207h12.6c.758 0 1.483.303 2.017.842.534.538.833 1.267.833 2.025V8.78a.75.75 0 01-1.5 0V5.074c0-.364-.144-.713-.398-.969a1.341 1.341 0 00-.952-.398H5.7c-.356 0-.699.142-.952.398a1.377 1.377 0 00-.398.97V8.78a.75.75 0 01-.75.75z"
  }));
};

Upload02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Upload02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Download01 = function Download01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.286 3.86A4.964 4.964 0 006.36 9.444a.75.75 0 01-.462.788.75.75 0 01-.409.07 2.464 2.464 0 00-2.739 2.45c0 1.29 1.029 2.235 2.464 2.235h2.802a.75.75 0 010 1.5H5.214c-2.114 0-3.964-1.475-3.964-3.736a3.965 3.965 0 013.571-3.945 6.464 6.464 0 0111.836-3.58 5.75 5.75 0 016.093 5.74c0 2.94-2.187 5.07-4.93 5.463a.74.74 0 01-.106.008h-2.589a.75.75 0 010-1.5h2.534c2.078-.32 3.591-1.891 3.591-3.972a4.25 4.25 0 00-4.875-4.204.75.75 0 01-.762-.373 4.963 4.963 0 00-4.327-2.53zm.357 5.285a.75.75 0 01.75.75v9.184l1.186-1.187a.75.75 0 011.061 1.06l-2.467 2.469a.75.75 0 01-1.054.007l-2.533-2.469a.75.75 0 011.047-1.074l1.26 1.228V9.895a.75.75 0 01.75-.75z"
  }));
};

Download01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Download01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Download02 = function Download02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 2.207a.75.75 0 01.75.75v10.246l3.532-3.374a.75.75 0 011.036 1.085l-4.8 4.585a.75.75 0 01-1.036 0l-4.8-4.585A.75.75 0 117.72 9.829l3.532 3.374V2.957a.75.75 0 01.75-.75zM20.4 14.47a.75.75 0 01.75.75v3.706c0 .758-.299 1.487-.833 2.025a2.84 2.84 0 01-2.017.842H5.7a2.841 2.841 0 01-2.017-.842 2.876 2.876 0 01-.833-2.025V15.22a.75.75 0 111.5 0v3.706c0 .365.144.713.398.969.253.256.596.398.952.398h12.6c.356 0 .699-.142.952-.398.254-.256.398-.604.398-.97V15.22a.75.75 0 01.75-.75z"
  }));
};

Download02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Download02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Logout01 = function Logout01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.951 20.317a2.877 2.877 0 01-2.025.833H15.22a.75.75 0 010-1.5h3.706c.364 0 .713-.144.969-.398.256-.253.398-.596.398-.952V5.7c0-.356-.142-.699-.398-.952a1.377 1.377 0 00-.97-.398H15.22a.75.75 0 010-1.5h3.706c.758 0 1.487.299 2.025.833.539.534.842 1.26.842 2.017v12.6c0 .758-.303 1.483-.842 2.017zM8.06 17.342A.75.75 0 017 17.318l-4.586-4.8a.75.75 0 010-1.036L7 6.682a.75.75 0 111.085 1.036L4.71 11.25h10.247a.75.75 0 010 1.5H4.71l3.374 3.532a.75.75 0 01-.024 1.06z"
  }));
};

Logout01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Logout01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Logout02 = function Logout02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.049 3.683a2.877 2.877 0 012.025-.833H8.78a.75.75 0 110 1.5H5.074c-.364 0-.713.144-.969.398a1.341 1.341 0 00-.398.952v12.6c0 .356.142.699.398.952.256.254.605.398.97.398H8.78a.75.75 0 010 1.5H5.074a2.877 2.877 0 01-2.025-.833 2.84 2.84 0 01-.842-2.017V5.7c0-.758.303-1.484.842-2.017zM15.94 6.658a.75.75 0 011.06.024l4.586 4.8a.75.75 0 010 1.036L17 17.318a.75.75 0 01-1.085-1.036l3.374-3.532H9.043a.75.75 0 010-1.5H19.29l-3.374-3.532a.75.75 0 01.024-1.06z"
  }));
};

Logout02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Logout02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Share = function Share(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 19.3a.668.668 0 01-.24 0 .74.74 0 01-.51-.71c0-.08.1-8.62 8.4-10.79v-3a.75.75 0 01.4-.66.76.76 0 01.77 0l9.6 6.36a.75.75 0 010 1.23l-9.6 7a.73.73 0 01-.78.06.75.75 0 01-.41-.67v-3h-.08c-3.94 0-6.94 3.91-7 3.95a.73.73 0 01-.55.23zm7.56-5.75c.311 0 .622.02.93.06a.75.75 0 01.66.74v2.25l7.57-5.44-7.57-5v2.2a.76.76 0 01-.59.74 9.42 9.42 0 00-7.47 7.24 10 10 0 016.47-2.79z"
  }));
};

Share.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Share.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AddSquareContained = function AddSquareContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 3.75A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.625 2.625h11.25a2.625 2.625 0 002.625-2.625V6.375a2.625 2.625 0 00-2.625-2.625H6.375zM2.25 6.375A4.125 4.125 0 016.375 2.25h11.25a4.125 4.125 0 014.125 4.125v11.25a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zm9.75 1.5a.75.75 0 01.75.75v2.624h2.625a.75.75 0 110 1.5H12.75v2.625a.75.75 0 01-1.5 0V12.75H8.625a.75.75 0 010-1.5h2.625V8.624a.75.75 0 01.75-.75z"
  }));
};

AddSquareContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AddSquareContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AddCircleContained = function AddCircleContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 7.874a.75.75 0 01.75.75v2.625h2.625a.75.75 0 110 1.5H12.75v2.625a.75.75 0 01-1.5 0V12.75H8.625a.75.75 0 010-1.5h2.625V8.624a.75.75 0 01.75-.75z",
    opacity: ".9"
  }));
};

AddCircleContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AddCircleContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AddCircleContainedFill = function AddCircleContainedFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 100 18 9 9 0 000-18zm.652 5.87a.652.652 0 00-1.304 0v2.477H8.87a.652.652 0 000 1.305h2.478v2.478a.652.652 0 001.304 0v-2.478h2.478a.652.652 0 000-1.305h-2.478V8.87z",
    opacity: ".9"
  }));
};

AddCircleContainedFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AddCircleContainedFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Add01 = function Add01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.05a.75.75 0 01.75.75v6.45h6.45a.75.75 0 110 1.5h-6.45v6.45a.75.75 0 11-1.5 0v-6.45H4.8a.75.75 0 110-1.5h6.45V4.8a.75.75 0 01.75-.75z"
  }));
};

Add01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Add01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Add02 = function Add02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.25a.75.75 0 01.75.75v5.25H18a.75.75 0 010 1.5h-5.25V18a.75.75 0 01-1.5 0v-5.25H6a.75.75 0 010-1.5h5.25V6a.75.75 0 01.75-.75z"
  }));
};

Add02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Add02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Add03 = function Add03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.45a.75.75 0 01.75.75v4.05h4.05a.75.75 0 110 1.5h-4.05v4.05a.75.75 0 01-1.5 0v-4.05H7.2a.75.75 0 010-1.5h4.05V7.2a.75.75 0 01.75-.75z"
  }));
};

Add03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Add03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AlertSquareContained = function AlertSquareContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 3.75A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.625 2.625h11.25a2.625 2.625 0 002.625-2.625V6.375a2.625 2.625 0 00-2.625-2.625H6.375zM2.25 6.375A4.125 4.125 0 016.375 2.25h11.25a4.125 4.125 0 014.125 4.125v11.25a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zM12 6.75a.75.75 0 01.75.75V12a.75.75 0 11-1.5 0V7.5a.75.75 0 01.75-.75zm0 7.835a.75.75 0 01.75.75v.04a.75.75 0 11-1.5 0v-.04a.75.75 0 01.75-.75z"
  }));
};

AlertSquareContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlertSquareContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AlertCircleContained = function AlertCircleContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 6.75a.75.75 0 01.75.75V12a.75.75 0 01-1.5 0V7.5a.75.75 0 01.75-.75zm0 7.835a.75.75 0 01.75.75v.04a.75.75 0 01-1.5 0v-.04a.75.75 0 01.75-.75z"
  }));
};

AlertCircleContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlertCircleContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AlertCircleContainedFill = function AlertCircleContainedFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 100 18 9 9 0 000-18zm.652 4.826a.652.652 0 00-1.304 0V12a.652.652 0 001.304 0V7.826zm0 7.268a.652.652 0 00-1.304 0v.037a.652.652 0 001.304 0v-.037z"
  }));
};

AlertCircleContainedFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlertCircleContainedFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var EyeOpen = function EyeOpen(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.802 12.1c.064.152.164.37.302.633.286.543.735 1.269 1.382 1.996 1.285 1.445 3.349 2.896 6.526 2.948 3.162.052 5.214-1.39 6.498-2.859a10.206 10.206 0 001.382-2.045c.142-.28.244-.51.308-.668v-.002a8.88 8.88 0 00-.302-.683 10.317 10.317 0 00-1.364-2.094C17.26 7.816 15.204 6.322 12 6.322c-3.205 0-5.26 1.495-6.534 3.004a10.318 10.318 0 00-1.364 2.094c-.139.284-.237.518-.3.68zM21 12.112l.716-.225v-.001l-.001-.002-.003-.007-.006-.02a4.23 4.23 0 00-.109-.298 10.357 10.357 0 00-.352-.8 11.813 11.813 0 00-1.565-2.401C18.192 6.597 15.747 4.822 12 4.822S5.808 6.597 4.32 8.358a11.815 11.815 0 00-1.565 2.402 10.374 10.374 0 00-.438 1.031l-.023.067-.006.02-.002.006-.001.002c0 .001 0 .002.715.226l-.716-.225-.073.236.08.233.71-.244-.71.244v.001l.001.003.002.006.007.019a4.236 4.236 0 00.113.285c.08.188.199.45.363.762.33.624.843 1.456 1.588 2.294 1.498 1.684 3.935 3.39 7.623 3.451 3.704.06 6.151-1.655 7.651-3.372a11.7 11.7 0 001.588-2.35 10.268 10.268 0 00.451-1.012l.024-.066.006-.019.003-.006v-.003l-.71-.237zm0 0l.712.236.076-.23-.072-.23-.716.224zm-9-1.524c-.848 0-1.5.664-1.5 1.44 0 .775.652 1.439 1.5 1.439s1.5-.664 1.5-1.44c0-.775-.652-1.439-1.5-1.439zm-3 1.44c0-1.643 1.363-2.94 3-2.94s3 1.297 3 2.94c0 1.642-1.363 2.939-3 2.939s-3-1.297-3-2.94z"
  }));
};

EyeOpen.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
EyeOpen.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var EyeClosed = function EyeClosed(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.282 4.438a.75.75 0 011.06 0l14.063 14.063a.75.75 0 01-1.06 1.06l-1.9-1.9c-1.407.892-3.206 1.513-5.457 1.476-3.688-.06-6.125-1.767-7.623-3.452a11.658 11.658 0 01-1.588-2.293 9.982 9.982 0 01-.452-.984 4.236 4.236 0 01-.024-.064l-.007-.019-.002-.006v-.002c-.001-.001-.001-.002.708-.246l-.716-.224.001-.002.001-.004.004-.01.011-.035a8.651 8.651 0 01.21-.543c.15-.353.38-.84.71-1.39.62-1.042 1.605-2.332 3.071-3.354l-1.01-1.01a.75.75 0 010-1.06zm2.09 3.151a.76.76 0 01-.024.017c-1.35.882-2.262 2.057-2.84 3.025a10.083 10.083 0 00-.706 1.428c.064.153.164.37.302.634.286.543.735 1.268 1.382 1.996 1.285 1.445 3.349 2.896 6.526 2.948 1.788.03 3.212-.418 4.34-1.068l-2.373-2.373c-.53.456-1.223.73-1.979.73-1.637 0-3-1.296-3-2.939a2.898 2.898 0 01.787-1.983L7.372 7.589zm3.476 3.476c-.22.252-.348.573-.348.922 0 .776.652 1.44 1.5 1.44.346 0 .661-.112.913-.297l-2.065-2.065zM3 12.071l-.716-.224-.073.235.08.233.71-.244zm9-5.79c-.364 0-.712.02-1.044.055a.75.75 0 01-.162-1.49A11.21 11.21 0 0112 4.78c3.747 0 6.192 1.775 7.68 3.536.74.876 1.244 1.748 1.565 2.402a10.375 10.375 0 01.439 1.032l.022.066.006.02.003.006v.003l-.715.225.712.237v.001l-.001.002-.002.004-.004.012a7.363 7.363 0 01-.067.182c-.047.12-.116.288-.21.493-.189.41-.48.973-.893 1.591a.75.75 0 01-1.247-.833 10.156 10.156 0 00.912-1.696v-.002a8.882 8.882 0 00-.302-.682 10.314 10.314 0 00-1.364-2.095C17.26 7.776 15.204 6.281 12 6.281zm9 5.79l.712.237.076-.23-.072-.23-.716.223zm-.711-.237z"
  }));
};

EyeClosed.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
EyeClosed.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Rocket = function Rocket(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.754 2.456l.07.385c.375 2.084.148 4.371-.654 6.62-.749 2.098-1.983 4.097-3.583 5.82-.199 1.5-.808 2.96-1.766 4.23a9.153 9.153 0 01-2.538 2.305.68.68 0 01-.336.091.644.644 0 01-.3-.072.656.656 0 01-.344-.539 19.65 19.65 0 00-.234-2.147c-.91.35-1.85.593-2.818.722l-.29.038-.48-.48a1.128 1.128 0 01-.105.122l-.048.048a1.278 1.278 0 01-1.102.35l-.04.04a1.369 1.369 0 01-.022.022c-.875.881-1.675 1.153-2.5 1.153-.487 0-.98-.094-1.505-.215l-.383-.087-.07-.385v-.003c-.224-1.246-.435-2.425.975-3.832.04-.04.084-.081.127-.121a1.261 1.261 0 01.353-1.09l.048-.05c.038-.037.078-.072.119-.105l-.458-.458.046-.299c.142-.924.393-1.823.743-2.696a20.425 20.425 0 00-2.05-.22.645.645 0 01-.514-.98 9.189 9.189 0 012.306-2.538c1.274-.962 2.736-1.573 4.244-1.77 1.751-1.578 3.766-2.777 5.877-3.485 2.349-.79 4.72-.948 6.85-.46l.382.086zM5.112 9.03a7.985 7.985 0 00-1.49 1.463c.51.05 1.029.124 1.549.215A14.543 14.543 0 017.054 7.94 8.157 8.157 0 005.112 9.03zm-.641 8.498c-.784.805-.822 1.366-.666 2.351.93.191 1.581.18 2.416-.6l-1.75-1.751zm3.016 1.23l.049-.048a.083.083 0 000-.113l-2.379-2.38a.076.076 0 00-.056-.022.076.076 0 00-.057.021l-.048.049a.076.076 0 00-.022.056c0 .016.003.038.022.057l2.378 2.38c.03.03.084.03.113 0zm5.928 1.525a7.967 7.967 0 001.46-1.49c.469-.619.84-1.287 1.107-1.984a14.35 14.35 0 01-2.793 1.845c.097.541.172 1.085.226 1.63zm2.872-5.36c1.704-1.704 3.005-3.73 3.765-5.86.681-1.91.91-3.844.665-5.619-1.818-.337-3.819-.162-5.817.51-2.223.745-4.332 2.076-6.104 3.848-1.07 1.07-1.926 2.214-2.548 3.4a11.36 11.36 0 00-1.11 3.21l4.243 4.242c2.507-.401 4.829-1.654 6.906-3.73zm-4.67-5.317A2.688 2.688 0 0114.3 6.921a2.688 2.688 0 012.686 2.685 2.688 2.688 0 01-2.685 2.686 2.687 2.687 0 01-2.686-2.686zm1.184-.002c0 .827.674 1.5 1.5 1.5.827 0 1.5-.673 1.5-1.5s-.673-1.5-1.5-1.5c-.826 0-1.5.673-1.5 1.5z"
  }));
};

Rocket.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Rocket.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var MinusSquareContained = function MinusSquareContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 3.75A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.625 2.625h11.25a2.625 2.625 0 002.625-2.625V6.375a2.625 2.625 0 00-2.625-2.625H6.375zM2.25 6.375A4.125 4.125 0 016.375 2.25h11.25a4.125 4.125 0 014.125 4.125v11.25a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zM7.875 12a.75.75 0 01.75-.75h6.75a.75.75 0 010 1.5h-6.75a.75.75 0 01-.75-.75z"
  }));
};

MinusSquareContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MinusSquareContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var MinusCircleContained = function MinusCircleContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm5.625 0a.75.75 0 01.75-.75h6.75a.75.75 0 010 1.5h-6.75a.75.75 0 01-.75-.75z"
  }));
};

MinusCircleContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MinusCircleContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var MinusCircleContainedFill = function MinusCircleContainedFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-3.391 9.044a.707.707 0 100 1.413h6.782a.706.706 0 100-1.413H8.61z"
  }));
};

MinusCircleContainedFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MinusCircleContainedFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Minus01 = function Minus01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05 12a.75.75 0 01.75-.75h14.4a.75.75 0 110 1.5H4.8a.75.75 0 01-.75-.75z"
  }));
};

Minus01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Minus01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Minus02 = function Minus02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 12a.75.75 0 01.75-.75h12a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75z"
  }));
};

Minus02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Minus02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Minus03 = function Minus03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 12a.75.75 0 01.75-.75h9.6a.75.75 0 010 1.5H7a.75.75 0 01-.75-.75z"
  }));
};

Minus03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Minus03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var InformationSquareContained = function InformationSquareContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 2.25h11.25a4.125 4.125 0 014.125 4.125v11.25a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375A4.125 4.125 0 016.375 2.25zm11.25 1.5H6.375A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.625 2.625h11.25a2.625 2.625 0 002.625-2.625V6.375a2.625 2.625 0 00-2.625-2.625zM12 7.875a.75.75 0 01.75.75v.04a.75.75 0 11-1.5 0v-.04a.75.75 0 01.75-.75zm0 3.375a.75.75 0 01.75.75v4.5a.75.75 0 11-1.5 0V12a.75.75 0 01.75-.75z"
  }));
};

InformationSquareContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
InformationSquareContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var InformationCircleContained = function InformationCircleContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 7.875a.75.75 0 01.75.75v.04a.75.75 0 01-1.5 0v-.04a.75.75 0 01.75-.75zm0 3.375a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0V12a.75.75 0 01.75-.75z"
  }));
};

InformationCircleContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
InformationCircleContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var InformationCircleContainedFill = function InformationCircleContainedFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm.707 6.359a.707.707 0 10-1.413 0v.04a.707.707 0 101.413 0v-.04zm0 3.391a.706.706 0 10-1.413 0v4.522a.707.707 0 101.413 0V12z"
  }));
};

InformationCircleContainedFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
InformationCircleContainedFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Target01 = function Target01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.784 11.25h2.591a.75.75 0 010 1.5H3.784a8.252 8.252 0 007.466 7.466v-2.591a.75.75 0 011.5 0v2.591a8.252 8.252 0 007.466-7.466h-2.591a.75.75 0 010-1.5h2.591a8.252 8.252 0 00-7.466-7.466v2.591a.75.75 0 01-1.5 0V3.784a8.252 8.252 0 00-7.466 7.466zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12z"
  }));
};

Target01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Target01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Target02 = function Target02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.158 2.289a.75.75 0 01.505.605l.295 2.064 2.064.294a.75.75 0 01.424 1.273l-3.37 3.37a.75.75 0 01-.767.18l-1.808-.602-3.416 3.416a.75.75 0 01-1.06-1.06l3.417-3.418-.602-1.805a.75.75 0 01.181-.767l3.37-3.37a.75.75 0 01.767-.18zm-2.265 5.733l1.45.484 1.982-1.98-1.136-.163a.75.75 0 01-.636-.636L17.39 4.59l-1.98 1.98.483 1.451zM11.555 4.81a7.72 7.72 0 107.72 7.72.75.75 0 011.5 0 9.22 9.22 0 11-9.22-9.22.75.75 0 010 1.5zm0 4.235a3.485 3.485 0 103.485 3.485.75.75 0 111.5 0 4.985 4.985 0 11-4.985-4.985.75.75 0 010 1.5z"
  }));
};

Target02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Target02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Package02 = function Package02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.625 1.75a.75.75 0 01.75 0l8.314 4.8a.75.75 0 01.375.65v9.6a.75.75 0 01-.375.65l-8.314 4.8a.75.75 0 01-.75 0l-8.314-4.8a.75.75 0 01-.375-.65V7.2a.75.75 0 01.375-.65l8.314-4.8zM4.436 8.826v7.54l6.814 3.935v-7.282L4.436 8.826zm8.314 4.193v7.282l6.814-3.934V8.826l-6.814 4.193zm6.337-5.661L12 3.266 4.913 7.358 12 11.719l7.087-4.361z"
  }));
};

Package02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Package02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var XSquareContained = function XSquareContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 3.75A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.625 2.625h11.25a2.625 2.625 0 002.625-2.625V6.375a2.625 2.625 0 00-2.625-2.625H6.375zM2.25 6.375A4.125 4.125 0 016.375 2.25h11.25a4.125 4.125 0 014.125 4.125v11.25a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zm6.038 1.913a.75.75 0 011.06 0L12 10.939l2.652-2.651a.75.75 0 111.06 1.06L13.061 12l2.651 2.652a.75.75 0 11-1.06 1.06L12 13.061l-2.652 2.651a.75.75 0 01-1.06-1.06L10.939 12 8.288 9.348a.75.75 0 010-1.06z"
  }));
};

XSquareContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
XSquareContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var XCircleContained = function XCircleContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm6.038-3.712a.75.75 0 011.06 0L12 10.939l2.652-2.651a.75.75 0 111.06 1.06L13.061 12l2.651 2.652a.75.75 0 11-1.06 1.06L12 13.061l-2.652 2.651a.75.75 0 01-1.06-1.06L10.939 12 8.288 9.348a.75.75 0 010-1.06z"
  }));
};

XCircleContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
XCircleContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var XCircleContainedFill = function XCircleContainedFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75zM9.462 8.521a.665.665 0 10-.94.94L11.06 12l-2.538 2.538a.665.665 0 10.94.94L12 12.94l2.538 2.538a.665.665 0 00.94-.94L12.94 12 15.48 9.46a.665.665 0 10-.94-.94L12 11.06 9.462 8.52z"
  }));
};

XCircleContainedFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
XCircleContainedFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var X01 = function X01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47 4.47a.75.75 0 011.06 0L12 10.94l6.47-6.47a.75.75 0 111.06 1.06L13.06 12l6.47 6.47a.75.75 0 11-1.06 1.06L12 13.06l-6.47 6.47a.75.75 0 01-1.06-1.06L10.94 12 4.47 5.53a.75.75 0 010-1.06z"
  }));
};

X01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
X01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var X02 = function X02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
  }));
};

X02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
X02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var X03 = function X03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47 6.47a.75.75 0 011.06 0L12 10.94l4.47-4.47a.75.75 0 111.06 1.06L13.06 12l4.47 4.47a.75.75 0 11-1.06 1.06L12 13.06l-4.47 4.47a.75.75 0 01-1.06-1.06L10.94 12 6.47 7.53a.75.75 0 010-1.06z"
  }));
};

X03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
X03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var HelpSquareContained = function HelpSquareContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 3.75A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.625 2.625h11.25a2.625 2.625 0 002.625-2.625V6.375a2.625 2.625 0 00-2.625-2.625H6.375zM2.25 6.375A4.125 4.125 0 016.375 2.25h11.25a4.125 4.125 0 014.125 4.125v11.25a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zM12 7.687c-.814 0-1.5.678-1.5 1.543a.75.75 0 11-1.5 0c0-1.667 1.33-3.043 3-3.043s3 1.376 3 3.043c0 1.408-.948 2.608-2.25 2.947v.874a.75.75 0 11-1.5 0V11.522a.75.75 0 01.75-.75c.816 0 1.5-.677 1.5-1.542s-.684-1.543-1.5-1.543zm0 8.063a.75.75 0 01.75.75v.04a.75.75 0 11-1.5 0v-.04a.75.75 0 01.75-.75z"
  }));
};

HelpSquareContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
HelpSquareContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var HelpCircleContained = function HelpCircleContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 7.687c-.815 0-1.5.678-1.5 1.543a.75.75 0 01-1.5 0c0-1.667 1.33-3.043 3-3.043s3 1.376 3 3.043c0 1.408-.95 2.608-2.25 2.947l-.001.874a.75.75 0 01-1.5 0v-1.082l.001-.447a.75.75 0 01.75-.75c.815 0 1.5-.677 1.5-1.542s-.685-1.543-1.5-1.543zm-.001 8.063a.75.75 0 01.75.75v.04a.75.75 0 01-1.5 0v-.04a.75.75 0 01.75-.75z"
  }));
};

HelpCircleContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
HelpCircleContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var HelpCircleContainedFill = function HelpCircleContainedFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21a9 9 0 100-18 9 9 0 000 18zM10.5 9.23c0-.865.685-1.542 1.5-1.542s1.5.677 1.5 1.542-.685 1.543-1.5 1.543a.75.75 0 00-.75.75v.447l-.001 1.081a.75.75 0 001.5 0v-.874C14.051 11.84 15 10.64 15 9.23c0-1.667-1.33-3.042-3-3.042S9 7.563 9 9.23a.75.75 0 101.5 0zm2.249 7.27a.75.75 0 00-1.5 0v.04a.75.75 0 001.5 0v-.04z"
  }));
};

HelpCircleContainedFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
HelpCircleContainedFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Search = function Search(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.467 4.75a6.717 6.717 0 104.698 11.517l.005-.005A6.717 6.717 0 0011.466 4.75zm6.275 12.022a8.217 8.217 0 10-1.07 1.053l2.806 2.714a.75.75 0 101.043-1.078l-2.78-2.69z"
  }));
};

Search.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Search.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Settings = function Settings(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M14.51 21.52a1.76 1.76 0 01-.86-.2l-1.65-.9-.16-.1a.73.73 0 00-.56.07l-1.58.93a1.78 1.78 0 01-1.59 0l-1.26-.56a1.72 1.72 0 01-1-1.3l-.28-1.75a.71.71 0 00-.46-.55l-1.66-.61a1.71 1.71 0 01-1.09-1.23l-.31-1.28a1.75 1.75 0 01.42-1.61l1.18-1.31a.65.65 0 00.16-.32.7.7 0 000-.38L3.3 8.77a1.76 1.76 0 01.35-1.65l.88-1.07a1.71 1.71 0 011.46-.64l1.85.12a.85.85 0 00.36 0 .73.73 0 00.29-.23l1-1.5a1.76 1.76 0 011.46-.8h1.4a1.76 1.76 0 011.43.74l1 1.48a.72.72 0 00.28.24.83.83 0 00.38.07l1.83-.14a1.76 1.76 0 011.48.64l.86 1a1.75 1.75 0 01.31 1.63l-.53 1.71a.73.73 0 000 .33.7.7 0 00.19.32l.07.05 1.23 1.33a1.76 1.76 0 01.42 1.58l-.33 1.34a1.76 1.76 0 01-1.07 1.24l-1.7.66a.84.84 0 00-.3.22.61.61 0 00-.14.33l-.26 1.7a1.771 1.771 0 01-1 1.32l-1.26.6a1.83 1.83 0 01-.73.13zm-1.76-2.42l1.65.89a.22.22 0 00.22 0l1.26-.59a.3.3 0 00.14-.19l.25-1.71a2.23 2.23 0 01.46-1 2.11 2.11 0 01.92-.67l1.69-.67a.26.26 0 00.16-.18l.29-1.3a.23.23 0 00-.06-.22l-1.22-1.37a2.239 2.239 0 01-.31-.43 1.997 1.997 0 01-.23-.56 2.21 2.21 0 010-1.14l.53-1.7a.261.261 0 000-.24l-.86-1a.24.24 0 00-.21-.09l-1.83.13a2.24 2.24 0 01-1.11-.2 2.189 2.189 0 01-.88-.74l-1-1.47a.23.23 0 00-.2-.11h-1.46a.23.23 0 00-.2.11l-1 1.5c-.22.318-.624.568-.98.72a2.24 2.24 0 01-1.09.18l-1.81-.14a.24.24 0 00-.22.09l-.88 1.07a.26.26 0 000 .24l.54 1.66c.1.373.1.766 0 1.14a2.24 2.24 0 01-.53 1l-1.21 1.34a.29.29 0 00-.07.23l.31 1.28a.24.24 0 00.16.18l1.68.62c.362.136.683.363.93.66.233.292.404.635.48 1l.28 1.76a.24.24 0 00.14.18l1.26.59a.26.26 0 00.23 0l1.58-.88c.13-.08.272-.14.42-.18.219-.076.449-.113.68-.11.388.01.767.12 1.1.32zm-1.16-3.13a3.65 3.65 0 113.71-3.65 3.68 3.68 0 01-3.71 3.65zm0-5.79a2.15 2.15 0 102.21 2.14 2.19 2.19 0 00-2.21-2.14z"
  }));
};

Settings.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Settings.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CheckSquareContained = function CheckSquareContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 3.75A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.625 2.625h11.25a2.625 2.625 0 002.625-2.625V6.375a2.625 2.625 0 00-2.625-2.625H6.375zM2.25 6.375A4.125 4.125 0 016.375 2.25h11.25a4.125 4.125 0 014.125 4.125v11.25a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zM15.934 9.25a.75.75 0 01-.06 1.06l-5.033 4.5a.75.75 0 01-1 0l-1.716-1.535a.75.75 0 111-1.118l1.216 1.087 4.534-4.053a.75.75 0 011.06.06z"
  }));
};

CheckSquareContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CheckSquareContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CheckContained = function CheckContained(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zm3.672 5.703a.75.75 0 010 1.06l-4.267 4.267a.75.75 0 01-1.06 0L8.89 13.326a.75.75 0 111.06-1.06l.925.923 3.737-3.736a.75.75 0 011.06 0z"
  }));
};

CheckContained.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CheckContained.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CheckContainedFill = function CheckContainedFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm5.008 7.664a.812.812 0 10-1.152-1.146l-4.717 4.744-2.113-2.09a.812.812 0 10-1.143 1.156l2.69 2.659a.812.812 0 001.147-.005l5.288-5.318z"
  }));
};

CheckContainedFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CheckContainedFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CheckSquareBroken = function CheckSquareBroken(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 3.75A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.625 2.625h11.25a2.625 2.625 0 002.625-2.625v-6.188a.75.75 0 111.5 0v6.188a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375A4.125 4.125 0 016.375 2.25h7.875a.75.75 0 010 1.5H6.375zm14.03 1.532a.75.75 0 010 1.06l-7.875 7.876a.75.75 0 01-1.06 0l-2.25-2.25a.75.75 0 011.06-1.06L12 12.626l7.345-7.345a.75.75 0 011.06 0z"
  }));
};

CheckSquareBroken.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CheckSquareBroken.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CheckBroken = function CheckBroken(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75 1.528 0 2.977.352 4.266.98a.75.75 0 11-.657 1.349A8.25 8.25 0 1020.25 12a.75.75 0 011.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm17.593-6.155a.75.75 0 010 1.06l-7.875 7.875a.75.75 0 01-1.06 0l-2.25-2.25a.75.75 0 111.06-1.06l1.72 1.72 7.344-7.345a.75.75 0 011.06 0z"
  }));
};

CheckBroken.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CheckBroken.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Check = function Check(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.529 5.468a.75.75 0 01.003 1.06l-11.933 12a.75.75 0 01-1.063 0l-4.068-4.09a.75.75 0 011.064-1.057l3.535 3.555L19.468 5.471a.75.75 0 011.06-.003z"
  }));
};

Check.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Check.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var More01 = function More01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.999 18.5a1.499 1.499 0 10-2.998 0 1.499 1.499 0 002.998 0zm0-6.5A1.5 1.5 0 1011 12a1.5 1.5 0 002.998 0zm0-6.5A1.5 1.5 0 1011 5.5a1.5 1.5 0 002.998 0z"
  }));
};

More01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
More01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var More02 = function More02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.999A1.5 1.5 0 105.5 11a1.5 1.5 0 000 2.998zm6.5 0A1.5 1.5 0 1012 11a1.5 1.5 0 000 2.998zm6.5 0a1.5 1.5 0 100-2.998 1.5 1.5 0 000 2.998z"
  }));
};

More02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
More02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Marker = function Marker(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M4.348 20h4.174m-2.087-7.652V4h13.217l-2.087 4.174 2.087 4.174H6.435zm0 0v6.956"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.685 4a.75.75 0 01.75-.75h13.217a.75.75 0 01.67 1.085l-1.918 3.839 1.919 3.838a.75.75 0 01-.67 1.086H7.184v6.152h1.337a.75.75 0 010 1.5H4.348a.75.75 0 010-1.5h1.337V4zm1.5 7.598h11.254l-1.545-3.089a.75.75 0 010-.67L18.44 4.75H7.185v6.848z"
  }));
};

Marker.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Marker.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Favourite = function Favourite(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 5c0-.966.784-1.75 1.75-1.75h10c.966 0 1.75.784 1.75 1.75v13.933c0 1.06-1.236 1.638-2.05.96L12 15.976l-4.7 3.917c-.814.678-2.05.1-2.05-.96V5zM7 4.75a.25.25 0 00-.25.25v13.399l4.77-3.975a.75.75 0 01.96 0l4.77 3.975V5a.25.25 0 00-.25-.25H7z"
  }));
};

Favourite.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Favourite.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Home = function Home(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.198 4.809a.362.362 0 00-.396 0L4.869 9.498a.25.25 0 00-.119.205v8.775c0 .391.345.772.85.772h12.8c.505 0 .85-.38.85-.772V9.703a.25.25 0 00-.119-.205l-6.933-4.689zm-1.236-1.243a1.862 1.862 0 012.076 0l6.934 4.69c.479.323.778.86.778 1.447v8.775c0 1.29-1.088 2.272-2.35 2.272H5.6c-1.262 0-2.35-.982-2.35-2.272V9.703c0-.587.3-1.124.778-1.448l6.934-4.689z"
  }));
};

Home.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Home.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Component = function Component(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.87 2.718a1.599 1.599 0 012.26 0l2.423 2.422a1.599 1.599 0 010 2.262L13.13 9.824a1.6 1.6 0 01-2.262 0L8.447 7.402a1.599 1.599 0 010-2.262l2.422-2.422zm1.2 1.061a.099.099 0 00-.14 0L9.508 6.201a.1.1 0 000 .14l2.422 2.422a.099.099 0 00.14 0l2.422-2.422a.099.099 0 000-.14L12.07 3.779zM5.14 8.447a1.599 1.599 0 012.262 0l2.422 2.422a1.6 1.6 0 010 2.262l-2.422 2.422a1.599 1.599 0 01-2.262 0L2.718 13.13a1.599 1.599 0 010-2.262L5.14 8.447zm1.201 1.061a.1.1 0 00-.14 0L3.779 11.93a.099.099 0 000 .14l2.422 2.422a.099.099 0 00.14 0l2.422-2.422a.099.099 0 000-.14L6.34 9.508zm10.257-1.06a1.6 1.6 0 012.262 0l2.422 2.421a1.599 1.599 0 010 2.262l-2.422 2.422a1.6 1.6 0 01-2.262 0l-2.421-2.422a1.599 1.599 0 010-2.262l2.421-2.422zm1.201 1.06a.1.1 0 00-.14 0l-2.422 2.422a.099.099 0 000 .14l2.422 2.422a.099.099 0 00.14 0l2.422-2.422a.099.099 0 000-.14l-2.422-2.422zm-6.93 4.669a1.599 1.599 0 012.262 0l2.422 2.421a1.6 1.6 0 010 2.262l-2.422 2.422a1.599 1.599 0 01-2.262 0L8.447 18.86a1.6 1.6 0 010-2.262l2.422-2.421zm1.201 1.06a.099.099 0 00-.14 0L9.508 17.66a.1.1 0 000 .14l2.422 2.422a.099.099 0 00.14 0l2.422-2.422a.099.099 0 000-.14l-2.422-2.422z"
  }));
};

Component.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Component.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Loader01 = function Loader01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25a.75.75 0 01.75.75v4.114a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM5.105 5.106a.75.75 0 011.06 0l2.91 2.909a.75.75 0 11-1.06 1.06l-2.91-2.909a.75.75 0 010-1.06zm13.79 0a.75.75 0 010 1.06l-2.91 2.91a.75.75 0 01-1.06-1.06l2.909-2.91a.75.75 0 011.06 0zM2.25 12a.75.75 0 01.75-.75h4.114a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75zm13.886 0a.75.75 0 01.75-.75H21a.75.75 0 010 1.5h-4.114a.75.75 0 01-.75-.75zm-1.211 2.924a.75.75 0 011.06 0l2.91 2.91a.75.75 0 11-1.061 1.06l-2.91-2.91a.75.75 0 010-1.06zm-5.85 0a.75.75 0 010 1.061l-2.91 2.91a.75.75 0 01-1.06-1.061l2.91-2.91a.75.75 0 011.06 0zM12 16.137a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-4.114a.75.75 0 01.75-.75z"
  }));
};

Loader01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Loader01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Loader02 = function Loader02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.227 2.25a.75.75 0 01.75.75v3.273a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zm-7.28 1.924a.75.75 0 011.06 0l3.086 3.086a.75.75 0 01-1.06 1.06L5.946 5.236a.75.75 0 010-1.06zm11.932 1.568a.75.75 0 011.061 1.061l-1.518 1.518a.75.75 0 01-1.06-1.06l1.517-1.519zM2.932 11.454a.75.75 0 01.75-.75h4.363a.75.75 0 010 1.5H3.682a.75.75 0 01-.75-.75zm14.727 0a.75.75 0 01.75-.75h1.91a.75.75 0 010 1.5h-1.91a.75.75 0 01-.75-.75zm-1.298 3.134a.75.75 0 011.061 0l1.517 1.518a.75.75 0 01-1.06 1.06L16.36 15.65a.75.75 0 010-1.06zm-6.268 0a.75.75 0 010 1.061l-3.086 3.086a.75.75 0 11-1.06-1.061l3.085-3.085a.75.75 0 011.06 0zm3.134 1.298a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-4.364a.75.75 0 01.75-.75z"
  }));
};

Loader02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Loader02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Loader03 = function Loader03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.442 8.936c-.404-.2-.897-.019-1.032.412A9.05 9.05 0 1017.29 4.67c-.38-.27-.9-.098-1.087.33-.158.36-.021.778.295 1.012A7.5 7.5 0 114.852 9.938c.114-.39-.045-.821-.41-1.002z"
  }));
};

Loader03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Loader03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Square = function Square(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 6.375A4.125 4.125 0 016.375 2.25h11.25a4.125 4.125 0 014.125 4.125v11.25a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zM6.375 3.75A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.625 2.625h11.25a2.625 2.625 0 002.625-2.625V6.375a2.625 2.625 0 00-2.625-2.625H6.375z"
  }));
};

Square.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Square.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Circle = function Circle(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12z"
  }));
};

Circle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Circle.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var MoonLine = function MoonLine(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.054 2.47a.75.75 0 01.188.748 8.447 8.447 0 008.085 10.901c.855 0 1.68-.127 2.455-.362a.75.75 0 01.936.935c-1.238 4.084-5.031 7.058-9.52 7.058-5.495 0-9.948-4.453-9.948-9.947 0-4.49 2.973-8.282 7.056-9.52a.75.75 0 01.748.187zM8.486 4.212a8.447 8.447 0 1011.302 11.3c-.477.07-.965.107-1.461.107-5.494 0-9.947-4.453-9.947-9.947 0-.496.036-.983.106-1.46z"
  }));
};

MoonLine.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MoonLine.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var SunLine = function SunLine(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25a.75.75 0 01.75.75v.62a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM5.105 5.106a.75.75 0 011.06 0l.44.439a.75.75 0 11-1.061 1.06l-.439-.439a.75.75 0 010-1.06zm13.79 0a.75.75 0 010 1.06l-.44.44a.75.75 0 11-1.06-1.061l.44-.44a.75.75 0 011.06 0zM11.988 7.75a4.216 4.216 0 100 8.43 4.216 4.216 0 000-8.43zm-5.716 4.215a5.716 5.716 0 1111.431 0 5.716 5.716 0 01-11.43 0zM2.25 12a.75.75 0 01.75-.75h.62a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75zm17.38 0a.75.75 0 01.75-.75H21a.75.75 0 010 1.5h-.62a.75.75 0 01-.75-.75zm-2.235 5.395a.75.75 0 011.06 0l.44.439a.75.75 0 11-1.06 1.06l-.44-.439a.75.75 0 010-1.06zm-10.79 0a.75.75 0 010 1.06l-.44.44a.75.75 0 11-1.06-1.061l.439-.44a.75.75 0 011.06 0zM12 19.629a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-.62a.75.75 0 01.75-.75z"
  }));
};

SunLine.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SunLine.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var StarLine = function StarLine(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.876 3.365c.46-.932 1.788-.932 2.248 0l2.334 4.728 5.218.758c1.028.15 1.439 1.413.695 2.139l-3.776 3.68.891 5.198c.176 1.024-.899 1.805-1.819 1.321L12 18.735 7.333 21.19c-.92.483-1.995-.297-1.82-1.321l.892-5.198-3.776-3.68c-.744-.726-.333-1.99.695-2.139l5.218-.758 2.334-4.728zM12 4.476L9.83 8.873c-.183.37-.536.627-.944.686l-4.852.705 3.511 3.423c.295.288.43.703.36 1.11l-.828 4.832 4.34-2.282a1.254 1.254 0 011.166 0l4.34 2.282-.828-4.833c-.07-.406.065-.821.36-1.11l3.511-3.422-4.852-.705a1.253 1.253 0 01-.944-.686L12 4.476z"
  }));
};

StarLine.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
StarLine.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var StarFill = function StarFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.02 3.996a1.093 1.093 0 011.96 0l2.189 4.435 4.894.711a1.093 1.093 0 01.606 1.864l-3.542 3.453.836 4.874a1.093 1.093 0 01-1.585 1.152L12 18.184l-4.378 2.301a1.093 1.093 0 01-1.585-1.152l.836-4.874-3.542-3.453a1.093 1.093 0 01.606-1.864l4.894-.71 2.19-4.436z"
  }));
};

StarFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
StarFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Champion = function Champion(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9 3.45a.7.7 0 01.7-.7h10.8a.7.7 0 01.7.7V5.9H21a.7.7 0 01.7.7c0 3.16-1.86 5.021-3.987 5.188-.791 2.164-2.719 3.77-5.054 4.026.027.073.041.153.041.236v1.1h1.57a.7.7 0 01.584.314l1.78 2.7a.7.7 0 01-.584 1.086h-8.1a.7.7 0 01-.596-1.067l1.66-2.7a.7.7 0 01.597-.333H11.3v-1.1c0-.083.014-.163.04-.236-2.334-.257-4.262-1.862-5.053-4.027C4.16 11.621 2.3 9.761 2.3 6.6a.7.7 0 01.7-.7h2.9V3.45zm6.083 15.1h-1.981l-.8 1.3h5.548l-.858-1.3h-1.875a.941.941 0 01-.034 0zM5.9 9.59V7.3H3.738c.2 1.77 1.155 2.708 2.162 3V9.59zm6.1 4.86c-2.572 0-4.692-2.148-4.7-4.843V4.15h9.4v5.44c0 2.704-2.123 4.86-4.7 4.86zm6.1-4.15v-3h2.162c-.2 1.77-1.155 2.708-2.162 3z"
  }));
};

Champion.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Champion.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Gift = function Gift(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.996 2.983a2.5 2.5 0 013.53-.006 2.5 2.5 0 01-.006 3.53c-.23.23-.554.411-.843.548a7.53 7.53 0 01-.403.177h5.025a1.4 1.4 0 011.401 1.4v3.255a1.4 1.4 0 01-1.4 1.401h-.227v7.061a1.4 1.4 0 01-1.401 1.401H5.328a1.4 1.4 0 01-1.4-1.4v-7.062H3.7a1.4 1.4 0 01-1.401-1.4V8.632a1.4 1.4 0 011.401-1.401h4.54a7.434 7.434 0 01-.394-.173c-.29-.138-.613-.32-.846-.552a2.5 2.5 0 01-.006-3.53 2.5 2.5 0 013.53.006c.23.23.411.554.549.843.145.306.278.652.393.984.112.327.212.654.293.938.08-.283.18-.608.291-.934.114-.332.247-.678.393-.985.138-.29.32-.614.552-.846zm-1.583 5.749H3.8v3.056h7.613V8.732zm0 4.556H5.427v6.962h5.986v-6.962zm1.5 6.962v-6.962h5.66v6.962h-5.66zm0-8.462V8.732H20.2v3.056h-7.287zm2.553-7.75a1 1 0 00-1.409.005c-.045.046-.138.178-.259.431a8.159 8.159 0 00-.329.828c-.128.374-.238.751-.32 1.052.301-.083.68-.194 1.055-.324.304-.104.592-.217.83-.33.254-.12.383-.212.426-.254a1 1 0 00.006-1.409zm-6.002.005a1 1 0 00-1.409-.006 1 1 0 00.007 1.409c.045.045.177.138.43.259.237.113.525.224.828.329.374.128.751.238 1.052.32-.083-.301-.194-.68-.323-1.054a8.28 8.28 0 00-.33-.83c-.121-.254-.212-.384-.255-.427z"
  }));
};

Gift.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Gift.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CoinsRotate = function CoinsRotate(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97 2.47a.75.75 0 011.06 0l2 2a.75.75 0 010 1.06l-2 2a.75.75 0 01-1.06-1.06l.72-.72H6.166A1.917 1.917 0 004.25 7.667V9a.75.75 0 01-1.5 0V7.667A3.417 3.417 0 016.167 4.25h1.522l-.72-.72a.75.75 0 010-1.06zm7.919 3.28a3.752 3.752 0 00-3.658 2.916.75.75 0 01-1.462-.332A5.252 5.252 0 0120.139 9.5a5.25 5.25 0 01-4.62 5.212.75.75 0 11-.178-1.489 3.75 3.75 0 00-.452-7.473zM8 11.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM2.75 15.5a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0zm17.75-1.25a.75.75 0 01.75.75v1.333a3.417 3.417 0 01-3.417 3.417h-1.522l.72.72a.75.75 0 11-1.061 1.06l-2-2a.75.75 0 010-1.06l2-2a.75.75 0 111.06 1.06l-.72.72h1.523a1.917 1.917 0 001.917-1.917V15a.75.75 0 01.75-.75z"
  }));
};

CoinsRotate.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CoinsRotate.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Coins = function Coins(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.628 7.35C5.904 7.35 3.75 9.46 3.75 12c0 2.54 2.154 4.65 4.878 4.65.334 0 .66-.032.974-.092a.75.75 0 01.284 1.472c-.407.079-.828.12-1.258.12-3.493 0-6.378-2.724-6.378-6.15 0-3.425 2.885-6.15 6.378-6.15.43 0 .85.041 1.258.12a.75.75 0 01-.284 1.473 5.135 5.135 0 00-.974-.093zm6.744 0c-2.724 0-4.878 2.11-4.878 4.65 0 2.54 2.154 4.65 4.878 4.65S20.25 14.54 20.25 12c0-2.54-2.154-4.65-4.878-4.65zM8.994 12c0-3.425 2.885-6.15 6.378-6.15 3.493 0 6.378 2.725 6.378 6.15 0 3.426-2.885 6.15-6.378 6.15-3.493 0-6.378-2.724-6.378-6.15z"
  }));
};

Coins.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Coins.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CoinBroken = function CoinBroken(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.455 3.75c-1.393 0-2.669.491-3.668 1.31a.75.75 0 01-.95-1.161 7.295 7.295 0 0110.267 10.264.75.75 0 01-1.161-.95 5.795 5.795 0 00-4.487-9.462zm-4.91 4.91a5.795 5.795 0 100 11.59 5.795 5.795 0 000-11.59zM2.25 14.453a7.295 7.295 0 1114.59 0 7.295 7.295 0 01-14.59 0z"
  }));
};

CoinBroken.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CoinBroken.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CoinHand = function CoinHand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.585 3.75a2.02 2.02 0 00-.646 3.933 3.525 3.525 0 012.56-2.56 2.02 2.02 0 00-1.914-1.373zm3.452 1.336a3.52 3.52 0 10-4.136 4.136 3.52 3.52 0 104.136-4.136zm-.683 1.433a2.02 2.02 0 100 4.039 2.02 2.02 0 000-4.039zM3.219 14.077c0-.797.646-1.442 1.443-1.442H7.43c.683 0 1.255.475 1.404 1.113l.353-.176a5.595 5.595 0 012.502-.591h.284c.498 0 .993.066 1.473.197l1.455.397a1.784 1.784 0 011.319 1.728l.966-.967a2.113 2.113 0 012.666-.263c.97.646 1.26 2 .484 2.96a17.452 17.452 0 01-1.429 1.573c-.538.517-1.16 1.024-1.802 1.337-.668.326-1.17.494-1.703.59-.369.067-.76.099-1.2.135l-.473.04c-.926.085-1.998-.085-2.888-.225l-.153-.024c-.48-.076-.904-.14-1.267-.165a3.104 3.104 0 00-.549 0v.014c0 .796-.646 1.442-1.442 1.442H4.66a1.442 1.442 0 01-1.442-1.442v-6.231zm5.654 4.712c.221-.014.444-.007.656.008.437.032.922.106 1.393.18l.072.011c.96.151 1.866.294 2.6.227.21-.02.392-.035.555-.048.407-.033.695-.057.987-.11.37-.067.74-.183 1.312-.462.437-.213.928-.597 1.42-1.07.487-.467.94-.987 1.303-1.436.178-.22.143-.573-.15-.768a.613.613 0 00-.773.076l-1.37 1.371c-.531.53-1.25.828-2 .828h-2.255a.75.75 0 010-1.5h1.42l.592-.592a.288.288 0 00-.128-.482l-1.455-.397a4.096 4.096 0 00-1.078-.144h-.284c-.636 0-1.263.148-1.832.432l-.985.493v3.383zM4.72 14.135v6.115h2.654v-6.115H4.72z"
  }));
};

CoinHand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CoinHand.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Bag = function Bag(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.038 4.75a.22.22 0 00-.156.064l-1.829 1.83h11.894l-1.83-1.83a.22.22 0 00-.155-.064H8.038zm10.97 3.394H4.992v10.01c0 .592.493 1.096 1.13 1.096h11.755c.638 0 1.13-.504 1.13-1.096V8.144zM6.822 3.754a1.72 1.72 0 011.216-.504h7.924c.456 0 .893.181 1.216.504l3.11 3.11c.14.14.22.331.22.53v10.76c0 1.447-1.192 2.596-2.631 2.596H6.123c-1.44 0-2.63-1.149-2.63-2.596V7.394a.75.75 0 01.219-.53l3.11-3.11zM9.09 9.553a.75.75 0 01.75.75 2.159 2.159 0 104.318 0 .75.75 0 011.5 0 3.659 3.659 0 11-7.318 0 .75.75 0 01.75-.75z"
  }));
};

Bag.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Bag.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Wallet = function Wallet(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.594 3.57a.75.75 0 01.998.17l2.575 3.31H18.4c.856 0 1.55.694 1.55 1.55v2.05H20a.75.75 0 01.75.75v4.4a.75.75 0 01-.75.75h-.05V19a1.55 1.55 0 01-1.55 1.55H4.8A1.55 1.55 0 013.25 19V8.6c0-.856.694-1.55 1.55-1.55h3.38l5.414-3.48zM8.39 8.55H18.4a.05.05 0 01.05.05v2.05H17.4a2.95 2.95 0 000 5.9h1.05V19a.05.05 0 01-.05.05H4.8a.05.05 0 01-.05-.05V8.6a.05.05 0 01.05-.05h3.589zm6.878-1.5h-4.313l2.875-1.848 1.438 1.848zm2.133 5.1a1.45 1.45 0 000 2.9h1.85v-2.9H17.4z"
  }));
};

Wallet.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Wallet.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Receipt = function Receipt(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.317 5.6c0-1.194.86-2.35 2.136-2.35h11.094c1.277 0 2.136 1.156 2.136 2.35V20a.75.75 0 01-1.177.617l-1.884-1.305-1.884 1.305a.75.75 0 01-.854 0L12 19.312l-1.884 1.305a.75.75 0 01-.854 0l-1.884-1.305-1.884 1.305A.75.75 0 014.317 20V5.6zm2.136-.85c-.254 0-.636.276-.636.85v12.969l1.134-.786a.75.75 0 01.854 0l1.884 1.305 1.884-1.305a.75.75 0 01.854 0l1.884 1.305 1.884-1.305a.75.75 0 01.854 0l1.134.786V5.6c0-.574-.382-.85-.636-.85H6.453z"
  }));
};

Receipt.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Receipt.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ReceiptLines = function ReceiptLines(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.317 5.6c0-1.194.86-2.35 2.136-2.35h11.094c1.277 0 2.136 1.156 2.136 2.35V20a.75.75 0 01-1.177.617l-1.884-1.305-1.884 1.305a.75.75 0 01-.854 0L12 19.312l-1.884 1.305a.75.75 0 01-.854 0l-1.884-1.305-1.884 1.305A.75.75 0 014.317 20V5.6zm2.136-.85c-.254 0-.636.276-.636.85v12.969l1.134-.786a.75.75 0 01.854 0l1.884 1.305 1.884-1.305a.75.75 0 01.854 0l1.884 1.305 1.884-1.305a.75.75 0 01.854 0l1.134.786V5.6c0-.574-.382-.85-.636-.85H6.453zm1.064 3.517a.75.75 0 01.75-.75h7.466a.75.75 0 010 1.5H8.267a.75.75 0 01-.75-.75zm0 4.266a.75.75 0 01.75-.75h7.466a.75.75 0 010 1.5H8.267a.75.75 0 01-.75-.75z"
  }));
};

ReceiptLines.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ReceiptLines.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Tag = function Tag(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.378 4.752a.722.722 0 00-.566.21l-7.85 7.85a.722.722 0 000 1.021l5.205 5.205a.722.722 0 001.021 0l7.85-7.85a.723.723 0 00.21-.566l-.372-4.833a.722.722 0 00-.665-.665l-4.833-.372zm-1.627-.851a2.222 2.222 0 011.742-.644l4.833.371a2.222 2.222 0 012.046 2.046l.371 4.833a2.222 2.222 0 01-.644 1.742l-7.85 7.85a2.222 2.222 0 01-3.143 0l-5.205-5.205a2.222 2.222 0 010-3.143l7.85-7.85zm3.122 4.472a.75.75 0 01.754-.746h.005a.75.75 0 01-.008 1.5h-.005a.75.75 0 01-.746-.754z"
  }));
};

Tag.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Tag.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var TagFill = function TagFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.431 12.281a1.472 1.472 0 000 2.082l5.206 5.206a1.473 1.473 0 002.082 0l7.85-7.85c.304-.304.46-.726.427-1.154l-.372-4.834a1.472 1.472 0 00-1.355-1.355l-4.834-.372a1.472 1.472 0 00-1.154.427l-7.85 7.85zm11.736-3.614a.833.833 0 100-1.667.833.833 0 000 1.667z"
  }));
};

TagFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TagFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CurrencyDollar = function CurrencyDollar(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.25a.75.75 0 01.75.75v1.917h1.06a3.416 3.416 0 013.075 2.278.75.75 0 01-1.415.499 1.917 1.917 0 00-1.71-1.277h-3.538a1.917 1.917 0 000 3.833h3.556a3.417 3.417 0 010 6.833H12.75V20a.75.75 0 01-1.5 0v-1.917h-1.06a3.416 3.416 0 01-3.075-2.278.75.75 0 111.415-.499 1.917 1.917 0 001.71 1.277h3.538a1.917 1.917 0 000-3.833h-3.556a3.417 3.417 0 010-6.833h1.028V4a.75.75 0 01.75-.75z"
  }));
};

CurrencyDollar.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CurrencyDollar.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CurrencyCoinDollar = function CurrencyCoinDollar(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 6.187a.75.75 0 01.75.75v.97H13.158c.49.021.96.192 1.35.487.391.294.684.7.845 1.163a.75.75 0 11-1.418.49.967.967 0 00-.33-.456.918.918 0 00-.499-.185h-2.231a.922.922 0 00-.658.28.985.985 0 00-.28.689c0 .261.103.51.28.69.177.18.414.279.658.279h2.25c.651 0 1.272.263 1.728.728.456.464.71 1.09.71 1.74 0 .65-.254 1.277-.71 1.741a2.422 2.422 0 01-1.728.728h-.375v.969a.75.75 0 01-1.5 0v-.969H10.842a2.418 2.418 0 01-1.35-.487c-.391-.295-.684-.7-.845-1.163a.75.75 0 011.418-.49c.064.184.18.342.33.456.147.11.32.174.499.184h2.231a.922.922 0 00.658-.279.985.985 0 00.28-.69.985.985 0 00-.28-.69.922.922 0 00-.658-.278h-2.25a2.422 2.422 0 01-1.728-.728 2.485 2.485 0 01-.71-1.741c0-.65.254-1.277.71-1.74a2.422 2.422 0 011.728-.729h.375v-.968a.75.75 0 01.75-.75z"
  }));
};

CurrencyCoinDollar.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CurrencyCoinDollar.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CurrencyEuro = function CurrencyEuro(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.246 4.873a5.962 5.962 0 013.944-.48c1.328.295 2.534 1.038 3.475 2.113a.75.75 0 01-1.13.988c-.747-.855-1.68-1.417-2.672-1.638a4.462 4.462 0 00-2.956.364c-.942.462-1.765 1.248-2.352 2.277-.137.241-.26.493-.367.753H13.9a.75.75 0 010 1.5H8.757a7.38 7.38 0 000 2.5H13.9a.75.75 0 010 1.5H9.188c.107.26.23.512.367.753.587 1.03 1.41 1.815 2.352 2.277.94.46 1.966.584 2.956.364.993-.221 1.925-.783 2.672-1.638a.75.75 0 111.13.988c-.94 1.075-2.147 1.818-3.475 2.114a5.961 5.961 0 01-3.944-.481c-1.236-.606-2.273-1.615-2.994-2.882a8.232 8.232 0 01-.663-1.495H5.9a.75.75 0 010-1.5h1.34a8.89 8.89 0 010-2.5H5.9a.75.75 0 010-1.5h1.69a8.235 8.235 0 01.662-1.495c.721-1.267 1.758-2.276 2.994-2.882z"
  }));
};

CurrencyEuro.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CurrencyEuro.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CurrencyCoinEuro = function CurrencyCoinEuro(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.021-4.777a4.114 4.114 0 012.72-.331c.918.204 1.745.716 2.386 1.449a.75.75 0 01-1.129.987c-.448-.512-1.002-.843-1.583-.972a2.614 2.614 0 00-1.733.214c-.556.272-1.05.74-1.404 1.362l-.049.089h2.622a.75.75 0 010 1.5h-3.09a4.51 4.51 0 000 1.082h3.09a.75.75 0 010 1.5H9.48c.016.03.032.06.049.088.355.623.848 1.09 1.404 1.363a2.615 2.615 0 001.733.214c.581-.13 1.135-.46 1.583-.973a.75.75 0 011.129.988c-.641.733-1.468 1.245-2.385 1.45a4.114 4.114 0 01-2.72-.332c-.85-.417-1.558-1.108-2.047-1.967a5.552 5.552 0 01-.386-.831h-.902a.75.75 0 010-1.5h.566a6.012 6.012 0 010-1.082h-.566a.75.75 0 010-1.5h.902c.106-.288.235-.566.386-.831.49-.86 1.196-1.55 2.046-1.967z"
  }));
};

CurrencyCoinEuro.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CurrencyCoinEuro.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CurrencyPound = function CurrencyPound(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.282 5.982A3.25 3.25 0 009.8 8.968v3.247h4.15a.75.75 0 110 1.5H9.8v2.75a.749.749 0 01-.005.084c-.033.294-.1.58-.2.856a6.752 6.752 0 012.7.351.76.76 0 01.068.027 5.25 5.25 0 004.375 0 .75.75 0 11.625 1.364 6.75 6.75 0 01-5.59.016 5.25 5.25 0 00-3.66.111c-.254.165-.529.3-.818.4a.75.75 0 01-.625-1.355c.233-.137.474-.26.72-.368a2.247 2.247 0 00.91-1.53v-2.706H6.95a.75.75 0 010-1.5H8.3V8.961a4.75 4.75 0 018.847-2.375.75.75 0 01-1.294.759 3.25 3.25 0 00-1.57-1.363z"
  }));
};

CurrencyPound.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CurrencyPound.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CurrencyCoinPound = function CurrencyCoinPound(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm11.181-4.26a1.923 1.923 0 00-2.652 1.765v1.921h2.524a.75.75 0 010 1.5h-2.525v1.59a.755.755 0 01-.004.083c-.011.096-.027.19-.047.284.527 0 1.051.087 1.551.26a.737.737 0 01.068.027 3.26 3.26 0 002.716 0 .75.75 0 01.626 1.364 4.76 4.76 0 01-3.93.016 3.26 3.26 0 00-2.241.065c-.18.115-.375.21-.58.28a.75.75 0 01-.625-1.355c.156-.092.317-.175.482-.248a1.258 1.258 0 00.484-.823v-1.543h-.653a.75.75 0 010-1.5h.653V9.498a3.423 3.423 0 016.376-1.711.75.75 0 11-1.293.759 1.923 1.923 0 00-.93-.806z"
  }));
};

CurrencyCoinPound.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CurrencyCoinPound.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CurrencyRubel = function CurrencyRubel(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 5a.75.75 0 01.75-.75h6a3.75 3.75 0 010 7.5H9.25v2.5h5.25a.75.75 0 010 1.5H9.25V19a.75.75 0 01-1.5 0v-3.25H6.5a.75.75 0 010-1.5h1.25v-2.5H6.5a.75.75 0 010-1.5h1.25V5zm1.5 5.25h5.25a2.25 2.25 0 000-4.5H9.25v4.5z"
  }));
};

CurrencyRubel.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CurrencyRubel.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CurrencyCoinRubel = function CurrencyCoinRubel(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm6.494-4.5a.75.75 0 01.75-.75h4.296c.744 0 1.471.265 2.02.757.55.494.877 1.184.877 1.922s-.327 1.427-.878 1.921a3.027 3.027 0 01-2.02.757h-3.545v1.072h3.546a.75.75 0 010 1.5h-3.546V16.5a.75.75 0 11-1.5 0v-1.821h-.681a.75.75 0 010-1.5h.681v-1.072h-.681a.75.75 0 110-1.5h.681V7.5zm1.5 3.107h3.546c.395 0 .76-.142 1.017-.373.255-.229.38-.52.38-.805 0-.285-.125-.577-.38-.806a1.528 1.528 0 00-1.017-.373h-3.546v2.357z"
  }));
};

CurrencyCoinRubel.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CurrencyCoinRubel.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CurrencyRupee = function CurrencyRupee(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 5a.75.75 0 01.75-.75h11a.75.75 0 010 1.5h-4.536a4.75 4.75 0 011.226 2.5h3.31a.75.75 0 010 1.5h-3.31a4.75 4.75 0 01-4.69 4H8.31l4.72 4.72a.75.75 0 01-1.06 1.06l-6-6a.75.75 0 01.53-1.28h3a3.25 3.25 0 003.162-2.5H6.5a.75.75 0 010-1.5h6.162A3.25 3.25 0 009.5 5.75h-3A.75.75 0 015.75 5z"
  }));
};

CurrencyRupee.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CurrencyRupee.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CurrencyCoinRupee = function CurrencyCoinRupee(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm5.625-3.938a.75.75 0 01.75-.75h6.75a.75.75 0 010 1.5h-2.23c.209.329.358.692.443 1.072h1.787a.75.75 0 110 1.5h-1.787a3.357 3.357 0 01-.844 1.586 3.15 3.15 0 01-2.278.985h-.088l2.471 2.59a.75.75 0 01-1.085 1.035l-3.682-3.857a.75.75 0 01.543-1.268h1.84c.441 0 .871-.183 1.194-.52a1.83 1.83 0 00.36-.551H8.625a.75.75 0 010-1.5h3.394a1.83 1.83 0 00-.36-.55 1.65 1.65 0 00-1.193-.521H8.625a.75.75 0 01-.75-.75z"
  }));
};

CurrencyCoinRupee.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CurrencyCoinRupee.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Card = function Card(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7.781a3 3 0 013-3h13.5a3 3 0 013 3v8.439a3 3 0 01-3 2.999H5.25a3 3 0 01-3-3V7.78zm3-1.5a1.5 1.5 0 00-1.5 1.5v.938h16.5V7.78a1.5 1.5 0 00-1.5-1.499H5.25zm15 3.938H3.75v6a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-6z"
  }));
};

Card.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Card.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CardAdd = function CardAdd(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7.783a2.876 2.876 0 012.876-2.876h12.756a2.876 2.876 0 012.876 2.876v3.72a.75.75 0 01-1.5 0v-1.375H3.75v5.628c0 .76.616 1.376 1.376 1.376h8.504a.75.75 0 010 1.5H5.126a2.876 2.876 0 01-2.876-2.876V7.783zm1.5.845h15.508v-.845c0-.76-.616-1.376-1.376-1.376H5.126c-.76 0-1.376.616-1.376 1.376v.845zm15.012 4.49a.75.75 0 01.75.75v1.487H21a.75.75 0 010 1.5h-1.488v1.488a.75.75 0 01-1.5 0v-1.488h-1.488a.75.75 0 010-1.5h1.488v-1.488a.75.75 0 01.75-.75z"
  }));
};

CardAdd.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CardAdd.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CardCheck = function CardCheck(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 8.03a2.868 2.868 0 012.868-2.868h12.705a2.867 2.867 0 012.868 2.867v3.706a.75.75 0 01-1.5 0v-1.367H3.751v5.602c0 .756.612 1.368 1.367 1.368h8.47a.75.75 0 010 1.5h-8.47a2.868 2.868 0 01-2.868-2.867V8.029zm1.5.837h15.441V8.03c0-.755-.612-1.367-1.368-1.367H5.118c-.756 0-1.368.612-1.368 1.367v.838zm17.78 4.985a.75.75 0 010 1.06l-2.904 2.905a.75.75 0 01-1.06 0l-1.332-1.331a.75.75 0 011.06-1.06l.802.8 2.374-2.374a.75.75 0 011.06 0z"
  }));
};

CardCheck.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CardCheck.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CardDown = function CardDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7.617a2.932 2.932 0 012.932-2.932h13.09a2.931 2.931 0 012.933 2.931v3.82a.75.75 0 01-1.5 0v-1.433H3.75V15.8c0 .79.641 1.432 1.432 1.432h8.727a.75.75 0 010 1.5H5.182a2.932 2.932 0 01-2.932-2.932V7.617zm1.5.886h15.955v-.887c0-.79-.641-1.43-1.432-1.43H5.182c-.79 0-1.432.64-1.432 1.431v.886zm15.019 4.364a.75.75 0 01.75.75v3.143l.952-.947a.75.75 0 011.058 1.063l-2.231 2.22a.75.75 0 01-1.058 0l-2.133-2.12a.75.75 0 111.058-1.063l.854.849v-3.145a.75.75 0 01.75-.75z"
  }));
};

CardDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CardDown.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CardEdit = function CardEdit(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7.423a2.807 2.807 0 012.807-2.808H17.4a2.806 2.806 0 012.808 2.807V9.48h-.719a.748.748 0 01-.546.235H3.75v5.422c0 .722.586 1.308 1.307 1.308h6.686a.75.75 0 010 1.5H5.057a2.807 2.807 0 01-2.807-2.808V7.423zm1.5.792h14.958v-.793c0-.722-.585-1.307-1.308-1.307H5.057c-.722 0-1.307.586-1.307 1.308v.792zM18 11.932a.75.75 0 011.062 0l2.468 2.47a.75.75 0 010 1.06l-3.703 3.703a.75.75 0 01-.53.22h-2.469a.75.75 0 01-.75-.75v-2.47a.75.75 0 01.22-.53L18 11.933zm.531 1.591l-2.953 2.954v1.408h1.408l2.953-2.954-1.408-1.408z"
  }));
};

CardEdit.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CardEdit.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CardLock = function CardLock(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7.5a2.868 2.868 0 012.868-2.868h12.705A2.868 2.868 0 0120.69 7.5v1.588a.75.75 0 01-1.015.702.749.749 0 01-.264.048H3.75v5.603c0 .755.613 1.368 1.368 1.368H12a.75.75 0 110 1.5H5.118A2.868 2.868 0 012.25 15.44V7.5zm1.5.838h15.441V7.5c0-.756-.612-1.368-1.368-1.368H5.118c-.756 0-1.368.612-1.368 1.368v.838zm14.603 4.853a.574.574 0 00-.574.574v.573h1.147v-.573a.574.574 0 00-.573-.574zm2.073 1.176v-.602a2.074 2.074 0 10-4.147 0v.602a1.633 1.633 0 00-1.323 1.604v1.764c0 .902.73 1.633 1.632 1.633h3.53c.901 0 1.632-.731 1.632-1.633v-1.764c0-.796-.57-1.46-1.324-1.604zm-3.838 1.471a.132.132 0 00-.132.133v1.764c0 .073.059.133.132.133h3.53c.073 0 .132-.06.132-.133v-1.764a.132.132 0 00-.132-.133h-3.53z"
  }));
};

CardLock.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CardLock.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CardMinus = function CardMinus(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 8.085a2.838 2.838 0 012.838-2.838h12.527a2.837 2.837 0 012.838 2.838v3.654a.75.75 0 01-1.5 0v-1.338H3.75v5.514c0 .739.6 1.338 1.338 1.338h8.351a.75.75 0 010 1.5H5.09a2.838 2.838 0 01-2.839-2.838v-7.83zm1.5.816h15.203v-.816c0-.739-.599-1.338-1.338-1.338H5.088c-.739 0-1.338.6-1.338 1.338v.816zM21 16.269h-4.43a.75.75 0 110-1.5H21a.75.75 0 010 1.5z"
  }));
};

CardMinus.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CardMinus.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CardUp = function CardUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7.617a2.932 2.932 0 012.932-2.932h13.09a2.931 2.931 0 012.933 2.931v3.82a.75.75 0 11-1.5 0v-1.433H3.75V15.8c0 .79.641 1.432 1.432 1.432h8.727a.75.75 0 010 1.5H5.182a2.932 2.932 0 01-2.932-2.932V7.617zm1.5.886h15.954v-.887c0-.79-.64-1.43-1.431-1.43H5.182c-.791 0-1.432.64-1.432 1.431v.886zm14.588 4.582a.75.75 0 011.058 0l2.133 2.12a.75.75 0 01-1.058 1.064l-.854-.849v3.145a.75.75 0 11-1.5 0V15.42l-.952.948a.75.75 0 11-1.058-1.063l2.231-2.22z"
  }));
};

CardUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CardUp.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CardX = function CardX(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7.863a2.956 2.956 0 012.956-2.956h13.238a2.956 2.956 0 012.957 2.956v3.861a.75.75 0 01-1.5 0v-1.456H3.75v5.869c0 .804.651 1.456 1.456 1.456h8.825a.75.75 0 110 1.5H5.207a2.956 2.956 0 01-2.957-2.956V7.863zm1.5.905H19.9v-.905c0-.805-.651-1.456-1.456-1.456H5.206c-.804 0-1.456.652-1.456 1.456v.905zm13.435 5.559a.75.75 0 011.061 0l1.112 1.111 1.112-1.111a.75.75 0 111.06 1.06L20.42 16.5l1.111 1.112a.75.75 0 11-1.06 1.06l-1.112-1.111-1.112 1.112a.75.75 0 01-1.06-1.061l1.111-1.112-1.112-1.112a.75.75 0 010-1.06z"
  }));
};

CardX.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CardX.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Eth = function Eth(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 11.068l6.098-3.216 6.056 3.216L12.021 2l-6.098 9.068zm11.897.996l-5.788-3.183-5.852 3.183 5.852 3.087 5.788-3.087zm.29.965L12.02 22l-6.13-8.971 6.13 2.99 6.088-2.99z"
  }));
};

Eth.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Eth.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Bnb = function Bnb(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.494l-3.894 3.894-2.247-2.247L12 2l6.198 6.199-2.247 2.247L12 6.494zm0 11.012l3.967-3.967 2.247 2.247L12 22l-6.179-6.179 2.247-2.247L12 17.506zm-5.423-5.589L6.494 12l.045.046-2.247 2.247L2 12l2.33-2.33 2.247 2.247zm3 .083L12 14.423 14.423 12 12 9.577 9.577 12zm7.919.01l.01-.01-.026-.026 2.247-2.247L22 12l-2.257 2.257-2.247-2.247z"
  }));
};

Bnb.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Bnb.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Matic = function Matic(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm2.496-13.21a.849.849 0 01.804 0l2.715 1.586a.833.833 0 01.402.708v3.205a.823.823 0 01-.402.708L15.3 17.582a.849.849 0 01-.804 0l-2.714-1.585a.833.833 0 01-.402-.708v-1.114l1.273-.742v1.08c0 .303.168.573.402.708l1.441.843c.268.135.57.135.804 0l1.408-.843a.833.833 0 00.402-.708v-1.687a.823.823 0 00-.402-.708l-1.441-.843a.849.849 0 00-.804 0l-1.843 1.08-1.273.741-1.843 1.08a.849.849 0 01-.804 0L5.985 12.59a.833.833 0 01-.402-.708v-3.17c0-.27.134-.54.402-.675l2.748-1.62a.849.849 0 01.804 0l2.68 1.586a.833.833 0 01.403.708v1.147l-1.273.742V9.487a.823.823 0 00-.402-.708l-1.441-.877a.849.849 0 00-.804 0l-1.441.843a.833.833 0 00-.402.708v1.687c0 .303.167.573.402.708l1.44.877c.269.135.57.135.805 0l1.843-1.113 1.273-.708 1.876-1.113z"
  }));
};

Matic.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Matic.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Arbitrum = function Arbitrum(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.202 17.651l2.147 1.237 7.143-11.456L10.28 7.4c-1.033-.014-2.146.254-2.657 1.088l-4.056 6.287-1.365 2.097v.779zm18.247-2.53l.002 1.303v.085c-.009.191-.1.369-.248.49l-1.52.88-4.204-6.798 1.615-2.742 4.355 6.783zm-5.354 4.838l-3.035-4.763 1.853-3.144 3.985 6.282-2.803 1.625zM12.419 7.444l3.196-.012-7.21 12.23-.687 1.165-2.527-1.454 7.228-11.929z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.798 7.416a2.035 2.035 0 00-.955-1.636l-7.944-4.568a2.066 2.066 0 00-1.822 0c-.066.033-7.725 4.475-7.725 4.475a2.02 2.02 0 00-1.15 1.725v9.46l1.365-2.097-.012-7.3a.672.672 0 01.28-.507c.037-.025 7.826-4.534 7.85-4.547a.691.691 0 01.6-.002l7.84 4.51a.675.675 0 01.312.537v9.042a.659.659 0 01-.234.49l-1.52.881-.785.455-2.803 1.625-2.843 1.647a.689.689 0 01-.484-.01l-3.363-1.934-.688 1.165 3.023 1.74.262.149c.114.063.19.106.218.119.215.104.524.165.802.165.256 0 .505-.047.74-.14l8.258-4.781c.474-.367.753-.921.778-1.521V7.416z"
  }));
};

Arbitrum.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Arbitrum.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ZkSync = function ZkSync(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zM8.336 7.763c.001.523.003 1.021-.007 1.52-.004.213.048.279.27.276 1.01-.009 2.02-.008 3.029-.007l1.01.001h.507c-.018.093-.08.131-.137.167a.628.628 0 00-.048.032 1542.28 1542.28 0 01-4.411 3.306.473.473 0 00-.22.428c.007.822.006 1.644.005 2.466v.853c-.087.016-.123-.031-.157-.075l-.029-.035a4428.772 4428.772 0 01-4.557-4.553c-.086-.082-.152-.145-.007-.288a808.154 808.154 0 004.625-4.62 4.108 4.108 0 00.125-.099c0 .214 0 .423.002.628zm7.33 9.122v-2.093-.115c.002-.116.003-.174-.026-.204-.03-.03-.091-.03-.216-.028H10.778l.428-.322.804-.605.701-.527a449.34 449.34 0 012.746-2.053.468.468 0 00.213-.431c-.007-.748-.006-1.496-.005-2.244V8.26 7.191l.067-.045.339.351c.226.236.451.47.681.701a1606.665 1606.665 0 003.667 3.669c.076.068.144.13.01.262-1.194 1.185-2.384 2.375-3.6 3.592h-.001l-.008.009-1.155 1.155z"
  }));
};

ZkSync.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ZkSync.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Btc = function Btc(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm2.451-7.368a1.21 1.21 0 00-.594-1.92l-3.097-.923-.69 2.316 3.097.923a1.201 1.201 0 00.92-.095 1.2 1.2 0 00.364-.301zm1.404-4.715a1.202 1.202 0 00-.44-.814 1.202 1.202 0 00-.417-.22L11.9 8.961l-.69 2.316 3.097.923a1.21 1.21 0 001.548-1.283zm-.408-2.545c.713.212 1.301.69 1.655 1.344.354.654.432 1.408.22 2.12a2.777 2.777 0 01-1.382 1.673c.355.635.465 1.405.242 2.155-.212.714-.69 1.301-1.344 1.655a2.77 2.77 0 01-2.12.22l-.413-.123-.488 1.637-1.466-.437.487-1.637-1.26-.375-.487 1.637-1.429-.425-.352-.105.467-1.568-1.741-.518.491-1.65 1.741.518 1.789-6.006-1.741-.518.491-1.65 1.741.518.553-1.857 1.429.426.353.105-.574 1.926 1.257.375.573-1.927 1.472.439-.573 1.926.41.122z"
  }));
};

Btc.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Btc.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Camera = function Camera(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.752 4.322A.75.75 0 019.4 3.95h5.2a.75.75 0 01.648.372L16.43 6.35H18a2.75 2.75 0 012.75 2.75v8.2A2.75 2.75 0 0118 20.05H6a2.75 2.75 0 01-2.75-2.75V9.1A2.75 2.75 0 016 6.35h1.57l1.182-2.028zM9.831 5.45L8.648 7.478A.75.75 0 018 7.85H6c-.69 0-1.25.56-1.25 1.25v8.2c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V9.1c0-.69-.56-1.25-1.25-1.25h-2a.75.75 0 01-.648-.372L14.17 5.45H9.831zm2.169 5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM8.25 12.7a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0z"
  }));
};

Camera.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Camera.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Image01 = function Image01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 3.75A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.625 2.625h11.25a2.625 2.625 0 002.625-2.625V6.375a2.625 2.625 0 00-2.625-2.625H6.375zM2.25 6.375A4.125 4.125 0 016.375 2.25h11.25a4.125 4.125 0 014.125 4.125v11.25a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zm13.05.562a.75.75 0 01.75-.75h.321a.75.75 0 01.75.75v.273a.75.75 0 01-.75.75h-.321a.75.75 0 01-.75-.75v-.273zm-.025 5.022l-3.019 2.837-.002.002a1.219 1.219 0 01-1.702-.038l-.01-.01-.008-.008-1.457-1.262-1.93 1.636a.188.188 0 00-.022.087v1.672h9.75v-3.3c0-.05-.02-.1-.058-.135l-1.542-1.48zm-8.218 3.066l.102.07-.102-.07zm1.94-1.655l.076-.088-.076.088zm5.448-2.69a1.219 1.219 0 011.676.012l1.735 1.666c.332.318.519.758.519 1.218v3.58c0 .673-.546 1.219-1.219 1.219H6.844a1.219 1.219 0 01-1.219-1.219v-1.953c0-.346.106-.682.302-.964a1.37 1.37 0 01.243-.261l2.024-1.715.019-.02a1.219 1.219 0 011.737.005v.001l.017.017 1.452 1.258 3.024-2.842.002-.002zM9.96 12.26zm.012.01zm-1.78-.003z"
  }));
};

Image01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Image01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Image02 = function Image02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 6.375A4.125 4.125 0 016.375 2.25h11.25a4.125 4.125 0 014.125 4.125v11.25a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zM6.375 3.75A2.625 2.625 0 003.75 6.375v11.25c0 .3.05.59.144.858l4.2-4.2a.75.75 0 011.061 0l1.72 1.719 4.532-4.532a.75.75 0 011.06 0l3.783 3.782V6.375a2.625 2.625 0 00-2.625-2.625H6.375zM20.25 17.226a.746.746 0 01-.343-.196l-3.97-3.97-4.532 4.533a.75.75 0 01-1.06 0l-1.72-1.72-3.84 3.84c.44.337.992.537 1.59.537h11.25a2.625 2.625 0 002.625-2.625v-.399zM8.062 7.125a.937.937 0 100 1.875.937.937 0 000-1.875zm-2.437.938a2.438 2.438 0 114.875 0 2.438 2.438 0 01-4.875 0z"
  }));
};

Image02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Image02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ImageCheck = function ImageCheck(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 6.49a4.056 4.056 0 014.056-4.056h8.265a.75.75 0 010 1.5H6.306A2.556 2.556 0 003.75 6.49v11.02c0 1.317.996 2.4 2.275 2.54l9.134-8.596a.75.75 0 011.045.016l3.678 3.678V9.796a.75.75 0 011.5 0v7.714a4.056 4.056 0 01-4.056 4.056H6.306A4.056 4.056 0 012.25 17.51V6.49zM19.883 17.13a.747.747 0 01-.332-.193l-3.893-3.893-7.46 7.021h9.128a2.556 2.556 0 002.556-2.556v-.379zM21.53 3.204a.75.75 0 010 1.061l-3.857 3.857a.75.75 0 01-1.06 0L14.96 6.47a.75.75 0 111.06-1.06l1.123 1.122 3.327-3.327a.75.75 0 011.06 0zM7.96 7.24a.903.903 0 100 1.806.903.903 0 000-1.806zm-2.404.903a2.403 2.403 0 114.806 0 2.403 2.403 0 01-4.806 0z"
  }));
};

ImageCheck.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ImageCheck.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ImageUp = function ImageUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.272 2.468a.75.75 0 011.058 0l2.199 2.187a.75.75 0 01-1.058 1.063l-.92-.915v3.822a.75.75 0 01-1.5 0v-3.82l-1.022 1.017a.75.75 0 01-1.058-1.064l2.3-2.29zM2.25 6.375A4.125 4.125 0 016.375 2.25h7.313a.75.75 0 010 1.5H6.375A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.343 2.61l9.33-8.781a.75.75 0 011.045.016l3.782 3.782V12a.75.75 0 011.5 0v5.625a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zm18 10.851a.746.746 0 01-.343-.196l-3.985-3.985-7.656 7.205h9.359a2.625 2.625 0 002.625-2.625v-.399zM8.062 7.125a.937.937 0 100 1.875.937.937 0 000-1.875zm-2.437.938a2.438 2.438 0 114.875 0 2.438 2.438 0 01-4.875 0z"
  }));
};

ImageUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ImageUp.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ImageDown = function ImageDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7 2.25a.75.75 0 01.75.75v3.82l1.02-1.017a.75.75 0 011.06 1.064l-2.302 2.29a.75.75 0 01-1.058 0L15.971 6.97a.75.75 0 011.058-1.063l.92.915V3a.75.75 0 01.75-.75zM2.25 6.375A4.125 4.125 0 016.375 2.25h7.313a.75.75 0 010 1.5H6.375A2.625 2.625 0 003.75 6.375v11.25a2.625 2.625 0 002.343 2.61l9.33-8.781a.75.75 0 011.045.016l3.782 3.782V12a.75.75 0 011.5 0v5.625a4.125 4.125 0 01-4.125 4.125H6.375a4.125 4.125 0 01-4.125-4.125V6.375zm18 10.851a.746.746 0 01-.343-.196l-3.985-3.985-7.656 7.205h9.359a2.625 2.625 0 002.625-2.625v-.399zM8.062 7.125a.937.937 0 100 1.875.937.937 0 000-1.875zm-2.437.938a2.438 2.438 0 114.875 0 2.438 2.438 0 01-4.875 0z"
  }));
};

ImageDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ImageDown.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ImageX = function ImageX(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 6.706a3.926 3.926 0 013.926-3.927h6.883a.75.75 0 010 1.5H6.176A2.426 2.426 0 003.75 6.706v10.588c0 1.245.938 2.272 2.146 2.41l8.766-8.25a.75.75 0 011.045.016l3.484 3.484v-4.013a.75.75 0 011.5 0v6.353a3.926 3.926 0 01-3.926 3.927H6.176a3.926 3.926 0 01-3.926-3.927V6.706zm16.941 10.246a.747.747 0 01-.31-.186l-3.72-3.721-7.093 6.676h8.697a2.427 2.427 0 002.426-2.427v-.342zM16.234 3a.75.75 0 011.061 0l1.587 1.587L20.47 3a.75.75 0 111.06 1.06l-1.587 1.588 1.587 1.587a.75.75 0 01-1.06 1.061l-1.588-1.587-1.587 1.587a.75.75 0 11-1.06-1.06l1.587-1.588-1.588-1.587a.75.75 0 010-1.06zm-8.47 4.457a.838.838 0 100 1.676.838.838 0 000-1.676zm-2.338.838a2.338 2.338 0 114.677 0 2.338 2.338 0 01-4.677 0z"
  }));
};

ImageX.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ImageX.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ImageAdd = function ImageAdd(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.144 2.755a.75.75 0 01.75.75V5.61H21a.75.75 0 010 1.5h-2.106v2.106a.75.75 0 01-1.5 0V7.11H15.29a.75.75 0 010-1.5h2.105V3.505a.75.75 0 01.75-.75zM2.25 7.37a3.779 3.779 0 013.779-3.779h6.562a.75.75 0 010 1.5H6.03A2.279 2.279 0 003.75 7.37v10.096a2.28 2.28 0 002 2.262l8.347-7.856a.75.75 0 011.044.016l3.263 3.263v-2.733a.75.75 0 011.5 0v5.048a3.779 3.779 0 01-3.779 3.78H6.03a3.779 3.779 0 01-3.779-3.78V7.37zm16.154 9.796a.747.747 0 01-.285-.179l-3.524-3.524-6.675 6.282h8.205a2.279 2.279 0 002.279-2.279v-.3zM7.544 8.12a.764.764 0 100 1.529.764.764 0 000-1.529zm-2.265.764a2.264 2.264 0 114.529 0 2.264 2.264 0 01-4.53 0z"
  }));
};

ImageAdd.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ImageAdd.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ImageMinus = function ImageMinus(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 6.952a3.779 3.779 0 013.779-3.779h6.562a.75.75 0 010 1.5H6.03A2.279 2.279 0 003.75 6.952v10.096a2.28 2.28 0 002 2.262l8.347-7.856a.75.75 0 011.044.016l3.263 3.263V12a.75.75 0 111.5 0v5.048a3.779 3.779 0 01-3.779 3.779H6.03a3.779 3.779 0 01-3.779-3.779V6.952zm16.154 9.795a.747.747 0 01-.285-.178l-3.524-3.524-6.675 6.282h8.205a2.279 2.279 0 002.279-2.279v-.3zm-3.865-9.795a.75.75 0 01.75-.75H21a.75.75 0 010 1.5h-5.711a.75.75 0 01-.75-.75zm-6.996.75a.764.764 0 100 1.529.764.764 0 000-1.53zm-2.264.764a2.264 2.264 0 114.529 0 2.264 2.264 0 01-4.53 0z"
  }));
};

ImageMinus.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ImageMinus.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ImageQuestion = function ImageQuestion(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.353 3.75c-.771 0-1.368.607-1.368 1.322a.75.75 0 01-1.5 0c0-1.574 1.3-2.822 2.868-2.822 1.568 0 2.868 1.248 2.868 2.822 0 1.573-1.3 2.821-2.868 2.821a.75.75 0 010-1.5c.77 0 1.368-.607 1.368-1.321 0-.715-.597-1.322-1.368-1.322zM2.779 7.235A3.926 3.926 0 016.706 3.31h5.823a.75.75 0 010 1.5H6.706a2.426 2.426 0 00-2.427 2.426v10.588c0 1.246.938 2.272 2.146 2.411l8.767-8.25a.75.75 0 011.044.015l3.485 3.484V12a.75.75 0 011.5 0v5.823a3.926 3.926 0 01-3.927 3.927H6.706a3.926 3.926 0 01-3.927-3.927V7.236zm16.942 10.247a.747.747 0 01-.31-.187l-3.72-3.72-7.094 6.675h8.697a2.427 2.427 0 002.427-2.427v-.341zM8.294 7.985a.838.838 0 100 1.677.838.838 0 000-1.677zm-2.338.839a2.338 2.338 0 114.676 0 2.338 2.338 0 01-4.676 0zm12.397.308a.75.75 0 01.75.75v.08a.75.75 0 11-1.5 0v-.08a.75.75 0 01.75-.75z"
  }));
};

ImageQuestion.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ImageQuestion.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Save = function Save(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.937 2.25h8.764c.71 0 1.392.282 1.894.785M6.937 2.25H4.93c-1.48 0-2.679 1.2-2.679 2.679V19.07c0 1.48 1.2 2.679 2.679 2.679H19.07c1.48 0 2.679-1.2 2.679-2.679V8.3c0-.71-.282-1.392-.785-1.894l-3.37-3.37M6.188 3.75v2.625c0 1.036.839 1.875 1.875 1.875h7.874c1.036 0 1.876-.84 1.876-1.875V5.373l2.092 2.092c.22.221.345.521.345.834V19.07c0 .651-.528 1.179-1.179 1.179h-1.259v-5.438c0-1.035-.839-1.874-1.875-1.874H8.064c-1.036 0-1.876.839-1.876 1.874v5.063c0 .137.037.265.1.375H4.93c-.651 0-1.179-.528-1.179-1.179V4.93c0-.651.528-1.179 1.179-1.179h1.258zm1.4 16.5h8.724v-5.438a.375.375 0 00-.375-.374H8.064a.375.375 0 00-.376.374v5.063a.746.746 0 01-.1.375zm8.748-16.314a.755.755 0 00-.023.189v2.25a.375.375 0 01-.375.375H8.061a.375.375 0 01-.374-.375V3.75H15.7c.227 0 .447.065.636.186z"
  }));
};

Save.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Save.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var File01 = function File01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6A2.75 2.75 0 017.5 3.25h9A2.75 2.75 0 0119.25 6v12a2.75 2.75 0 01-2.75 2.75h-9A2.75 2.75 0 014.75 18V6zM7.5 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h9c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25h-9zM8.25 8A.75.75 0 019 7.25h6a.75.75 0 010 1.5H9A.75.75 0 018.25 8zm0 3a.75.75 0 01.75-.75h6a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zm0 3a.75.75 0 01.75-.75h3a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75z"
  }));
};

File01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
File01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var File02 = function File02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6A2.75 2.75 0 017.5 3.25h7.558c.494 0 .956.208 1.287.556.287.302.733.757 1.155 1.135.373.334.94.914 1.265 1.251.315.326.485.76.485 1.206V18a2.75 2.75 0 01-2.75 2.75h-9A2.75 2.75 0 014.75 18V6zM17.7 7.25a28.004 28.004 0 00-1.2-1.191 22.8 22.8 0 01-1.242-1.22l-.008-.008V7c0 .138.112.25.25.25h2.2zm-3.95-2.5V7c0 .966.784 1.75 1.75 1.75h2.25V18c0 .69-.56 1.25-1.25 1.25h-9c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h6.25z"
  }));
};

File02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
File02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var File03 = function File03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6A2.75 2.75 0 017.5 3.25h7.558c.494 0 .956.208 1.287.556.287.302.733.757 1.155 1.135.373.334.94.914 1.265 1.251.315.326.485.76.485 1.206V18a2.75 2.75 0 01-2.75 2.75h-9A2.75 2.75 0 014.75 18V6zM17.7 7.25a28.004 28.004 0 00-1.2-1.191 22.8 22.8 0 01-1.242-1.22l-.008-.008V7c0 .138.112.25.25.25h2.2zm-3.95-2.5V7c0 .966.784 1.75 1.75 1.75h2.25V18c0 .69-.56 1.25-1.25 1.25h-9c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h6.25zM8.25 8A.75.75 0 019 7.25h2a.75.75 0 010 1.5H9A.75.75 0 018.25 8zm0 3a.75.75 0 01.75-.75h6a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zm0 3a.75.75 0 01.75-.75h6a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75z"
  }));
};

File03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
File03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileCheck01 = function FileCheck01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 6a2.75 2.75 0 012.75-2.75h9A2.75 2.75 0 0118 6v5.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-9C5.56 4.75 5 5.31 5 6v12c0 .69.56 1.25 1.25 1.25h4a.75.75 0 010 1.5h-4A2.75 2.75 0 013.5 18V6zm16.762 7.452a.75.75 0 01.037 1.06l-4.667 5a.75.75 0 01-1.079.018l-1.833-1.833a.75.75 0 111.06-1.06l1.285 1.284 4.137-4.433a.75.75 0 011.06-.036z"
  }));
};

FileCheck01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileCheck01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileCheck02 = function FileCheck02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.833 6a2.75 2.75 0 012.75-2.75h9A2.75 2.75 0 0118.334 6v5.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-9c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h4a.75.75 0 010 1.5h-4A2.75 2.75 0 013.833 18V6zm3.5 2a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm0 3a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm0 3a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zm12.614.47a.75.75 0 010 1.06l-4 4a.75.75 0 01-1.06 0l-1.834-1.833a.75.75 0 111.06-1.06l1.304 1.302 3.47-3.47a.75.75 0 011.06 0z"
  }));
};

FileCheck02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileCheck02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileDown01 = function FileDown01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 6A2.75 2.75 0 017 3.25h9A2.75 2.75 0 0118.75 6v5.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25H7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h4a.75.75 0 110 1.5H7A2.75 2.75 0 014.25 18V6zm12.705 8.25a.75.75 0 01.75.75v3.195l.766-.762a.75.75 0 011.058 1.063l-2.045 2.036a.75.75 0 01-1.058 0l-1.955-1.944a.75.75 0 111.058-1.063l.676.672V15a.75.75 0 01.75-.75z"
  }));
};

FileDown01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileDown01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileDown02 = function FileDown02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 6A2.75 2.75 0 017 3.25h9A2.75 2.75 0 0118.75 6v5.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25H7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h4a.75.75 0 110 1.5H7A2.75 2.75 0 014.25 18V6zm3.5 2a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6A.75.75 0 017.75 8zm0 3a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm0 3a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zm9.205.25a.75.75 0 01.75.75v3.195l.766-.762a.75.75 0 011.058 1.063l-2.045 2.036a.75.75 0 01-1.058 0l-1.955-1.944a.75.75 0 111.058-1.063l.676.672V15a.75.75 0 01.75-.75z"
  }));
};

FileDown02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileDown02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileUp01 = function FileUp01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 6A2.75 2.75 0 017 3.25h9A2.75 2.75 0 0118.75 6v5.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25H7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h4a.75.75 0 110 1.5H7A2.75 2.75 0 014.25 18V6zm12.266 8.468a.75.75 0 011.058 0l1.955 1.944a.75.75 0 01-1.058 1.063l-.676-.672V20a.75.75 0 01-1.5 0v-3.195l-.766.762a.75.75 0 11-1.058-1.063l2.045-2.036z"
  }));
};

FileUp01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileUp01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileUp02 = function FileUp02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 6A2.75 2.75 0 017 3.25h9A2.75 2.75 0 0118.75 6v5.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25H7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h4a.75.75 0 110 1.5H7A2.75 2.75 0 014.25 18V6zm3.5 2a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6A.75.75 0 017.75 8zm0 3a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm0 3a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zm8.766.468a.75.75 0 011.058 0l1.955 1.944a.75.75 0 01-1.058 1.063l-.676-.672V20a.75.75 0 01-1.5 0v-3.195l-.766.762a.75.75 0 11-1.058-1.063l2.045-2.036z"
  }));
};

FileUp02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileUp02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileEdit01 = function FileEdit01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 5.991a2.741 2.741 0 012.741-2.74h8.96a2.741 2.741 0 012.742 2.74v3.983a.75.75 0 01-1.5 0V5.99c0-.685-.556-1.24-1.242-1.24h-8.96c-.685 0-1.24.555-1.24 1.24L4.75 17.938c0 .686.556 1.241 1.241 1.241h3.982a.75.75 0 110 1.5H5.991a2.741 2.741 0 01-2.741-2.741V5.991zm13.404 6.439a.75.75 0 011.06 0l2.816 2.816a.75.75 0 010 1.06l-4.224 4.224a.75.75 0 01-.53.22H12.96a.75.75 0 01-.75-.75v-2.816a.75.75 0 01.22-.53l4.224-4.224zm-2.944 5.065v1.755h1.755l3.474-3.474-1.755-1.755-3.474 3.474z"
  }));
};

FileEdit01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileEdit01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileEdit02 = function FileEdit02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 5.991a2.741 2.741 0 012.741-2.74h8.96a2.741 2.741 0 012.742 2.74v3.983a.75.75 0 01-1.5 0V5.99c0-.685-.556-1.24-1.242-1.24h-8.96c-.685 0-1.24.555-1.24 1.24L4.75 17.938c0 .686.556 1.241 1.241 1.241h3.982a.75.75 0 110 1.5H5.991a2.741 2.741 0 01-2.741-2.741V5.991zm3.485 1.991a.75.75 0 01.75-.75h5.973a.75.75 0 010 1.5H7.485a.75.75 0 01-.75-.75zm0 2.987a.75.75 0 01.75-.75h5.973a.75.75 0 010 1.5H7.485a.75.75 0 01-.75-.75zm9.919 1.46a.75.75 0 011.06 0l2.816 2.817a.75.75 0 010 1.06l-4.224 4.224a.75.75 0 01-.53.22H12.96a.75.75 0 01-.75-.75v-2.816a.75.75 0 01.22-.53l4.224-4.224zm-2.944 5.066v1.755h1.755l3.474-3.474-1.755-1.755-3.474 3.474zm-6.975-3.54a.75.75 0 01.75-.75h2.987a.75.75 0 010 1.5H7.485a.75.75 0 01-.75-.75z"
  }));
};

FileEdit02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileEdit02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Edit = function Edit(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.898 4.177a1.75 1.75 0 012.474-.001l2.45 2.447a1.75 1.75 0 01.001 2.475L9.587 19.341a1.75 1.75 0 01-.893.478l-4.546.916a.75.75 0 01-.883-.883l.918-4.541a1.75 1.75 0 01.477-.89L14.898 4.176zm1.414 1.06a.25.25 0 00-.353 0L5.72 15.48a.25.25 0 00-.068.128l-.694 3.434 3.44-.693a.25.25 0 00.127-.069L18.762 8.038a.25.25 0 000-.354l-2.45-2.447z"
  }));
};

Edit.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Edit.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CopyLeft = function CopyLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19.25c.69 0 1.25-.56 1.25-1.25v-6c0-.69-.56-1.25-1.25-1.25h-6c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h6zM20.75 18A2.75 2.75 0 0118 20.75h-6A2.75 2.75 0 019.25 18v-6A2.75 2.75 0 0112 9.25h6A2.75 2.75 0 0120.75 12v6zm-13-4a.75.75 0 01-.75.75H5A1.75 1.75 0 013.25 13V6A2.75 2.75 0 016 3.25h7c.966 0 1.75.784 1.75 1.75v2a.75.75 0 01-1.5 0V5a.25.25 0 00-.25-.25H6c-.69 0-1.25.56-1.25 1.25v7c0 .138.112.25.25.25h2a.75.75 0 01.75.75z"
  }));
};

CopyLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CopyLeft.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var CopyRight = function CopyRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19.25c.69 0 1.25-.56 1.25-1.25v-6c0-.69-.56-1.25-1.25-1.25h-6c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h6zM20.75 18A2.75 2.75 0 0118 20.75h-6A2.75 2.75 0 019.25 18v-6A2.75 2.75 0 0112 9.25h6A2.75 2.75 0 0120.75 12v6zm-13-4a.75.75 0 01-.75.75H5A1.75 1.75 0 013.25 13V6A2.75 2.75 0 016 3.25h7c.966 0 1.75.784 1.75 1.75v2a.75.75 0 01-1.5 0V5a.25.25 0 00-.25-.25H6c-.69 0-1.25.56-1.25 1.25v7c0 .138.112.25.25.25h2a.75.75 0 01.75.75z"
  }));
};

CopyRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CopyRight.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileMultiple = function FileMultiple(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45 5.6a2.35 2.35 0 012.35-2.35h6.046c.438 0 .847.184 1.139.491.229.241.582.602.915.9.303.271.76.74 1.02 1.009.28.289.43.673.43 1.069V15.2A2.35 2.35 0 0118 17.55h-2.45v.85a2.35 2.35 0 01-2.35 2.35H6a2.35 2.35 0 01-2.35-2.35V8.8A2.35 2.35 0 016 6.45h2.45V5.6zM6 7.95a.85.85 0 00-.85.85v9.6c0 .47.38.85.85.85h7.2c.47 0 .85-.38.85-.85v-1.59-.01V11.15H12.4a1.55 1.55 0 01-1.55-1.55V7.95H6zm3.95-1.5V5.6c0-.47.38-.85.85-.85h4.85V6.4c0 .856.694 1.55 1.55 1.55h1.65v7.25c0 .47-.38.85-.85.85h-2.45v-5.645-.005-.481c0-.396-.15-.78-.43-1.07-.26-.268-.717-.737-1.02-1.008a16.955 16.955 0 01-.915-.9 1.572 1.572 0 00-1.139-.491H9.95zm2.4 1.786V9.6c0 .028.023.05.05.05h1.406c-.24-.245-.517-.522-.706-.691-.264-.236-.531-.5-.75-.723zm6.256-1.786c-.24-.245-.518-.522-.706-.691-.264-.236-.531-.5-.75-.723V6.4c0 .028.023.05.05.05h1.406z"
  }));
};

FileMultiple.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileMultiple.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileNone = function FileNone(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.317 3.408a.75.75 0 011.053.132l.645.829a.748.748 0 01.54-.23h7.163c.462 0 .895.194 1.205.52.254.268.649.67 1.022 1.004.334.3.84.817 1.128 1.117.295.305.455.711.455 1.13v10.757a.747.747 0 01-.1.375l.386.498a.75.75 0 11-1.184.92l-12.444-16a.75.75 0 01.131-1.052zm11.71 13.834V9.194h-1.916a1.639 1.639 0 01-1.639-1.638V5.639h-5.47l9.026 11.604zM14.973 5.835v1.72c0 .077.062.14.14.14h1.76c-.291-.3-.679-.691-.928-.914-.352-.315-.71-.674-.972-.946zm-8.75 2.748a.75.75 0 01.75.75v8c0 .568.46 1.028 1.028 1.028h5.777a.75.75 0 010 1.5H8a2.528 2.528 0 01-2.528-2.528v-8a.75.75 0 01.75-.75z"
  }));
};

FileNone.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileNone.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FilePlus01 = function FilePlus01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.922 6a2.75 2.75 0 012.75-2.75h9A2.75 2.75 0 0118.422 6v5.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-9c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h4a.75.75 0 010 1.5h-4A2.75 2.75 0 013.922 18V6zM16.5 13.25a.75.75 0 01.75.75v2.078h2.078a.75.75 0 110 1.5H17.25v2.079a.75.75 0 11-1.5 0v-2.079h-2.078a.75.75 0 010-1.5h2.078V14a.75.75 0 01.75-.75z"
  }));
};

FilePlus01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FilePlus01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FilePlus02 = function FilePlus02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.922 6a2.75 2.75 0 012.75-2.75h9A2.75 2.75 0 0118.422 6v5.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-9c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h4a.75.75 0 010 1.5h-4A2.75 2.75 0 013.922 18V6zm3.5 2a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm0 3a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm0 3a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zm9.078-.75a.75.75 0 01.75.75v2.078h2.078a.75.75 0 110 1.5H17.25v2.079a.75.75 0 11-1.5 0v-2.079h-2.078a.75.75 0 010-1.5h2.078V14a.75.75 0 01.75-.75z"
  }));
};

FilePlus02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FilePlus02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileQuestion01 = function FileQuestion01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6A2.75 2.75 0 017.5 3.25h9A2.75 2.75 0 0119.25 6v3.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-9c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h5a.75.75 0 110 1.5h-5A2.75 2.75 0 014.75 18V6zm11.75 7.75c-.706 0-1.25.556-1.25 1.207a.75.75 0 01-1.5 0c0-1.51 1.247-2.707 2.75-2.707s2.75 1.196 2.75 2.707c0 1.51-1.247 2.706-2.75 2.706a.75.75 0 110-1.5c.706 0 1.25-.556 1.25-1.206 0-.651-.544-1.207-1.25-1.207zm0 5a.75.75 0 01.75.75v.075a.75.75 0 11-1.5 0V19.5a.75.75 0 01.75-.75z"
  }));
};

FileQuestion01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileQuestion01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileQuestion02 = function FileQuestion02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.283 5.99a2.74 2.74 0 012.74-2.74h8.959a2.74 2.74 0 012.74 2.74v3.484a.75.75 0 01-1.5 0V5.991a1.24 1.24 0 00-1.24-1.241H7.023a1.24 1.24 0 00-1.24 1.24v11.945c0 .685.555 1.24 1.24 1.24H12a.75.75 0 110 1.5H7.023a2.74 2.74 0 01-2.74-2.74V5.99zm3.484 1.991a.75.75 0 01.75-.75h5.972a.75.75 0 010 1.5H8.517a.75.75 0 01-.75-.75zm0 2.986a.75.75 0 01.75-.75h5.972a.75.75 0 010 1.5H8.517a.75.75 0 01-.75-.75zm9.21 3.164c-.701 0-1.24.551-1.24 1.197a.75.75 0 01-1.5 0c0-1.505 1.242-2.697 2.74-2.697 1.498 0 2.74 1.192 2.74 2.697 0 1.505-1.242 2.698-2.74 2.698a.75.75 0 010-1.5c.7 0 1.24-.552 1.24-1.198 0-.646-.54-1.197-1.24-1.197zm-9.21-.178a.75.75 0 01.75-.75h2.986a.75.75 0 010 1.5H8.516a.75.75 0 01-.75-.75zm9.21 5.222a.75.75 0 01.75.75V20a.75.75 0 01-1.5 0v-.075a.75.75 0 01.75-.75z"
  }));
};

FileQuestion02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileQuestion02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileX01 = function FileX01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6A2.75 2.75 0 017.5 3.25h9A2.75 2.75 0 0119.25 6v6.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-9c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25H11a.75.75 0 110 1.5H7.5A2.75 2.75 0 014.75 18V6zm9.22 9.47a.75.75 0 011.06 0l1.47 1.47 1.47-1.47a.75.75 0 011.06 1.06L17.56 18l1.47 1.47a.75.75 0 11-1.06 1.06l-1.47-1.47-1.47 1.47a.75.75 0 01-1.06-1.06L15.44 18l-1.47-1.47a.75.75 0 010-1.06z"
  }));
};

FileX01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileX01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FileX02 = function FileX02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6A2.75 2.75 0 017.5 3.25h9A2.75 2.75 0 0119.25 6v6.5a.75.75 0 01-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-9c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25H11a.75.75 0 110 1.5H7.5A2.75 2.75 0 014.75 18V6zm3.5 2A.75.75 0 019 7.25h6a.75.75 0 010 1.5H9A.75.75 0 018.25 8zm0 3a.75.75 0 01.75-.75h6a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zm0 3a.75.75 0 01.75-.75h3a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zm5.72 1.47a.75.75 0 011.06 0l1.47 1.47 1.47-1.47a.75.75 0 011.06 1.06L17.56 18l1.47 1.47a.75.75 0 11-1.06 1.06l-1.47-1.47-1.47 1.47a.75.75 0 01-1.06-1.06L15.44 18l-1.47-1.47a.75.75 0 010-1.06z"
  }));
};

FileX02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FileX02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Ticket01 = function Ticket01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.824 6.424A2.074 2.074 0 004.75 8.497v7.006c0 1.145.928 2.073 2.074 2.073h4.549a2.695 2.695 0 015.143 0h.66a2.074 2.074 0 002.074-2.073V8.497a2.074 2.074 0 00-2.073-2.073h-.66a2.695 2.695 0 01-5.144 0h-4.55zM3.25 8.497c0-1.973 1.6-3.573 3.574-3.573H12a.75.75 0 01.75.729 1.194 1.194 0 002.387 0 .75.75 0 01.75-.729h1.289c1.973 0 3.573 1.6 3.573 3.573v7.006c0 1.973-1.6 3.573-3.573 3.573h-1.289a.75.75 0 01-.75-.729 1.194 1.194 0 00-2.387 0 .75.75 0 01-.75.73H6.824a3.574 3.574 0 01-3.574-3.574V8.497zm10.527.496a.75.75 0 01.75.75v.144a.75.75 0 01-1.5 0v-.144a.75.75 0 01.75-.75zm0 2.215a.75.75 0 01.75.75v.144a.75.75 0 01-1.5 0v-.144a.75.75 0 01.75-.75zm0 2.225a.75.75 0 01.75.75v.143a.75.75 0 11-1.5 0v-.143a.75.75 0 01.75-.75z"
  }));
};

Ticket01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Ticket01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Ticket02 = function Ticket02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.824 6.424A2.074 2.074 0 004.75 8.497v7.006c0 1.145.928 2.073 2.074 2.073h4.549a2.695 2.695 0 015.143 0h.66a2.074 2.074 0 002.074-2.073V8.497a2.074 2.074 0 00-2.073-2.073h-.66a2.695 2.695 0 01-5.144 0h-4.55zM3.25 8.497c0-1.973 1.6-3.573 3.574-3.573H12a.75.75 0 01.75.729 1.194 1.194 0 002.387 0 .75.75 0 01.75-.729h1.289c1.973 0 3.573 1.6 3.573 3.573v7.006c0 1.973-1.6 3.573-3.573 3.573h-1.289a.75.75 0 01-.75-.729 1.194 1.194 0 00-2.387 0 .75.75 0 01-.75.73H6.824a3.574 3.574 0 01-3.574-3.574V8.497zm10.527.496a.75.75 0 01.75.75v4.375a.75.75 0 01-1.5 0V9.743a.75.75 0 01.75-.75z"
  }));
};

Ticket02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Ticket02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Menu01 = function Menu01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.355a.75.75 0 000 1.5h.842a.75.75 0 100-1.5H4zm0 5.895a.75.75 0 100 1.5h.842a.75.75 0 000-1.5H4zm0 5.895a.75.75 0 000 1.5h.842a.75.75 0 000-1.5H4zm3.368-11.79a.75.75 0 100 1.5H20a.75.75 0 000-1.5H7.368zm0 5.895a.75.75 0 100 1.5H20a.75.75 0 000-1.5H7.368zm0 5.895a.75.75 0 000 1.5H20a.75.75 0 000-1.5H7.368z"
  }));
};

Menu01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Menu01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Menu02 = function Menu02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 6A.75.75 0 014 5.25h16a.75.75 0 010 1.5H4A.75.75 0 013.25 6zm0 6a.75.75 0 01.75-.75h16a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h16a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75z"
  }));
};

Menu02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Menu02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Menu03 = function Menu03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 6A.75.75 0 014 5.25h16a.75.75 0 010 1.5H4A.75.75 0 013.25 6zm0 6a.75.75 0 01.75-.75h16a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h9.5a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75z"
  }));
};

Menu03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Menu03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Menu04 = function Menu04(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 6A.75.75 0 014 5.25h16a.75.75 0 010 1.5H4A.75.75 0 013.25 6zm0 6a.75.75 0 01.75-.75h16a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75zm6.5 6a.75.75 0 01.75-.75H20a.75.75 0 010 1.5h-9.5a.75.75 0 01-.75-.75z"
  }));
};

Menu04.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Menu04.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Trash01 = function Trash01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.074 3a.75.75 0 01.75-.75h6.353a.75.75 0 010 1.5H8.824a.75.75 0 01-.75-.75zM2.779 6.176a.75.75 0 01.75-.75h16.942a.75.75 0 010 1.5h-1.44c.022.125.03.253.025.385l-.483 11.588a2.868 2.868 0 01-2.867 2.851H8.294a2.868 2.868 0 01-2.867-2.85L4.944 7.31c-.006-.13.003-.26.024-.384H3.53a.75.75 0 01-.75-.75zm3.972.75a.309.309 0 00-.309.322l.484 11.619v.015c0 .756.613 1.368 1.368 1.368h7.412c.755 0 1.367-.612 1.367-1.368v-.015l.485-11.619a.309.309 0 00-.309-.322H6.751zm3.131 2.736a.75.75 0 01.75.75v6.353a.75.75 0 01-1.5 0v-6.353a.75.75 0 01.75-.75zm4.236 0a.75.75 0 01.75.75v6.353a.75.75 0 01-1.5 0v-6.353a.75.75 0 01.75-.75z"
  }));
};

Trash01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Trash01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Trash02 = function Trash02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.074 4.059c0-1 .81-1.809 1.808-1.809h4.236c.999 0 1.809.81 1.809 1.809v1.059c0 .105-.01.208-.027.308h4.57a.75.75 0 010 1.5h-1.393c.017.1.026.204.026.31v11.646a2.868 2.868 0 01-2.868 2.868h-8.47a2.868 2.868 0 01-2.868-2.868V7.235c0-.105.01-.208.026-.309H3.53a.75.75 0 010-1.5H8.1a1.821 1.821 0 01-.025-.308v-1.06zM6.706 6.926a.309.309 0 00-.309.31v11.646c0 .756.612 1.368 1.368 1.368h8.47c.756 0 1.368-.612 1.368-1.368V7.235a.309.309 0 00-.309-.309H6.706zM9.882 3.75a.309.309 0 00-.308.309v1.059c0 .17.138.308.308.308h4.236c.17 0 .309-.138.309-.308v-1.06a.309.309 0 00-.31-.308H9.883zm0 5.912a.75.75 0 01.75.75v6.353a.75.75 0 01-1.5 0v-6.353a.75.75 0 01.75-.75zm4.236 0a.75.75 0 01.75.75v6.353a.75.75 0 01-1.5 0v-6.353a.75.75 0 01.75-.75z"
  }));
};

Trash02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Trash02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Trash03 = function Trash03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.074 3a.75.75 0 01.75-.75h6.353a.75.75 0 010 1.5H8.824a.75.75 0 01-.75-.75zM2.779 6.176a.75.75 0 01.75-.75h16.942a.75.75 0 010 1.5h-1.44c.022.125.03.253.025.385l-.483 11.588a2.868 2.868 0 01-2.867 2.851H8.294a2.868 2.868 0 01-2.867-2.85L4.944 7.31c-.006-.13.003-.26.024-.384H3.53a.75.75 0 01-.75-.75zm3.972.75a.309.309 0 00-.309.322l.484 11.619v.015c0 .756.613 1.368 1.368 1.368h7.412c.755 0 1.367-.612 1.367-1.368v-.015l.485-11.619a.309.309 0 00-.309-.322H6.751z"
  }));
};

Trash03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Trash03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Trash04 = function Trash04(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.074 4.059c0-1 .81-1.809 1.808-1.809h4.236c.999 0 1.809.81 1.809 1.809v1.059c0 .105-.01.208-.027.308h4.571a.75.75 0 010 1.5h-1.394c.017.1.026.204.026.31v11.646a2.868 2.868 0 01-2.868 2.868h-8.47a2.868 2.868 0 01-2.868-2.868V7.235c0-.105.01-.208.026-.309H3.53a.75.75 0 010-1.5H8.1a1.82 1.82 0 01-.026-.308v-1.06zm1.808 1.367h4.236c.17 0 .309-.138.309-.308v-1.06a.309.309 0 00-.31-.308H9.883a.309.309 0 00-.308.309v1.059c0 .17.138.308.308.308zm-3.177 1.5a.309.309 0 00-.308.31v11.646c0 .756.612 1.368 1.368 1.368h8.47c.756 0 1.368-.612 1.368-1.368V7.235a.309.309 0 00-.308-.309H6.705z"
  }));
};

Trash04.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Trash04.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var SortVertical01 = function SortVertical01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.47 4.27a.75.75 0 011.06 0l3.6 3.6a.75.75 0 01-1.06 1.06L12 5.86 8.93 8.93a.75.75 0 01-1.06-1.06l3.6-3.6zm-3.6 10.8a.75.75 0 011.06 0L12 18.14l3.07-3.07a.75.75 0 011.06 1.06l-3.6 3.6a.75.75 0 01-1.06 0l-3.6-3.6a.75.75 0 010-1.06z"
  }));
};

SortVertical01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SortVertical01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var SortVertical02 = function SortVertical02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.425 5.85a.75.75 0 01.75.75v9.08l2.296-2.131a.75.75 0 011.02 1.1l-3.556 3.3a.75.75 0 01-1.03-.009L2.48 14.638a.75.75 0 011.04-1.08l2.155 2.077V6.6a.75.75 0 01.75-.75zm6.122 1.315a.75.75 0 01.75-.75H21a.75.75 0 010 1.5h-7.703a.75.75 0 01-.75-.75zm0 4.333a.75.75 0 01.75-.75H18.8a.75.75 0 110 1.5h-5.502a.75.75 0 01-.75-.75zm0 4.333a.75.75 0 01.75-.75H16.6a.75.75 0 010 1.5h-3.302a.75.75 0 01-.75-.75z"
  }));
};

SortVertical02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SortVertical02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Filter1 = function Filter1(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.319 3.436A.75.75 0 013 3h18a.75.75 0 01.57 1.238l-7.02 8.198v7.814a.75.75 0 01-1.082.672l-3.6-1.777a.75.75 0 01-.418-.673v-6.036L2.43 4.238a.75.75 0 01-.111-.802zM4.629 4.5l6.14 7.171a.75.75 0 01.181.488v5.847l2.1 1.037V12.16a.75.75 0 01.18-.488L19.37 4.5H4.63z"
  }));
};

Filter1.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Filter1.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var FilterFill = function FilterFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.092 3.332A1 1 0 013 2.75h18a1 1 0 01.76 1.65l-6.96 8.128v7.722a1 1 0 01-1.443.897l-3.6-1.778a1 1 0 01-.557-.897v-5.944L2.24 4.4a1 1 0 01-.148-1.068z"
  }));
};

FilterFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FilterFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Filter02 = function Filter02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 6.462a.75.75 0 01.75-.75h18a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75zM5.02 12a.75.75 0 01.75-.75h12.46a.75.75 0 010 1.5H5.77a.75.75 0 01-.75-.75zm4.153 5.538a.75.75 0 01.75-.75h4.154a.75.75 0 010 1.5H9.923a.75.75 0 01-.75-.75z"
  }));
};

Filter02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Filter02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var BarChartSquareDown01 = function BarChartSquareDown01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 3.75a1.5 1.5 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H5.25zm-3 1.5a3 3 0 013-3h13.5a3 3 0 013 3v13.5a3 3 0 01-3 3H5.25a3 3 0 01-3-3V5.25zm4.72 3.97a.75.75 0 011.06 0l2.845 2.844 2.282-2.282a.75.75 0 011.06 0l3.376 3.375a.75.75 0 11-1.06 1.06l-2.846-2.844-2.282 2.282a.75.75 0 01-1.06 0L6.97 10.28a.75.75 0 010-1.06z"
  }));
};

BarChartSquareDown01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BarChartSquareDown01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var BarChartSquareDown02 = function BarChartSquareDown02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 3.75a1.5 1.5 0 00-1.5 1.5v2.725a.75.75 0 01.887.102l3.097 2.896L9.8 9.041a.75.75 0 011.024 0l4.926 4.607v-2.364a.75.75 0 011.5 0v4.091a.75.75 0 01-.75.75h-4.375a.75.75 0 110-1.5H14.6l-4.287-4.009-2.066 1.932a.75.75 0 01-1.024 0L3.75 9.3v9.449a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H5.25zm-3 1.5a3 3 0 013-3h13.5a3 3 0 013 3v13.5a3 3 0 01-3 3H5.25a3 3 0 01-3-3V5.25z"
  }));
};

BarChartSquareDown02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BarChartSquareDown02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var BarChartSquareUp01 = function BarChartSquareUp01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 3.75a1.5 1.5 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H5.25zm-3 1.5a3 3 0 013-3h13.5a3 3 0 013 3v13.5a3 3 0 01-3 3H5.25a3 3 0 01-3-3V5.25zm15.625 3.97a.75.75 0 010 1.06L14.5 13.656a.75.75 0 01-1.061 0l-2.282-2.283-3.407 3.408a.75.75 0 01-1.061-1.061l3.938-3.938a.75.75 0 011.06 0l2.282 2.283 2.845-2.845a.75.75 0 011.06 0z"
  }));
};

BarChartSquareUp01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BarChartSquareUp01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var BarChartSquareUp02 = function BarChartSquareUp02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 3.75a1.5 1.5 0 00-1.5 1.5v9.449l3.472-3.247a.75.75 0 011.024 0l2.066 1.932L14.6 9.375h-2.474a.75.75 0 110-1.5H16.5a.75.75 0 01.75.75v4.091a.75.75 0 01-1.5 0v-2.364l-4.926 4.607a.75.75 0 01-1.024 0l-2.066-1.932-3.097 2.896a.75.75 0 01-.887.102v2.725a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H5.25zm-3 1.5a3 3 0 013-3h13.5a3 3 0 013 3v13.5a3 3 0 01-3 3H5.25a3 3 0 01-3-3V5.25z"
  }));
};

BarChartSquareUp02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BarChartSquareUp02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var BarGroup01 = function BarGroup01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.115 3.75a.25.25 0 00-.25.25v16.25H20a.25.25 0 00.25-.25V4a.25.25 0 00-.25-.25h-3.885zm-1.75 16.5v-9.226a.25.25 0 00-.25-.25h-4.059a.25.25 0 00-.25.25v5.584l.002.073-.001 3.569h4.558zm-6.059-5.303a1.772 1.772 0 00-.248-.017H4a1.75 1.75 0 00-1.75 1.75V20c0 .966.784 1.75 1.75 1.75h16A1.75 1.75 0 0021.75 20V4A1.75 1.75 0 0020 2.25h-3.885A1.75 1.75 0 0014.365 4v5.292a1.764 1.764 0 00-.25-.018h-4.059a1.75 1.75 0 00-1.75 1.75v3.924zm0 1.706v3.597H4a.25.25 0 01-.25-.25v-3.32a.25.25 0 01.25-.25h4.058a.25.25 0 01.248.223z"
  }));
};

BarGroup01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BarGroup01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var BarGroup02 = function BarGroup02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.885 3.75a.25.25 0 01.25.25v16.25H4a.25.25 0 01-.25-.25V4A.25.25 0 014 3.75h3.885zm1.75 16.5v-9.226a.25.25 0 01.25-.25h4.059a.25.25 0 01.25.25v5.584l-.002.073.001 3.569H9.635zm6.059-5.303c.08-.011.164-.017.248-.017H20c.966 0 1.75.784 1.75 1.75V20A1.75 1.75 0 0120 21.75H4A1.75 1.75 0 012.25 20V4c0-.966.784-1.75 1.75-1.75h3.885c.967 0 1.75.784 1.75 1.75v5.292c.082-.012.165-.018.25-.018h4.059c.966 0 1.75.784 1.75 1.75v3.924zm0 1.706v3.597H20a.25.25 0 00.25-.25v-3.32a.25.25 0 00-.25-.25h-4.058a.25.25 0 00-.248.223z"
  }));
};

BarGroup02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BarGroup02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var BarGroup03 = function BarGroup03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.915 3.75a.25.25 0 01.25.25v6.714l-.002.076.002 9.46h-4.5V4a.25.25 0 01.25-.25h4zm-5.75 10.576V4c0-.966.784-1.75 1.75-1.75h4c.967 0 1.75.784 1.75 1.75v5.057c.081-.011.164-.017.248-.017h4c.966 0 1.75.783 1.75 1.75V20a1.75 1.75 0 01-1.75 1.75H4.087A1.75 1.75 0 012.337 20v-3.942c0-.966.784-1.75 1.75-1.75h3.828c.085 0 .169.006.25.018zm0 1.732v4.192H4.087a.25.25 0 01-.25-.25v-3.942a.25.25 0 01.25-.25h3.828a.25.25 0 01.25.25zm7.5-5.297a.25.25 0 01.248-.221h4a.25.25 0 01.25.25V20a.25.25 0 01-.25.25h-4.248v-9.489z"
  }));
};

BarGroup03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BarGroup03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var LineChartDown01 = function LineChartDown01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25a.75.75 0 01.75.75v17.25H21a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75V3A.75.75 0 013 2.25zm3.97 3.595a.75.75 0 011.06 0l3.407 3.407L13.72 6.97a.75.75 0 011.06 0l5.471 5.47V9.477a.75.75 0 011.5 0v4.773A.75.75 0 0121 15h-4.773a.75.75 0 010-1.5h2.962l-4.94-4.94-2.281 2.283a.75.75 0 01-1.061 0L6.97 6.905a.75.75 0 010-1.06z"
  }));
};

LineChartDown01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LineChartDown01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var LineChartDown02 = function LineChartDown02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25a.75.75 0 01.75.75v17.25H21a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75V3A.75.75 0 013 2.25zm3.934 5.883a.75.75 0 011.058-.074l3.633 3.152 2.455-2.13a.75.75 0 01.983 0l5.304 4.603a.75.75 0 01-.984 1.133l-4.812-4.176-2.454 2.13a.75.75 0 01-.984 0L7.008 9.19a.75.75 0 01-.074-1.058z"
  }));
};

LineChartDown02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LineChartDown02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var LineChartUp01 = function LineChartUp01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25a.75.75 0 01.75.75v17.25H21a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75V3A.75.75 0 013 2.25zm12.477 4.125a.75.75 0 01.75-.75H21a.75.75 0 01.75.75v4.773a.75.75 0 01-1.5 0V8.185l-5.47 5.47a.75.75 0 01-1.06 0l-2.283-2.282L8.03 14.78a.75.75 0 11-1.06-1.06l3.937-3.938a.75.75 0 011.06 0l2.282 2.283 4.94-4.94h-2.962a.75.75 0 01-.75-.75z"
  }));
};

LineChartUp01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LineChartUp01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var LineChartUp02 = function LineChartUp02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25a.75.75 0 01.75.75v17.25H21a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75V3A.75.75 0 013 2.25zm16.843 5.282a.75.75 0 010 1.06l-5.063 5.063a.75.75 0 01-1.06 0l-2.283-2.282L8.03 14.78a.75.75 0 01-1.06-1.06l3.937-3.938a.75.75 0 011.06 0l2.283 2.283 4.532-4.533a.75.75 0 011.06 0z"
  }));
};

LineChartUp02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LineChartUp02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var PieChart01 = function PieChart01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66 6.72A8.217 8.217 0 003.75 12c0 2.008.718 3.849 1.91 5.28L10.94 12 5.66 6.72zm1.06-1.06l4.53 4.53V3.783A8.213 8.213 0 006.72 5.66zm6.03-1.876V12a.75.75 0 01-.22.53l-5.81 5.81a8.25 8.25 0 106.03-14.556zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12z"
  }));
};

PieChart01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
PieChart01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var PieChart02 = function PieChart02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.336 3a.75.75 0 01.75-.75 6.407 6.407 0 016.407 6.407v.435a.75.75 0 01-.75.75h-5.657a.75.75 0 01-.75-.75V3zm1.5.807v4.535h4.147a4.909 4.909 0 00-4.147-4.535zm-5.1 1.523a7.48 7.48 0 108.191 8.191h-7.441a.75.75 0 01-.75-.75v-7.44zm-8.229 7.441a8.979 8.979 0 018.979-8.978.75.75 0 01.75.75v7.478h7.478a.75.75 0 01.75.75 8.978 8.978 0 11-17.957 0z"
  }));
};

PieChart02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
PieChart02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var PieChart03 = function PieChart03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.083 21.5a9.75 9.75 0 119.75-9.93.819.819 0 010 .36 9.77 9.77 0 01-9.75 9.57zm-5.28-3.41a8.25 8.25 0 0013.49-5.59h-7.88l-5.61 5.59zm4.53-14.56a8.25 8.25 0 00-5.59 13.5l5.59-5.59V3.53zm1.5 7.47h7.46a8.26 8.26 0 00-7.46-7.47V11z"
  }));
};

PieChart03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
PieChart03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var TrendDown01 = function TrendDown01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.77 16.5c0 .414.336.75.75.75H21a.75.75 0 00.75-.75v-6.23a.75.75 0 00-1.5 0v4.468l-7.37-7.086a.75.75 0 00-1.04 0l-3.8 3.654-4.52-4.347a.75.75 0 10-1.04 1.082l5.04 4.846c.29.279.75.279 1.04 0l3.8-3.654 6.778 6.517H14.52a.75.75 0 00-.75.75z"
  }));
};

TrendDown01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TrendDown01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var TrendUp01 = function TrendUp01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.938 7.2a.75.75 0 01.75-.75H21.6a.75.75 0 01.75.75v6.646a.75.75 0 01-1.5 0V8.962l-7.946 7.64a.75.75 0 01-1.04 0l-4.088-3.93L2.92 17.34a.75.75 0 11-1.04-1.082l5.376-5.169a.75.75 0 011.04 0l4.088 3.931 7.354-7.071h-5.05a.75.75 0 01-.75-.75z"
  }));
};

TrendUp01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TrendUp01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var SmileyHappy = function SmileyHappy(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm6.3-2.7a.75.75 0 01.75-.75h.09a.75.75 0 01.75.75v.072a.75.75 0 01-.75.75H9.3a.75.75 0 01-.75-.75V9.3zm5.4 0a.75.75 0 01.75-.75h.08a.75.75 0 01.75.75v.072a.75.75 0 01-.75.75h-.08a.75.75 0 01-.75-.75V9.3zm-5.465 4.799a.75.75 0 011.033.243c.528.854 1.447 1.408 2.482 1.408 1.035 0 1.954-.554 2.482-1.408a.75.75 0 011.276.79c-.784 1.265-2.17 2.118-3.758 2.118-1.589 0-2.974-.853-3.758-2.118a.75.75 0 01.243-1.033z"
  }));
};

SmileyHappy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SmileyHappy.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var SmileyHappyPlus = function SmileyHappyPlus(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.395 2.66a.75.75 0 01.75.75V5.37H21a.75.75 0 010 1.5h-1.855V8.81a.75.75 0 01-1.5 0V6.87h-1.9a.75.75 0 010-1.5h1.9V3.41a.75.75 0 01.75-.75zM2.25 13.288c0-4.437 3.546-8.053 7.944-8.053.955 0 1.872.171 2.722.485.459.17.72.58.78.98.276 1.86 1.617 3.358 3.361 3.845.398.11.764.428.872.898.138.593.21 1.21.21 1.845 0 4.436-3.546 8.052-7.945 8.052-4.398 0-7.944-3.616-7.944-8.052zm7.944-6.553c-3.548 0-6.444 2.923-6.444 6.553 0 3.629 2.896 6.552 6.444 6.552 3.55 0 6.445-2.923 6.445-6.552 0-.461-.047-.91-.135-1.343-2.196-.674-3.866-2.555-4.269-4.874a6.34 6.34 0 00-2.04-.336zm-2.847 3.99a.75.75 0 01.75-.75h.074a.75.75 0 01.75.75v.06a.75.75 0 01-.75.75h-.074a.75.75 0 01-.75-.75v-.06zm4.478 0a.75.75 0 01.75-.75h.066a.75.75 0 01.75.75v.06a.75.75 0 01-.75.75h-.066a.75.75 0 01-.75-.75v-.06zm-4.433 3.373a.75.75 0 011.03.25c.42.69 1.143 1.128 1.947 1.128.805 0 1.528-.438 1.947-1.127a.75.75 0 011.282.78c-.67 1.099-1.858 1.847-3.229 1.847-1.37 0-2.559-.748-3.228-1.847a.75.75 0 01.25-1.03z"
  }));
};

SmileyHappyPlus.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SmileyHappyPlus.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var SmileyNeutral = function SmileyNeutral(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm6.3-2.7a.75.75 0 01.75-.75h.09a.75.75 0 01.75.75v.072a.75.75 0 01-.75.75H9.3a.75.75 0 01-.75-.75V9.3zm5.4 0a.75.75 0 01.75-.75h.08a.75.75 0 01.75.75v.072a.75.75 0 01-.75.75h-.08a.75.75 0 01-.75-.75V9.3zm-5.82 5.437a.75.75 0 01.75-.75h6.24a.75.75 0 110 1.5H8.88a.75.75 0 01-.75-.75z"
  }));
};

SmileyNeutral.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SmileyNeutral.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var SmileySad = function SmileySad(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm6.3-2.7a.75.75 0 01.75-.75h.09a.75.75 0 01.75.75v.072a.75.75 0 01-.75.75H9.3a.75.75 0 01-.75-.75V9.3zm5.4 0a.75.75 0 01.75-.75h.08a.75.75 0 01.75.75v.072a.75.75 0 01-.75.75h-.08a.75.75 0 01-.75-.75V9.3zM12 15.004c-1.035 0-1.954.553-2.482 1.408a.75.75 0 01-1.276-.79c.784-1.266 2.17-2.118 3.758-2.118 1.589 0 2.974.852 3.758 2.118a.75.75 0 01-1.276.79c-.529-.855-1.447-1.408-2.482-1.408z"
  }));
};

SmileySad.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SmileySad.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var SmileyWink = function SmileyWink(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm5.063-2.813a.75.75 0 01.75-.75h1.873a.75.75 0 010 1.5H8.063a.75.75 0 01-.75-.75zm6.637 0a.75.75 0 01.75-.75h.08a.75.75 0 01.75.75v.073a.75.75 0 01-.75.75h-.08a.75.75 0 01-.75-.75v-.072zm-5.465 4.8a.75.75 0 011.033.242c.528.855 1.447 1.408 2.482 1.408 1.035 0 1.953-.553 2.482-1.408a.75.75 0 111.276.79c-.784 1.266-2.17 2.118-3.758 2.118-1.589 0-2.974-.852-3.758-2.118a.75.75 0 01.243-1.033z"
  }));
};

SmileyWink.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SmileyWink.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var UserProfile01 = function UserProfile01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75A2.625 2.625 0 1012 9a2.625 2.625 0 000-5.25zM7.875 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zm-4.5 11.25A4.125 4.125 0 017.502 13.5H16.5a4.125 4.125 0 014.125 4.125V21a.75.75 0 11-1.5 0v-3.375A2.625 2.625 0 0016.5 15h-9a2.625 2.625 0 00-2.624 2.625V21a.75.75 0 01-1.5 0v-3.375z"
  }));
};

UserProfile01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
UserProfile01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var UserProfile02 = function UserProfile02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75A2.625 2.625 0 1012 9a2.625 2.625 0 000-5.25zM7.875 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zm-3.1 8.481c1.664-1.292 4.093-2.035 7.225-2.035 3.132 0 5.561.743 7.226 2.035 1.681 1.305 2.524 3.127 2.524 5.124 0 .901-.674 1.77-1.668 1.77H3.918c-.994 0-1.668-.869-1.668-1.77 0-1.997.843-3.82 2.524-5.124zm.919 1.185c-1.308 1.015-1.944 2.397-1.944 3.94 0 .098.036.174.076.219.04.043.073.05.092.05h16.164c.02 0 .053-.007.092-.05a.327.327 0 00.076-.22c0-1.542-.636-2.924-1.944-3.939-1.324-1.028-3.395-1.72-6.306-1.72s-4.982.692-6.306 1.72z"
  }));
};

UserProfile02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
UserProfile02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var UserProfile03 = function UserProfile03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.047a2.948 2.948 0 100 5.895 2.948 2.948 0 000-5.895zM7.552 7.994a4.448 4.448 0 118.896 0 4.448 4.448 0 01-8.896 0zM2.357 19.318c1.547-2.581 4.84-4.19 9.643-4.19 4.802 0 8.096 1.609 9.643 4.19a.75.75 0 11-1.286.771c-1.175-1.96-3.85-3.46-8.357-3.46-4.508 0-7.181 1.5-8.357 3.46a.75.75 0 11-1.286-.771z"
  }));
};

UserProfile03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
UserProfile03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var UserProfileAdd = function UserProfileAdd(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.875 3.75a2.625 2.625 0 100 5.25 2.625 2.625 0 000-5.25zM6.75 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zm11.719 5.719a.75.75 0 01.75.75v1.781H21a.75.75 0 010 1.5h-1.781v1.781a.75.75 0 01-1.5 0v-1.781h-1.782a.75.75 0 010-1.5h1.782v-1.781a.75.75 0 01.75-.75zM2.25 17.624A4.125 4.125 0 016.375 13.5h6.188a.75.75 0 010 1.5H6.375a2.625 2.625 0 00-2.625 2.625V21a.75.75 0 01-1.5 0v-3.375z"
  }));
};

UserProfileAdd.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
UserProfileAdd.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var UserProfileCheck = function UserProfileCheck(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.875 3.75a2.625 2.625 0 100 5.25 2.625 2.625 0 000-5.25zM6.75 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zm-4.5 11.25A4.125 4.125 0 016.375 13.5h6.75a.75.75 0 010 1.5h-6.75a2.625 2.625 0 00-2.625 2.625V21a.75.75 0 01-1.5 0v-3.375zm18.22-3.905a.75.75 0 111.06 1.06l-3.937 3.938a.75.75 0 01-1.06 0l-1.126-1.125a.75.75 0 111.06-1.06l.596.594 3.407-3.407z"
  }));
};

UserProfileCheck.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
UserProfileCheck.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var UserProfileSquare = function UserProfileSquare(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 3.75c-.793 0-1.5.688-1.5 1.618v13.264c0 .625.32 1.14.769 1.411a.753.753 0 01-.019-.168v-1.688a3 3 0 013-3h9a3 3 0 013 3v1.845c.44-.274.75-.784.75-1.4V5.368c0-.93-.707-1.618-1.5-1.618H5.25zM18 20.25v-2.063a1.5 1.5 0 00-1.5-1.5h-9a1.5 1.5 0 00-1.5 1.5v1.688a.747.747 0 01-.1.375H18zM2.25 5.368c0-1.685 1.307-3.118 3-3.118h13.5c1.693 0 3 1.433 3 3.118v13.264c0 1.685-1.307 3.118-3 3.118H5.25c-1.693 0-3-1.433-3-3.118V5.368zM12 7.125a2.062 2.062 0 100 4.125 2.062 2.062 0 000-4.125zM8.437 9.187a3.563 3.563 0 117.126 0 3.563 3.563 0 01-7.126 0z"
  }));
};

UserProfileSquare.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
UserProfileSquare.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var UsersProfiles01 = function UsersProfiles01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45 4.715a2.263 2.263 0 100 4.526 2.263 2.263 0 000-4.526zM5.687 6.978a3.763 3.763 0 117.526 0 3.763 3.763 0 01-7.526 0zM14.59 4.11a.75.75 0 011.05-.156 3.759 3.759 0 011.522 3.024c0 1.24-.6 2.34-1.523 3.024a.75.75 0 01-.894-1.205 2.259 2.259 0 00.917-1.819c0-.745-.359-1.405-.917-1.819a.75.75 0 01-.155-1.05zM2.251 17.022a3.763 3.763 0 013.763-3.763h6.747a3.763 3.763 0 013.763 3.763v3.013a.75.75 0 11-1.5 0v-3.013a2.263 2.263 0 00-2.263-2.263H6.014a2.263 2.263 0 00-2.264 2.263v3.013a.75.75 0 11-1.5 0v-3.014zm14.986-3.013a.75.75 0 01.75-.75 3.763 3.763 0 013.763 3.763v3.013a.75.75 0 11-1.5 0v-3.013a2.263 2.263 0 00-2.263-2.263.75.75 0 01-.75-.75z"
  }));
};

UsersProfiles01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
UsersProfiles01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var UsersProfiles02 = function UsersProfiles02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.857 5.893a1.821 1.821 0 100 3.643 1.821 1.821 0 000-3.643zM6.536 7.714a3.321 3.321 0 116.643 0 3.321 3.321 0 01-6.643 0zm8.19-2.603a.75.75 0 011.024-.273 3.32 3.32 0 010 5.753.75.75 0 11-.75-1.299 1.82 1.82 0 000-3.156.75.75 0 01-.274-1.025zM4.242 14.035c1.31-1.016 3.203-1.588 5.615-1.588 2.412 0 4.306.572 5.615 1.588 1.325 1.028 1.992 2.47 1.992 4.045 0 .767-.576 1.527-1.449 1.527H3.7c-.873 0-1.449-.76-1.449-1.527 0-1.575.667-3.017 1.992-4.045zm.92 1.185c-.952.739-1.412 1.739-1.412 2.86 0 .011.001.02.003.027h12.208a.104.104 0 00.003-.027c0-1.121-.46-2.121-1.412-2.86-.968-.752-2.503-1.273-4.695-1.273s-3.726.521-4.695 1.273zm12.987-2.089a.75.75 0 011.05-.152c.726.543 1.353 1.44 1.795 2.337.44.896.756 1.917.756 2.764 0 .767-.576 1.527-1.45 1.527h-.425a.75.75 0 010-1.5h.372a.109.109 0 00.003-.027c0-.53-.215-1.315-.602-2.102-.387-.787-.885-1.452-1.347-1.797a.75.75 0 01-.152-1.05z"
  }));
};

UsersProfiles02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
UsersProfiles02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var UsersProfiles03 = function UsersProfiles03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81 6.922a2.048 2.048 0 100 4.095 2.048 2.048 0 000-4.095zM6.261 8.969a3.548 3.548 0 117.095 0 3.548 3.548 0 01-7.095 0zm8.408-2.82a.75.75 0 011.015-.306 3.547 3.547 0 01.096 6.199.75.75 0 01-.751-1.299 2.046 2.046 0 00-.055-3.579.75.75 0 01-.305-1.015zm1.93 7.147a.75.75 0 011.005-.335c.978.489 1.752.998 2.41 1.656.658.657 1.167 1.432 1.656 2.41a.75.75 0 11-1.342.67c-.444-.887-.867-1.512-1.375-2.02s-1.132-.93-2.02-1.374a.75.75 0 01-.335-1.007zM2.356 17.442c1.216-2.028 3.783-3.258 7.452-3.258 3.67 0 6.237 1.23 7.453 3.258a.75.75 0 01-1.287.772c-.844-1.408-2.791-2.53-6.166-2.53-3.374 0-5.322 1.122-6.166 2.53a.75.75 0 11-1.286-.771z"
  }));
};

UsersProfiles03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
UsersProfiles03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var MessageNotifySquare = function MessageNotifySquare(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.294 3.75a2.426 2.426 0 100 4.853 2.426 2.426 0 000-4.853zm-3.926 2.426a3.927 3.927 0 117.853 0 3.927 3.927 0 01-7.853 0zM5.648 4.81c-.756 0-1.369.612-1.369 1.367v8.287c0 .755.613 1.368 1.368 1.368h1.657a.75.75 0 01.75.75v2.608l3.14-3.139a.75.75 0 01.53-.22h6.629c.755 0 1.368-.612 1.368-1.367V12a.75.75 0 011.5 0v2.463a2.868 2.868 0 01-2.868 2.868h-6.319l-4.2 4.2A.75.75 0 016.555 21v-3.67h-.907a2.868 2.868 0 01-2.868-2.867V6.176A2.868 2.868 0 015.647 3.31h5.294a.75.75 0 010 1.5H5.647z"
  }));
};

MessageNotifySquare.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MessageNotifySquare.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var MessageChat = function MessageChat(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.25c-.69 0-1.25.56-1.25 1.25v7.826c0 .69.56 1.25 1.25 1.25h1.565a.75.75 0 01.75.75v2.363l2.894-2.893a.744.744 0 01.041-.038V12.5A2.75 2.75 0 0113 9.75h5.25V5.5c0-.69-.56-1.25-1.25-1.25H5zm14.75 5.604V5.5A2.75 2.75 0 0017 2.75H5A2.75 2.75 0 002.25 5.5v7.826A2.75 2.75 0 005 16.076h.815V19.5a.75.75 0 001.28.53l3.289-3.288a2.751 2.751 0 002.616 1.9h2.852l2.39 2.388a.75.75 0 001.28-.53v-1.908a2.751 2.751 0 002.228-2.7V12.5c0-1.259-.846-2.32-2-2.646zm-8 6.037c0 .69.56 1.25 1.25 1.25h3.163a.75.75 0 01.53.22l1.329 1.328v-.798a.75.75 0 01.75-.75H19c.69 0 1.25-.56 1.25-1.25V12.5c0-.69-.56-1.25-1.25-1.25h-6c-.69 0-1.25.56-1.25 1.25v3.391z"
  }));
};

MessageChat.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MessageChat.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Annotation = function Annotation(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v9.304c0 .69.56 1.25 1.25 1.25h4.75a.75.75 0 01.676.426l1.602 3.343 1.752-3.365a.75.75 0 01.666-.404H19c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5zM2.25 5A2.75 2.75 0 015 2.25h14A2.75 2.75 0 0121.75 5v9.304a2.75 2.75 0 01-2.75 2.75h-4.1l-2.235 4.293a.75.75 0 01-1.341-.023l-2.046-4.27H5a2.75 2.75 0 01-2.75-2.75V5z"
  }));
};

Annotation.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Annotation.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AnnotationTyping = function AnnotationTyping(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 3.75a1.5 1.5 0 00-1.5 1.5v8.804a1.5 1.5 0 001.5 1.5h4.5a.75.75 0 01.676.426l1.602 3.343 1.752-3.365a.75.75 0 01.666-.404h4.304a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H5.25zm-3 1.5a3 3 0 013-3h13.5a3 3 0 013 3v8.804a3 3 0 01-3 3H14.9l-2.235 4.293a.75.75 0 01-1.341-.023l-2.046-4.27H5.25a3 3 0 01-3-3V5.25zM7.5 9a.75.75 0 01.75.75v.085a.75.75 0 01-1.5 0V9.75A.75.75 0 017.5 9zM12 9a.75.75 0 01.75.75v.085a.75.75 0 01-1.5 0V9.75A.75.75 0 0112 9zm4.5 0a.75.75 0 01.75.75v.085a.75.75 0 01-1.5 0V9.75A.75.75 0 0116.5 9z"
  }));
};

AnnotationTyping.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AnnotationTyping.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AnnotationAlert = function AnnotationAlert(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 3.75a1.5 1.5 0 00-1.5 1.5v8.804a1.5 1.5 0 001.5 1.5h4.5a.75.75 0 01.676.426l1.602 3.343 1.752-3.365a.75.75 0 01.666-.404h4.304a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H5.25zm-3 1.5a3 3 0 013-3h13.5a3 3 0 013 3v8.804a3 3 0 01-3 3H14.9l-2.235 4.293a.75.75 0 01-1.341-.023l-2.046-4.27H5.25a3 3 0 01-3-3V5.25zm9.75.375a.75.75 0 01.75.75V9.75a.75.75 0 01-1.5 0V6.375a.75.75 0 01.75-.75zm0 6.665a.75.75 0 01.75.75v.085a.75.75 0 01-1.5 0v-.085a.75.75 0 01.75-.75z"
  }));
};

AnnotationAlert.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AnnotationAlert.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Inbox01 = function Inbox01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 3.75a1.5 1.5 0 00-1.5 1.5v8.25H7.5a.75.75 0 01.543.233l1.278 1.342h5.358l1.278-1.342a.75.75 0 01.543-.233h3.75V5.25a1.5 1.5 0 00-1.5-1.5H5.25zm16.5 1.5a3 3 0 00-3-3H5.25a3 3 0 00-3 3v13.5a3 3 0 003 3h13.5a3 3 0 003-3V5.25zM20.25 15h-3.429l-1.278 1.342a.75.75 0 01-.543.233H9a.75.75 0 01-.543-.233L7.179 15H3.75v3.75a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V15z"
  }));
};

Inbox01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Inbox01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Inbox02 = function Inbox02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.125 5.322a3 3 0 012.81-1.947h8.13a3 3 0 012.81 1.947l2.827 7.54a.75.75 0 01.048.263v4.5a3 3 0 01-3 3H5.25a3 3 0 01-3-3v-4.5c0-.09.016-.18.048-.263l2.827-7.54zm2.81-.447a1.5 1.5 0 00-1.405.973l-2.448 6.527H7.5a.75.75 0 01.543.233l1.278 1.342h5.358l1.278-1.342a.75.75 0 01.543-.233h3.418L17.47 5.848a1.5 1.5 0 00-1.404-.973H7.934zm12.315 9h-3.429l-1.278 1.342a.75.75 0 01-.543.233H9a.75.75 0 01-.543-.233l-1.278-1.342H3.75v3.75a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-3.75z"
  }));
};

Inbox02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Inbox02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Box = function Box(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.113 3.597a2.437 2.437 0 012.18-1.347h11.414c.923 0 1.767.522 2.18 1.347l1.546 3.093a3 3 0 01.317 1.341V18.75a3 3 0 01-3 3H5.25a3 3 0 01-3-3V8.031a3 3 0 01.317-1.341l1.546-3.093zM3.75 8.25v10.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V8.25H3.75zm16.037-1.5H4.213l1.24-2.482a.937.937 0 01.839-.518h11.414c.355 0 .68.2.839.518l1.24 2.482zm-11.35 3.844a.75.75 0 01.75-.75v1.5a.75.75 0 01-.75-.75zm.75 0v.75h5.625a.75.75 0 000-1.5H9.187v.75z"
  }));
};

Box.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Box.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Mail01 = function Mail01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.814 7.164a1.5 1.5 0 00-.064.434v8.804a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V7.598c0-.045-.002-.09-.006-.134l-7.858 4.714a.75.75 0 01-.792-.012l-7.78-5.002zm1.155-1.04l7.045 4.529 7.363-4.418a1.494 1.494 0 00-.627-.137H5.25c-.096 0-.19.009-.28.026zM2.25 7.598a3 3 0 013-3h13.5a3 3 0 013 3v8.804a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.598z"
  }));
};

Mail01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Mail01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Mail02 = function Mail02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.602 3.024a.75.75 0 01.766-.017l8.426 4.74c.59.332.956.956.956 1.634v8.709a3 3 0 01-3 3H5.25a3 3 0 01-3-3V9.909c0-.647.333-1.247.881-1.59l8.471-5.295zM3.75 18.09a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.296l-7.83 5.3a.75.75 0 01-.83.008l-.366-.239a522.164 522.164 0 00-3.957-2.539c-1.095-.694-2.2-1.386-3.058-1.903l-.459-.274v6.943zm.238-8.538c.274.154.614.354.995.584.873.526 1.99 1.225 3.087 1.921a466.363 466.363 0 013.921 2.516l8.111-5.49a.375.375 0 00-.043-.029L12.02 4.532l-8.032 5.02z"
  }));
};

Mail02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Mail02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Mail03 = function Mail03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81 7.179a1.5 1.5 0 00-.06.419v8.804c0 .188.034.367.097.533l4.805-4.894a.75.75 0 111.07 1.051l-4.704 4.792c.075.012.153.018.232.018h13.5c.21 0 .41-.043.59-.12l-5.597-5.131a.748.748 0 01-.164-.218l-1.136.832a.75.75 0 01-.906-.015L3.809 7.18zm1.1-1.043l7.106 5.583 7.43-5.45a1.493 1.493 0 00-.696-.171H5.25c-.117 0-.23.013-.34.038zM20.25 7.541l-5.478 4.017 5.47 5.014c.006-.056.009-.112.009-.17V7.598l-.001-.057zM2.25 7.598a3 3 0 013-3h13.5a3 3 0 013 3v8.804a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.598z"
  }));
};

Mail03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Mail03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Bell = function Bell(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75c-3.466 0-6.324 2.928-6.324 6.602v.008l-.026 2.181c0 1.613-.608 2.954-1.255 3.89h15.21c-.621-.938-1.203-2.28-1.203-3.894v-.01l.026-2.071C18.426 6.724 15.522 3.75 12 3.75zm-7.824 6.597C4.18 5.902 7.654 2.25 12 2.25c4.405 0 7.928 3.703 7.928 8.21v.01l-.026 2.071c.001 1.324.51 2.434 1.045 3.197l-.51.357.51-.356c.31.443.283.978.127 1.359-.155.378-.543.834-1.17.834H4.097c-.639 0-1.026-.47-1.177-.85-.152-.385-.177-.929.147-1.373l.603.44-.603-.44c.56-.765 1.082-1.866 1.082-3.172v-.009l.026-2.18zm4.414 9.291a.75.75 0 011.05-.145c.612.463 1.437.757 2.36.757.923 0 1.748-.294 2.36-.757a.75.75 0 01.905 1.196c-.881.667-2.027 1.061-3.265 1.061s-2.384-.394-3.265-1.061a.75.75 0 01-.145-1.05z"
  }));
};

Bell.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Bell.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var BellOff = function BellOff(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.259 2.391a.75.75 0 011.046.171l12.177 16.942a.75.75 0 01-1.218.875l-1.678-2.335H4.612c-.639 0-1.011-.482-1.151-.846-.144-.373-.169-.902.14-1.338.524-.74 1.016-1.806 1.016-3.074v-.009l.025-2.116a8.177 8.177 0 011.633-4.937.747.747 0 01.29-.231L5.086 3.438A.75.75 0 015.26 2.39zm2.166 4.3a6.683 6.683 0 00-1.283 3.974v.009l-.025 2.116c0 1.55-.562 2.843-1.166 3.754h9.556L7.426 6.691zm4.624-2.412c-.354 0-.7.034-1.035.098a.75.75 0 01-.282-1.473 7.012 7.012 0 011.317-.125c4.194 0 7.506 3.628 7.506 7.991v.009l-.024 2.011c.001 1.285.48 2.361.981 3.1a.75.75 0 01-1.24.843c-.625-.92-1.241-2.286-1.241-3.947v-.01l.024-2.01c-.002-3.633-2.738-6.487-6.006-6.487zM8.811 19.656a.75.75 0 011.053-.13c.567.444 1.332.724 2.185.724.854 0 1.618-.28 2.186-.723a.75.75 0 01.923 1.182c-.837.654-1.928 1.041-3.109 1.041-1.18 0-2.271-.387-3.108-1.041a.75.75 0 01-.13-1.053z"
  }));
};

BellOff.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BellOff.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Phone = function Phone(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.837 3.866L4.28 5.42a1.355 1.355 0 00-.417.894c-.057.693.066 1.468.47 2.545v.003c.66 1.775 1.658 3.445 3.182 5.278a19.659 19.659 0 006.531 5.106c.935.446 2.094.923 3.308 1l.002.001c.04.003.088.003.162.003.513 0 .857-.151 1.17-.481.173-.2.547-.581.857-.891l.434-.433.08-.079c.026-.071.055-.162.073-.256a.564.564 0 00.012-.235l-2.527-2.521a.702.702 0 01-.024-.025.432.432 0 00-.108-.088.678.678 0 00-.163.122l-.901.899-.006.005c-.103.103-.53.53-1.223.53a1.746 1.746 0 01-.905-.259 5.223 5.223 0 00-.395-.21l-.01-.005c-.178-.089-.4-.2-.62-.339-1.548-.976-2.94-2.243-4.246-3.846a.765.765 0 01-.028-.033c-.727-.921-1.228-1.724-1.589-2.595a.745.745 0 01-.018-.05l-.017-.052a1.862 1.862 0 01-.09-.783c.04-.344.192-.68.482-.983.038-.043.07-.07.084-.082l.002-.002a7.85 7.85 0 01.264-.229l.057-.058.124-.127a14.184 14.184 0 00.257-.256l.145-.145a.667.667 0 00.14-.18.667.667 0 00-.14-.18l-1.263-1.26-.215-.22H7.21a39.1 39.1 0 01-.22-.225 22.466 22.466 0 00-.82-.812l-.013-.014a.527.527 0 00-.113-.089.148.148 0 00-.029-.012c-.014.003-.075.02-.178.115zm14.856 14.928l.675.327.002-.004.002-.005.007-.015.021-.047a3.186 3.186 0 00.205-.656c.067-.347.133-1.051-.388-1.567l-.001-.002-2.528-2.522c-.203-.218-.619-.565-1.203-.565-.6 0-1.033.373-1.223.563l-.901.899a.437.437 0 01-.088.073.15.15 0 01-.08.024.23.23 0 01-.102-.027l-.013-.007a.774.774 0 00-.02-.012c-.158-.096-.333-.183-.48-.257l-.016-.008a5.625 5.625 0 01-.499-.27c-1.396-.88-2.675-2.039-3.9-3.545a.771.771 0 00-.014-.017c-.653-.83-1.064-1.502-1.354-2.194l-.003-.01a.398.398 0 01-.028-.152.09.09 0 01.01-.032.373.373 0 01.08-.102 6.2 6.2 0 01.175-.15l.01-.008a1.118 1.118 0 00.134-.123l.003-.003a37.703 37.703 0 00.176-.18c.092-.088.187-.184.275-.273l.121-.122c.315-.314.586-.728.586-1.242 0-.513-.271-.927-.586-1.241l-1.25-1.248-.218-.222-.002-.002a37.454 37.454 0 01-.212-.217m-.845-.838l-.005-.005c-.194-.193-.61-.54-1.2-.54-.487 0-.9.237-1.212.528a.754.754 0 00-.017.017L3.22 4.359a2.852 2.852 0 00-.852 1.828v.003c-.08.985.109 1.99.56 3.194.729 1.966 1.825 3.78 3.434 5.716l.003.003a21.157 21.157 0 007.03 5.495l.004.001c.968.462 2.344 1.048 3.858 1.145l.05-.749-.049.749c.093.006.188.006.252.006h.008c.915 0 1.663-.313 2.275-.966a89.586 89.586 0 011.242-1.273l.134-.133.049-.048a.751.751 0 00.15-.21l-.675-.326"
  }));
};

Phone.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Phone.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Send01 = function Send01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.973 5.088l-8.511 8.511.015.038 2.472 6.317c.157.403.73.392.872-.017l5.152-14.85zm-9.996 8.937c.044.045.08.099.103.159l2.472 6.317c.665 1.7 3.088 1.653 3.686-.072l5.401-15.568c.538-1.55-.95-3.038-2.5-2.5L3.57 7.76c-1.725.6-1.772 3.022-.072 3.687l6.317 2.472c.061.024.116.06.16.105zm.424-1.486l8.511-8.512L4.062 9.18a.465.465 0 00-.017.872l6.318 2.472.038.016z"
  }));
};

Send01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Send01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Send02 = function Send02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.297 7.607c-.596-1.363.827-2.732 2.165-2.083l10.386 5.036c1.203.583 1.203 2.297 0 2.88l-10.385 5.036c-1.339.649-2.762-.72-2.166-2.082l1.905-4.353.01.004-.01-.005a.1.1 0 000-.08L8.297 7.607zm3.232 5.143l-1.857 4.245c-.015.033-.012.05-.01.06a.111.111 0 00.032.053.11.11 0 00.054.03c.01.002.028.004.06-.012l9.026-4.376h-7.305zm7.305-1.5h-7.305L9.672 7.005c-.015-.033-.012-.05-.01-.06a.11.11 0 01.032-.053.11.11 0 01.054-.03c.01-.002.028-.004.06.012l9.026 4.376zM4.13 8.963a.75.75 0 01.75-.75h1.907a.75.75 0 110 1.5H4.88a.75.75 0 01-.75-.75zm-1.88 3.152a.75.75 0 01.75-.75h3.787a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75zm1.88 3.152a.75.75 0 01.75-.75h1.907a.75.75 0 010 1.5H4.88a.75.75 0 01-.75-.75z"
  }));
};

Send02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Send02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Paperclip = function Paperclip(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.506 7.897a4.647 4.647 0 119.295 0v5.95a2.801 2.801 0 01-5.602 0V8.102a.75.75 0 111.5 0v5.743a1.301 1.301 0 002.602 0V7.897a3.147 3.147 0 00-6.295 0v6.36a4.994 4.994 0 109.988 0V8.102a.75.75 0 011.5 0v6.153a6.494 6.494 0 01-12.988 0V7.897z"
  }));
};

Paperclip.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Paperclip.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Link = function Link(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.544 8.778A4.441 4.441 0 017.711 7.46h2.632a.75.75 0 010 1.5H7.711a2.959 2.959 0 00-2.96 3.027 2.96 2.96 0 00.862 2.133 2.883 2.883 0 002.082.887h2.632a.75.75 0 010 1.5H7.695c-1.188 0-2.3-.47-3.15-1.334l.534-.526-.535.526a4.459 4.459 0 01-1.294-3.197 4.459 4.459 0 011.294-3.198l.535.527-.535-.527zm8.363-.52a.75.75 0 01.75-.75h2.632a4.42 4.42 0 013.15 1.335 4.53 4.53 0 011.31 3.175 4.459 4.459 0 01-4.46 4.521h-2.632a.75.75 0 010-1.5h2.632a2.959 2.959 0 002.96-3.004v-.01a3.03 3.03 0 00-.878-2.13 2.92 2.92 0 00-2.082-.886h-2.632a.75.75 0 01-.75-.75zm3.033 4.457H8.044a.75.75 0 010-1.5h7.896a.75.75 0 010 1.5z"
  }));
};

Link.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Link.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var LinkAngled = function LinkAngled(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.091 14.34a.75.75 0 001.06 0l2.234-2.234a5.201 5.201 0 00-.05-7.408 5.287 5.287 0 00-3.702-1.54 5.155 5.155 0 00-3.698 1.498L9.7 6.889a.75.75 0 101.06 1.06l2.234-2.233a3.655 3.655 0 012.627-1.058c.999.008 1.951.4 2.656 1.105l.008.008a3.7 3.7 0 01.039 5.275l-2.234 2.233a.75.75 0 000 1.06zm-2.853 1.738l-2.233 2.233c-.69.689-1.603 1.066-2.626 1.058a3.7 3.7 0 01-2.665-1.14 3.701 3.701 0 01-.039-5.275l2.234-2.233a.75.75 0 00-1.06-1.06l-2.234 2.233a5.2 5.2 0 00.047 7.404 5.201 5.201 0 003.706 1.571c1.416.01 2.718-.518 3.697-1.497l2.234-2.234a.75.75 0 10-1.06-1.06zm-5.155-.22a.75.75 0 001.06 0l6.7-6.7a.75.75 0 10-1.06-1.061l-6.7 6.7a.75.75 0 000 1.06z"
  }));
};

LinkAngled.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LinkAngled.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var LinkBroken = function LinkBroken(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7 3.58a.75.75 0 011.06 0l1.107 1.107a.75.75 0 01-1.061 1.06L3.7 4.641a.75.75 0 010-1.06zM.975 9.155a.75.75 0 01.673-.82l1.89-.188a.75.75 0 11.149 1.493l-1.891.188a.75.75 0 01-.82-.673zM9.433.698a.75.75 0 01.672.82l-.18 1.824a.75.75 0 11-1.494-.148l.181-1.823a.75.75 0 01.82-.673zm-6.25 14.986a5.18 5.18 0 011.524-3.698l2.234-2.233A.75.75 0 118 10.813l-2.233 2.234a3.701 3.701 0 00.055 5.291A3.7 3.7 0 008.47 19.46c1.024.008 1.937-.369 2.627-1.058l2.233-2.233a.75.75 0 011.06 1.06l-2.233 2.234c-.98.98-2.282 1.508-3.698 1.498a5.201 5.201 0 01-3.706-1.572 5.2 5.2 0 01-1.571-3.706l.75-.006-.75.006zm6.61-7.642a.75.75 0 010-1.06l2.234-2.234a5.155 5.155 0 013.698-1.497 5.286 5.286 0 013.702 1.54 5.2 5.2 0 01.05 7.408l-2.233 2.233a.75.75 0 01-1.06-1.06l2.233-2.234a3.7 3.7 0 00-.038-5.274l-.009-.008a3.786 3.786 0 00-2.656-1.105 3.655 3.655 0 00-2.626 1.058l-2.234 2.233a.75.75 0 01-1.06 0zM8.176 15.95a.75.75 0 010-1.06l6.7-6.701a.75.75 0 011.061 1.06l-6.7 6.701a.75.75 0 01-1.06 0zm11.743-1.047a.75.75 0 01.673-.82l1.89-.188a.75.75 0 01.148 1.493l-1.89.187a.75.75 0 01-.82-.672zm-4.744 4.805a.75.75 0 01.672.82l-.181 1.824a.75.75 0 01-1.493-.148l.181-1.824a.75.75 0 01.82-.672zm3.237-1.733a.75.75 0 011.06 0l1.107 1.107a.75.75 0 11-1.061 1.06l-1.106-1.106a.75.75 0 010-1.06z"
  }));
};

LinkBroken.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LinkBroken.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var LinkExternal = function LinkExternal(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.19 4.75H15a.75.75 0 110-1.5h5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0V5.81l-7.22 7.22a.75.75 0 01-1.061-1.06l7.22-7.22zM7 4.75A2.25 2.25 0 004.75 7v10A2.25 2.25 0 007 19.25h10A2.25 2.25 0 0019.25 17v-4a.75.75 0 011.5 0v4A3.75 3.75 0 0117 20.75H7A3.75 3.75 0 013.25 17V7A3.75 3.75 0 017 3.25h4a.75.75 0 010 1.5H7z"
  }));
};

LinkExternal.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LinkExternal.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Globe = function Globe(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.343 19.38a7.547 7.547 0 01-2.686 0 6.265 6.265 0 01-.754-1.317 11.98 11.98 0 01-.714-2.293c.924-.133 1.93-.207 2.987-.207.93 0 1.817.057 2.644.16a12.032 12.032 0 01-.723 2.34c-.234.536-.49.976-.754 1.317zm.8 1.363A9.026 9.026 0 0112 21a9.026 9.026 0 01-2.143-.257 9.004 9.004 0 010-17.486A9.021 9.021 0 0112 3c.739 0 1.456.089 2.143.257a9.01 9.01 0 016.02 4.946A8.966 8.966 0 0121 12a8.965 8.965 0 01-1.583 5.099 9.011 9.011 0 01-5.274 3.644zm3.89-4.287a7.535 7.535 0 01-2.553 2.19c.34-.782.618-1.685.82-2.675.635.135 1.216.299 1.733.485zm.777-1.31c.443-.957.69-2.023.69-3.146a7.472 7.472 0 00-.69-3.146c-.678.264-1.442.485-2.27.657.097.796.148 1.631.148 2.489 0 .858-.051 1.693-.147 2.489a14.41 14.41 0 012.27.657zm-3.75-.904a22.799 22.799 0 00-2.884-.18c-1.125 0-2.213.08-3.23.227A19.328 19.328 0 018.813 12c0-.796.046-1.564.133-2.29 1.017.149 2.105.227 3.23.227.998 0 1.967-.062 2.883-.179.084.712.129 1.463.129 2.242 0 .78-.045 1.53-.129 2.242zm-.24-5.965c-.827.103-1.715.16-2.644.16-1.058 0-2.063-.074-2.987-.207a11.98 11.98 0 01.714-2.293c.234-.536.49-.976.754-1.317a7.545 7.545 0 012.686 0c.264.341.52.781.754 1.317.292.667.539 1.458.723 2.34zm1.48-.248a13.279 13.279 0 001.733-.485 7.535 7.535 0 00-2.553-2.19c.34.782.618 1.685.82 2.675zM8.52 5.354A7.534 7.534 0 006.045 7.44c.494.195 1.055.368 1.67.513.202-.96.474-1.837.805-2.599zM7.47 9.436a13.46 13.46 0 01-2.223-.702A7.47 7.47 0 004.5 12c0 1.17.268 2.278.746 3.266a13.45 13.45 0 012.223-.702A20.783 20.783 0 017.312 12c0-.885.054-1.745.157-2.564zm.246 6.61c-.615.146-1.176.319-1.67.514a7.533 7.533 0 002.475 2.086 13.53 13.53 0 01-.805-2.6z"
  }));
};

Globe.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Globe.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AtSign = function AtSign(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.921a9.079 9.079 0 105.926 15.957.75.75 0 00-.98-1.136A7.579 7.579 0 1119.578 12v.007A1.749 1.749 0 0116.081 12V8.668a.75.75 0 00-1.5 0v.17a4.081 4.081 0 10.857 5.36 3.249 3.249 0 005.64-2.2v-.008A9.079 9.079 0 0012 2.921zM9.419 12a2.581 2.581 0 115.162 0 2.581 2.581 0 01-5.162 0z"
  }));
};

AtSign.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AtSign.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Hash = function Hash(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79 4.26a.75.75 0 01.617.863L9.968 7.75h5.479l.479-2.873a.75.75 0 111.48.246l-.438 2.627H19a.75.75 0 010 1.5h-2.281l-.917 5.5H19a.75.75 0 010 1.5h-3.448l-.479 2.873a.75.75 0 11-1.48-.246l.438-2.627H8.552l-.479 2.873a.75.75 0 11-1.48-.246l.438-2.627H5a.75.75 0 010-1.5h2.281l.917-5.5H5a.75.75 0 010-1.5h3.448l.479-2.873a.75.75 0 01.863-.617zm-.071 4.99l-.917 5.5h5.48l.916-5.5h-5.48z"
  }));
};

Hash.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Hash.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var TwitterFillBrand = function TwitterFillBrand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21 6.662a7.666 7.666 0 01-2.122.556 3.576 3.576 0 001.625-1.955 7.586 7.586 0 01-2.346.857 3.747 3.747 0 00-2.095-1.073 3.839 3.839 0 00-2.345.371 3.6 3.6 0 00-1.623 1.661 3.392 3.392 0 00-.23 2.263A10.86 10.86 0 017.65 8.271a10.413 10.413 0 01-3.396-2.62c-.328.54-.5 1.152-.5 1.776 0 1.225.652 2.307 1.643 2.94a3.81 3.81 0 01-1.673-.441v.044c0 .816.295 1.606.835 2.238a3.728 3.728 0 002.128 1.226 3.881 3.881 0 01-1.67.06 3.544 3.544 0 001.314 1.757c.62.44 1.366.684 2.137.698-.766.575-1.643 1-2.581 1.252A7.738 7.738 0 013 17.41 10.795 10.795 0 008.66 19c6.794 0 10.509-5.383 10.509-10.052 0-.152-.005-.306-.012-.456A7.33 7.33 0 0021 6.662z"
  }));
};

TwitterFillBrand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TwitterFillBrand.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var DiscordFillBrand = function DiscordFillBrand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M18.248 6.38a15.002 15.002 0 00-3.714-1.13c-.175.31-.334.63-.476.957a13.973 13.973 0 00-4.12 0c-.142-.327-.301-.647-.476-.957a15.107 15.107 0 00-3.717 1.133c-2.35 3.441-2.987 6.797-2.669 10.104a15.029 15.029 0 004.555 2.263c.369-.49.695-1.012.975-1.556a9.733 9.733 0 01-1.536-.726c.13-.093.255-.188.377-.28a10.793 10.793 0 009.106 0c.123.099.25.194.377.28-.49.286-1.006.53-1.54.727.28.545.607 1.065.976 1.555 1.64-.49 3.18-1.254 4.558-2.261.373-3.836-.639-7.16-2.676-10.108zM9.01 14.454c-.888 0-1.621-.797-1.621-1.778 0-.98.708-1.785 1.618-1.785.91 0 1.638.805 1.623 1.785-.016.981-.715 1.778-1.62 1.778zm5.98 0c-.889 0-1.62-.797-1.62-1.778 0-.98.708-1.785 1.62-1.785.912 0 1.634.805 1.618 1.785-.015.981-.713 1.778-1.618 1.778z"
  }));
};

DiscordFillBrand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
DiscordFillBrand.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var GoogleFillBrand = function GoogleFillBrand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.64 12.205c0-.639-.057-1.252-.164-1.841H12v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H3.957v2.332A8.997 8.997 0 0012 21z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.964 13.71A5.41 5.41 0 016.682 12c0-.593.102-1.17.282-1.71V7.958H3.957A8.997 8.997 0 003 12c0 1.452.348 2.827.957 4.042l3.007-2.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C16.463 3.891 14.426 3 12 3a8.997 8.997 0 00-8.043 4.958l3.007 2.332C7.672 8.163 9.656 6.58 12 6.58z"
  }));
};

GoogleFillBrand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
GoogleFillBrand.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var MetamaskFillBrand = function MetamaskFillBrand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21.193 1.798L13.22 8.176l1.481-3.763 6.492-2.615z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.807 1.798l7.9 6.438-1.408-3.823-6.492-2.615z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.327 16.583l-2.12 3.504 4.538 1.346 1.297-4.773-3.715-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.966 16.66l1.29 4.773 4.538-1.346-2.113-3.504-3.715.077z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.545 10.662l-1.264 2.063 4.499.216-.153-5.222-3.082 2.943z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.455 10.662l-3.13-3.004-.104 5.283 4.498-.216-1.264-2.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.794 20.087l2.714-1.425-2.338-1.967-.376 3.392z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.492 18.662l2.714 1.425-.376-3.392-2.338 1.967z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.206 20.087l-2.713-1.425.216 1.908-.024.803 2.521-1.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.794 20.087l2.521 1.286-.016-.803.209-1.908-2.714 1.425z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.363 15.434l-2.257-.715 1.592-.786.665 1.502z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.637 15.434l.664-1.5 1.601.785-2.265.716z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.794 20.087l.391-3.504-2.504.077 2.113 3.427z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.815 16.583l.391 3.504 2.121-3.427-2.513-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.72 12.725l-4.5.216.417 2.493.665-1.501 1.6.785 1.817-1.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.106 14.718l1.592-.785.665 1.501.417-2.493-4.5-.216 1.826 1.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28 12.725l1.89 3.97-.064-1.977-1.825-1.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.902 14.718l-.072 1.977 1.89-3.97-1.818 1.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.78 12.94l-.417 2.494.528 2.944.112-3.875-.223-1.562z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.22 12.94l-.216 1.554.104 3.884.529-2.944-.417-2.493z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.637 15.434l-.529 2.944.384.284 2.338-1.967.072-1.976-2.265.715z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.106 14.719l.064 1.976 2.337 1.967.384-.284-.528-2.944-2.257-.715z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.685 21.373l.024-.803-.2-.19h-3.018l-.192.19.016.803-2.521-1.286.88.776 1.793 1.338h3.066l1.793-1.338.88-.776-2.521 1.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.492 18.662l-.383-.285H10.89l-.383.285-.209 1.908.192-.19h3.018l.2.19-.216-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.53 8.59l.672-3.52-1.009-3.272-7.7 6.163 2.962 2.7 4.186 1.322.92-1.166-.4-.31.64-.63-.488-.415.64-.526-.424-.345z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.798 5.07l.68 3.52-.431.346.64.526-.488.414.64.63-.4.311.92 1.166 4.186-1.321 2.963-2.701-7.701-6.163L1.798 5.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.64 11.983l-4.185-1.321 1.264 2.063-1.889 3.97 2.497-.035h3.715l-1.401-4.677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.545 10.662l-4.186 1.32-1.393 4.678h3.715l2.489.035-1.89-3.97 1.265-2.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.22 12.94l.272-4.98 1.21-3.547H9.298l1.209 3.548.272 4.98.104 1.57.007 3.867h2.217l.008-3.867.104-1.57z"
  }));
};

MetamaskFillBrand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MetamaskFillBrand.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var TokenpocketFillBrand = function TokenpocketFillBrand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#image0_698_111",
    transform: "scale(.00446)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_698_111",
    width: "224",
    height: "224",
    href: "data:image/pngbase64,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"
  })));
};

TokenpocketFillBrand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TokenpocketFillBrand.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var BitKeepFillBrand = function BitKeepFillBrand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "1",
    width: "22",
    height: "22"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#image0_698_119",
    transform: "scale(.00444)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_698_119",
    width: "225",
    height: "225",
    href: "data:image/pngbase64,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"
  })));
};

BitKeepFillBrand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BitKeepFillBrand.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var SafepalFillBrand = function SafepalFillBrand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#image0_698_126",
    transform: "scale(.00444)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_698_126",
    width: "225",
    height: "225",
    href: "data:image/pngbase64,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"
  })));
};

SafepalFillBrand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SafepalFillBrand.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var WalletConnectFill = function WalletConnectFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.685 8.303c2.935-3.161 7.695-3.161 10.63 0l.353.38a.427.427 0 010 .573l-1.208 1.302a.178.178 0 01-.266 0l-.486-.524c-2.048-2.205-5.368-2.205-7.416 0l-.52.56a.179.179 0 01-.266 0l-1.209-1.3a.427.427 0 010-.573l.388-.418zm13.13 2.692l1.075 1.158a.427.427 0 010 .573l-4.85 5.223a.357.357 0 01-.531 0l-3.443-3.707a.09.09 0 00-.132 0l-3.442 3.707a.357.357 0 01-.532 0l-4.85-5.223a.427.427 0 010-.573l1.076-1.158a.357.357 0 01.531 0l3.442 3.707a.09.09 0 00.133 0l3.442-3.707a.357.357 0 01.532 0l3.442 3.707a.09.09 0 00.133 0l3.442-3.707a.357.357 0 01.531 0z"
  }));
};

WalletConnectFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
WalletConnectFill.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ArbitrumFillBrand = function ArbitrumFillBrand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M14.479 11.08l1.616-2.741 4.355 6.782.002 1.302-.015-8.957a.675.675 0 00-.312-.538l-7.84-4.51a.691.691 0 00-.67.044l-.027.017-7.61 4.41-.03.014a.672.672 0 00-.393.573l.012 7.299 4.057-6.287c.51-.834 1.623-1.103 2.656-1.088l1.212.032L4.35 18.888l.842.484L12.42 7.444l3.195-.012-7.21 12.23 3.005 1.728.358.206a.69.69 0 00.484.01l7.951-4.608-1.52.881-4.204-6.799zm.616 8.879l-3.034-4.764 1.852-3.143 3.986 6.282-2.804 1.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.06 15.196l3.035 4.763 2.803-1.625-3.985-6.282-1.853 3.144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.451 16.424l-.002-1.302-4.355-6.783-1.616 2.742 4.205 6.799 1.52-.881a.674.674 0 00.248-.49v-.085z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.202 17.651l2.147 1.237 7.143-11.456L10.28 7.4c-1.033-.014-2.146.254-2.657 1.088l-4.056 6.287-1.365 2.097v.779z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.615 7.432l-3.196.012-7.228 11.929 2.527 1.454.687-1.165 7.21-12.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.798 7.416a2.035 2.035 0 00-.955-1.636l-7.944-4.568a2.066 2.066 0 00-1.822 0c-.066.033-7.725 4.475-7.725 4.475a2.02 2.02 0 00-1.15 1.725v9.46l1.365-2.097-.012-7.3a.672.672 0 01.28-.507c.037-.025 7.826-4.534 7.85-4.547a.691.691 0 01.6-.002l7.84 4.51a.675.675 0 01.312.537v9.042a.659.659 0 01-.234.49l-1.52.881-.785.455-2.803 1.625-2.843 1.647a.689.689 0 01-.484-.01l-3.363-1.934-.688 1.165 3.023 1.74.262.149c.114.063.19.106.218.119.215.104.524.165.802.165.256 0 .505-.047.74-.14l8.258-4.781c.474-.367.753-.921.778-1.521V7.416z"
  }));
};

ArbitrumFillBrand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArbitrumFillBrand.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var OptimismFillBrand = function OptimismFillBrand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.978 15.08c-.663 0-1.207-.16-1.63-.48-.419-.324-.628-.786-.628-1.385 0-.126.014-.28.042-.462.072-.41.175-.904.31-1.48.378-1.569 1.357-2.353 2.935-2.353.43 0 .814.074 1.154.222.34.143.607.36.803.65.195.286.292.628.292 1.027 0 .12-.014.271-.041.454a19.752 19.752 0 01-.301 1.48c-.196.781-.533 1.366-1.012 1.754-.48.382-1.121.573-1.924.573zm.117-1.232c.312 0 .577-.094.795-.282.223-.189.382-.477.476-.865.129-.536.226-1.003.293-1.403.022-.12.034-.242.034-.367 0-.52-.265-.78-.795-.78-.312 0-.58.095-.803.283-.217.189-.373.477-.468.864-.1.383-.2.85-.301 1.403a1.868 1.868 0 00-.034.36c0 .524.268.787.803.787z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.64 14.995a.175.175 0 01-.142-.06.209.209 0 01-.025-.154l1.154-5.561a.245.245 0 01.092-.154c.05-.04.103-.06.16-.06h2.224c.619 0 1.115.13 1.488.393.38.263.569.642.569 1.138 0 .143-.017.291-.05.445-.14.656-.421 1.14-.845 1.454-.418.314-.992.471-1.723.471h-1.129l-.384 1.874a.245.245 0 01-.092.154.25.25 0 01-.16.06H12.64zm2.96-3.269a.981.981 0 00.611-.197.927.927 0 00.352-.564c.016-.097.025-.183.025-.257 0-.165-.048-.29-.142-.376-.095-.091-.257-.137-.486-.137h-1.003l-.318 1.531h.962z"
  }));
};

OptimismFillBrand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
OptimismFillBrand.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var EmojiFire = function EmojiFire(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#image0_652_47",
    transform: "scale(.01389)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_652_47",
    width: "72",
    height: "72",
    href: "data:image/pngbase64,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"
  })));
};

EmojiFire.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
EmojiFire.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var EmojiTrophy = function EmojiTrophy(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#image0_652_80",
    transform: "scale(.01389)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_652_80",
    width: "72",
    height: "72",
    href: "data:image/pngbase64,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"
  })));
};

EmojiTrophy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
EmojiTrophy.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var EmojiAdmissionTickets = function EmojiAdmissionTickets(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#image0_708_34",
    transform: "scale(.01389)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_708_34",
    width: "72",
    height: "72",
    href: "data:image/pngbase64,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"
  })));
};

EmojiAdmissionTickets.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
EmojiAdmissionTickets.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var EmojiAlarmClock = function EmojiAlarmClock(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#image0_832_10",
    transform: "scale(.01389)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_832_10",
    width: "72",
    height: "72",
    href: "data:image/pngbase64,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"
  })));
};

EmojiAlarmClock.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
EmojiAlarmClock.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var EmojiRocket = function EmojiRocket(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#image0_838_10",
    transform: "scale(.01389)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_838_10",
    width: "72",
    height: "72",
    href: "data:image/pngbase64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAC/VBMVEUAAACMNCkQMlNRWlq8JQTmwAgeRmw1O0DyDwEmGSZjZWwsNTvOOwojMEn2ZAT4jgJgZ2eytrPSJAX86DwRTIZtLjAgMlH0qwkcLkT3pAPuFQ7qYALjigfVFA3cZwDcqge9JgKQsMqmp6kkLTH1mgfqBwTnfQPaEgzkdwPhVgSFjpoZJS3iEw+5sZ7zfwXnDwo2ODrpDQcfKTGTj47pnwzbEwjhWQbeVAKaQwjRfALwNgDtNDO6Fxn90w783RL4yA1ncnenVQ0NQnzKEhDODQx/nLsNO3NaW2N8lbDLGAr82xf0fQmlFRP0RxfPXwD6YiDMWAb40C8UKT2bqbWMLxCmpqbWyXV3XxdKY5CFhYqdoqGppaPyAwDsAwACAwRTBAjmBAByDAQaQGH/CQbc5N00fLMMDRHL0cc7g7x6gn/5rweCvOqQmZWGjYr8GxmNs9T/9WaTyvEwdKr8vwnKBgPaBwHk7OdFjMLCx7z/8Er4BQGUwuXe6ORZoNexxs23vbWTprE6RkgSGyH8fwX8RgWqCgXp8u1/q9K+zdHW3NCpsKuip6QnUHX/9nFbXmP/81hETE38cgi5CAXx9vOmucCHnaubop1me4r/+XtrcnD+2Bc9DxT/sRD9pQ3+Wgn9FwmBs91tos5PlczULC+cDAZwsOOesbr/+qNxjZ9PUVYeJjL+jhb+yQ/7NQh9Dwie1fbH1NdhmciJpr9Yjr1EcJr+940vWn9yeXhha3gfJUHLHB/+nA2HCgz5JwLN2tsoY5lxh5U4ZYq6cnhgHiViBAbvIAWy5/pGhLdbhal9kqT53DD/8Spqp9tzmblRepvBLTA5HDCUTSqELwuvv8Hs33U8UWQlMU7pS0z6yibZHx3Kr69UbIGCbXb//m+uWmHeWlz//UGSGhypGBjdNgrCRQWmLgXtTgTI8fz9+r7f2q5DbpLDjI/6fXp/UFxkZ0/BREhLNz3HnTO5v8TVenzRw2y7o2L9Yl/NxlDbvC7PxIdDWnWdiFjd11W/hRifjpHLrKySAAAAXHRSTlMACf7+Ewz+/v7+Kf0gP/7+/fws/fz2b7cT5d/ZVD44H/vz3NzQop6AdXNfVP786ci/tZ+Le2JiS0Ir/v37xaySSeDb06+upaOM+efFvri28O/fy7yalTrV1MKlgz08fYEAAAirSURBVFjD3dZ3UJJhHAdwEExR09KsHO0y27ts7733NMKZoDggjRyhZlkqjkRM0zBIQXGmucvcI1dm2d577931e17R6o6Ot/qv73mn552f+/2+z/O+SPj/QiQS/1XQmDF4wYK5kAWDNf5a6T5jweo+fRz3QYRCYe2Gjn/HrFu7keuV6sw4dubMmWMMhvu+zHnd/4LRGNO386twriPjjKenJ0DO7nGZszr+DfPK378pPJxf63nU0xMcZ0Z6Zpeuf874p6V5hcdz47lVlZiT6iw8/qcQcXDf3ZceFxc/DuBy+XwuvxY5qanC46f+DNLYNOy1aIpYHDZ0cjGfy40PD+/jnFpeXs74MwjGeS26WfJCkxJNE10oBsfL39+r/P79cmHFqT8oW2PtsOu39LNzeN6aPjYpky9EgJOWlma79+B9oUuXWRq4ndWXLtw8VJRDUkv0sdkaLWIWe/mftGpqsnq4tzzOpQvuezS4787rN7OLcqSayNlqUw/QSQ9XV9eDVjvdoaJ5eOvpnFY8hSfghcBaNlsBev6u2N/K9SDKbok13q6JYzqfDKjXzyF5JyIHEn39yeOTrnuB2Wu1M/tUlw4d8Tr+1+pfQD3IQSl59+SSR6tjG+DQ3GVWd3xOmn/8tXq1dgdVdMF2L8TVyvaAvQPJAk9FqpsPwCMRca2+Qe5ACpjM1x7AeOy37Rxh14mkiWezGRGvvOK59s9FJe1OChMGQuPst90d4JDdKWRkdzznHtAUz+VXPc8TlbQ6VD/mkcmXXNE4O3cH2NsdIoXMV95Pxz73vfj8KknR0zyRaEoBjVYQZm5pOfmSB4wDDhSUzQsZOUOZQ16j71WemlFUFS8QPK0XXWSzd5jv2qV+fWebE+Fg10mqNkSZo7vk5pXyVIawVmAvEAh4jbf8wtjsvOdwg9octJi30oZ6LLlV4pgKL9T0ustFRRJJkeDKlSvfOqd5uHq0OgHYYsoG0ho45RbtsjPjTPpRN7fMy5IqPrw40IP6i9OJpDaaqKBbXV0yEYVsNnD2wjBxQxwjLt3Nbfv27ZmCdgcxcgct1k/RHRpnaDhi1BzI7IU72GF+1E/74o4CA3HLLEJOGuYA07nVgcW6KirFkMk8csRy165dW8x3sP0KKHXpxyu2W1uD43a0zr4JDWT1iyNVG91dgTObecQSBaBt7DAx9XylW4U1BCD44JEMawq3BQZzIpDTSapwMd0RF+UOGijML4Vi4WJtDV/IOep5TBjxZth++TitDslbU8GJaY26OLTdgcXEVEqHUy4uAGEO+kD9eO7hw5+dEE0FJ0YewLwI/bQ6sBg0lBgIkHwxcJxT3d+cezgMMW2OgoKIA5llAGFNq2+DxfxKKedPYAO1Oc7ujhlv3wyLQONkI0dtlYaCg5+cfLussBAodXV1dPTiaIrFKbkTd4zhDs6+2lrJ57f2Dm0OFK3g4PfsuZ0MKSwsLCuDgaDq3EDkVLilxwkZ7u7u3OKqysrKumfZdrAW7zcOeWlsbOy92D2Q5EmTbi/s7SeGzU67WFdUHAcHGEcHkeW1yrq6zNPez+x4PCk4ih6xgctDQ7W1AQPr3qTbve/eFUcndsjEmH1CRyjnSp6lKKcu89Hp04GaUlKIt6ZCp8fypCTfUAho2vfu3blz9+5ZSu6JyuPIcXR0zKh6mmeZl/MImBMnAjtoeit2YLEkiG+Sr68vooyWLZs5U59y/hFiwMngC/SnMPN4pzEmsEMHlURNksK3/fikmJj8/KT8JB0doIx6qqpqacxvbq7EmD4ZkpySW8yL0hOQQORYqKiMVvhu1Vp8GBKDsHwdneET4B+G+fM7NV+uxZgqgZR688kFfTBAAQacror/sx50WMZisRCGLBMiQWMkRaqWK0EMvyjnBZV2/clTCzDkzKohih3d/lEQmUyGYf0nguNDUfPx+ZSRwZcIpCXU0rx3185boCAmd7QGQXFMFy2aOm3a9OnTpk2bOnWqMYHQkULxtjjv43NZIuC9oFKpYqZITUVFBWNUGpaQCb9Jr3W9VFXhO1EVgn6YuN4b/ijRJrFZGg0ObShTHwSU3IaC2boEnCEbT60mWVjAVbHxQQ58rublIiS3oaSAPXQcXse426Iazvtm75AcOzUb+UAlgDRQaWL2NvNRZHzMxLErOcHBTk7vn+XY2ZGiqaWltDvJedHwQ4Efe8c2c3OcA/VcXO0EiQxy+uJgx4N5aAV3koanlBaIw4ABxxBfQ6rd6MFOQUGRkUEgPQOnNKW3+tI14jBgMGfLCFybEY0NWsDJyooE7NxZzCkcoWXWGzGYs2UAEQ803oDFcQrKSsiKBKeRBrmjvcKMYNa7zQFIKdLLWJXcny4LboUwJyVlRb6RGYHQtfc25OCExhr0NKazogCKTEjIyvqMnK9RJmaE7l31UT2Yg2e1icbjh8ewajjBTlkJCQkfz9JoZ1/WTFcldBypz5Y7KKOUQsSe4Mg4HI5TQsKDB43gfKjppkXsqn93qLncQTHUUvZcjB8UI4uKAigInLfIubGyJ6HXzNvJZeZyB2WEltKJTOnVwXowUGRkQlYjrbH6hp4xHEH/2OQy9R/OqB5Ky9Y1AahaL9gp8urVl7SZejf0xkIdqv1j9xSqyxVz8wHKr+MEo1C6LKo6ODj46tX3Z7/q1UR1I2NXXRsgJKH1BuK41oO0femsFg4HoHONL2/UGIztRcCg0D2w2xbUt/pAIp6nVaeFxdLj6OlFOb38cKOGZSr/PQZht9pwHDg4IANOCz2quoVOp7fURLEWtx3O9NB7k2AiOC6sZhyr6bBi6HSWDD7YYuj9TcGRQ75Y2+oDdPE5ZCMduq+ODl2Wr71s0Ph2BjrCIEOoGV+0hsv06DGHfY1MJmiNnUj4FZoEtwdvdA3odB06y2ACmCbtELqQvtpG42AcvBlvZDLI1NS0J3bHCT9BBsNNoB3cIQ6a8Jt379gJyMUfGP7f8x30kIhjrw84BgAAAABJRU5ErkJggg=="
  })));
};

EmojiRocket.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
EmojiRocket.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AlarmOn = function AlarmOn(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.93 3a.75.75 0 01.75-.75h.72a4.35 4.35 0 014.35 4.35v.72a.75.75 0 01-1.5 0V6.6a2.85 2.85 0 00-2.85-2.85h-.72a.75.75 0 01-.75-.75zm-9.33.75A2.85 2.85 0 003.75 6.6v.72a.75.75 0 01-1.5 0V6.6A4.35 4.35 0 016.6 2.25h.72a.75.75 0 010 1.5H6.6zm5.4 1.8a7.17 7.17 0 100 14.34 7.17 7.17 0 000-14.34zm-8.67 7.17a8.67 8.67 0 1115.308 5.577l2.172 2.173a.75.75 0 11-1.06 1.06l-2.173-2.172A8.635 8.635 0 0112 21.39a8.635 8.635 0 01-5.577-2.032L4.25 21.53a.75.75 0 01-1.06-1.06l2.172-2.173A8.635 8.635 0 013.33 12.72zM12 8.73a.75.75 0 01.75.75v2.93l1.58 1.58a.75.75 0 11-1.06 1.06l-1.59-1.589a1.47 1.47 0 01-.43-1.04V9.48a.75.75 0 01.75-.75z"
  }));
};

AlarmOn.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlarmOn.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AlarmOff = function AlarmOff(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.93 3a.75.75 0 01.75-.75h.72a4.35 4.35 0 014.35 4.35v.72a.75.75 0 01-1.5 0V6.6a2.85 2.85 0 00-2.85-2.85h-.72a.75.75 0 01-.75-.75zm-12.368.487a.75.75 0 011.06.024l16.2 16.971a.75.75 0 01-1.084 1.036l-2.106-2.206A8.639 8.639 0 0112 21.39a8.635 8.635 0 01-5.577-2.032L4.25 21.53a.75.75 0 01-1.06-1.06l2.172-2.173A8.635 8.635 0 013.33 12.72a8.642 8.642 0 012.347-5.932L4.133 5.171c-.244.42-.383.907-.383 1.429v.72a.75.75 0 01-1.5 0V6.6c0-.979.324-1.884.87-2.61a.747.747 0 01.255-.216.747.747 0 01.187-.287zm3.152 4.388a7.17 7.17 0 009.88 10.35l-9.88-10.35zM12 5.55c-.709 0-1.392.103-2.037.293a.75.75 0 01-.426-1.438 8.67 8.67 0 0110.246 12.138.75.75 0 01-1.346-.662A7.17 7.17 0 0012 5.55z"
  }));
};

AlarmOff.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlarmOff.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AlarmCheck = function AlarmCheck(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.93 3a.75.75 0 01.75-.75h.72a4.35 4.35 0 014.35 4.35v.72a.75.75 0 01-1.5 0V6.6a2.85 2.85 0 00-2.85-2.85h-.72a.75.75 0 01-.75-.75zm-9.33.75A2.85 2.85 0 003.75 6.6v.72a.75.75 0 01-1.5 0V6.6A4.35 4.35 0 016.6 2.25h.72a.75.75 0 010 1.5H6.6zm5.4 1.8a7.17 7.17 0 100 14.34 7.17 7.17 0 000-14.34zm-8.67 7.17a8.67 8.67 0 1115.308 5.577l2.172 2.173a.75.75 0 11-1.06 1.06l-2.173-2.172A8.635 8.635 0 0112 21.39a8.635 8.635 0 01-5.577-2.032L4.25 21.53a.75.75 0 01-1.06-1.06l2.172-2.173A8.635 8.635 0 013.33 12.72zm12.013-2.938a.75.75 0 010 1.06l-3.938 3.938a.75.75 0 01-1.06 0l-1.688-1.687a.75.75 0 111.06-1.06l1.158 1.156 3.407-3.407a.75.75 0 011.06 0z"
  }));
};

AlarmCheck.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlarmCheck.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ClockForward = function ClockForward(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.087 4.663a7.337 7.337 0 106.357 11.005.75.75 0 011.298.751 8.837 8.837 0 111.144-5.253l.584-.584a.75.75 0 111.06 1.06l-2.021 2.023a.75.75 0 01-1.061 0l-2.022-2.022a.75.75 0 011.06-1.06l.922.921a7.338 7.338 0 00-7.32-6.841zm0 3.37a.75.75 0 01.75.75v3.687l2.52.84a.75.75 0 11-.474 1.423l-3.033-1.01a.75.75 0 01-.513-.712V8.784a.75.75 0 01.75-.75z"
  }));
};

ClockForward.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ClockForward.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ClockPlus = function ClockPlus(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.47 4.28a7.72 7.72 0 101.449 15.305.75.75 0 11.28 1.474A9.22 9.22 0 1120.692 12a.75.75 0 01-1.5 0 7.72 7.72 0 00-7.721-7.72zm0 3.601a.75.75 0 01.75.75v3.887l2.664.888a.75.75 0 11-.474 1.423l-3.177-1.059a.75.75 0 01-.512-.711V8.63a.75.75 0 01.75-.75zm6.883 6.545a.75.75 0 01.75.75v1.897H21a.75.75 0 010 1.5h-1.897v1.898a.75.75 0 11-1.5 0v-1.898h-1.897a.75.75 0 010-1.5h1.897v-1.897a.75.75 0 01.75-.75z"
  }));
};

ClockPlus.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ClockPlus.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Reconnect = function Reconnect(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 12a7.178 7.178 0 0114.248-1.24l-.813-.572a.75.75 0 00-.862 1.228l2.294 1.61a.75.75 0 001.045-.182l1.61-2.294a.75.75 0 00-1.227-.862l-.57.81a8.678 8.678 0 10-1.032 5.841.75.75 0 00-1.298-.75A7.178 7.178 0 013.75 12z"
  }));
};

Reconnect.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Reconnect.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AlarmMinus = function AlarmMinus(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.93 3a.75.75 0 01.75-.75h.72a4.35 4.35 0 014.35 4.35v.72a.75.75 0 01-1.5 0V6.6a2.85 2.85 0 00-2.85-2.85h-.72a.75.75 0 01-.75-.75zm-9.33.75A2.85 2.85 0 003.75 6.6v.72a.75.75 0 01-1.5 0V6.6A4.35 4.35 0 016.6 2.25h.72a.75.75 0 010 1.5H6.6zm5.4 1.8a7.17 7.17 0 100 14.34 7.17 7.17 0 000-14.34zm-8.67 7.17a8.67 8.67 0 1115.308 5.577l2.172 2.173a.75.75 0 11-1.06 1.06l-2.173-2.172A8.635 8.635 0 0112 21.39a8.635 8.635 0 01-5.577-2.032L4.25 21.53a.75.75 0 01-1.06-1.06l2.172-2.173A8.635 8.635 0 013.33 12.72zm5.107-.158a.75.75 0 01.75-.75h5.626a.75.75 0 010 1.5H9.186a.75.75 0 01-.75-.75z"
  }));
};

AlarmMinus.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlarmMinus.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var AlarmPlus = function AlarmPlus(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.93 3a.75.75 0 01.75-.75h.72a4.35 4.35 0 014.35 4.35v.72a.75.75 0 01-1.5 0V6.6a2.85 2.85 0 00-2.85-2.85h-.72a.75.75 0 01-.75-.75zm-9.33.75A2.85 2.85 0 003.75 6.6v.72a.75.75 0 01-1.5 0V6.6A4.35 4.35 0 016.6 2.25h.72a.75.75 0 010 1.5H6.6zm5.4 1.8a7.17 7.17 0 100 14.34 7.17 7.17 0 000-14.34zm-8.67 7.17a8.67 8.67 0 1115.308 5.577l2.172 2.173a.75.75 0 11-1.06 1.06l-2.173-2.172A8.635 8.635 0 0112 21.39a8.635 8.635 0 01-5.577-2.032L4.25 21.53a.75.75 0 01-1.06-1.06l2.172-2.173A8.635 8.635 0 013.33 12.72zM12 9a.75.75 0 01.75.75v2.063h2.063a.75.75 0 010 1.5H12.75v2.062a.75.75 0 01-1.5 0v-2.063H9.187a.75.75 0 010-1.5h2.063V9.75A.75.75 0 0112 9z"
  }));
};

AlarmPlus.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlarmPlus.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Calendar01 = function Calendar01(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.745 2.25a.75.75 0 01.75.75v.793h8.818V3a.75.75 0 011.5 0v.86a3.751 3.751 0 013.037 3.683V18a3.75 3.75 0 01-3.75 3.75H6.9A3.75 3.75 0 013.15 18V7.543a3.752 3.752 0 012.845-3.64V3a.75.75 0 01.75-.75zM6.9 5.293a2.25 2.25 0 00-2.25 2.25v.668a.748.748 0 01.263-.047h14.174c.093 0 .181.017.263.047v-.668a2.25 2.25 0 00-2.25-2.25H6.9zm12.45 4.324a.748.748 0 01-.263.047H4.913a.748.748 0 01-.263-.047V18a2.25 2.25 0 002.25 2.25h10.2A2.25 2.25 0 0019.35 18V9.617z"
  }));
};

Calendar01.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Calendar01.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Calendar02 = function Calendar02(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.661 2.25a.75.75 0 01.75.75v.793h8.982V3a.75.75 0 011.5 0v.866a3.837 3.837 0 013.085 3.763v10.285a3.836 3.836 0 01-3.835 3.836H6.857a3.836 3.836 0 01-3.836-3.836V7.63a3.837 3.837 0 012.89-3.719V3a.75.75 0 01.75-.75zm.196 3.043a2.336 2.336 0 00-2.336 2.336v.589a.748.748 0 01.279-.054h14.4c.098 0 .192.02.279.054v-.59a2.336 2.336 0 00-2.336-2.335H6.857zM19.48 9.61a.748.748 0 01-.279.053H4.8a.748.748 0 01-.279-.053v8.303a2.336 2.336 0 002.336 2.336h10.286a2.336 2.336 0 002.335-2.336V9.611zm-10.8 4.96a.75.75 0 01.75-.75h5.142a.75.75 0 010 1.5H9.43a.75.75 0 01-.75-.75z"
  }));
};

Calendar02.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Calendar02.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Calendar03 = function Calendar03(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.661 2.25a.75.75 0 01.75.75v.793h8.982V3a.75.75 0 011.5 0v.852a3.751 3.751 0 013.085 3.69V18a3.75 3.75 0 01-3.75 3.75H6.771A3.75 3.75 0 013.021 18V7.543a3.751 3.751 0 012.89-3.651V3a.75.75 0 01.75-.75zm.11 3.043a2.25 2.25 0 00-2.25 2.25V18a2.25 2.25 0 002.25 2.25h10.457a2.25 2.25 0 002.25-2.25V7.543a2.25 2.25 0 00-2.25-2.25H6.771zm-.223 2.85a.75.75 0 01.75-.75h9.33a.75.75 0 010 1.5h-9.33a.75.75 0 01-.75-.75z"
  }));
};

Calendar03.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Calendar03.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Calendar04 = function Calendar04(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.086 2.25a.75.75 0 01.75.75v1.048a3.803 3.803 0 013.052 3.727v10.173c0 2.1-1.702 3.802-3.802 3.802H6.915a3.802 3.802 0 01-3.802-3.802V7.776a3.803 3.803 0 013.051-3.728V3a.75.75 0 111.5 0v.974h8.673V3a.75.75 0 01.75-.75zm0 3.224H6.913a2.302 2.302 0 00-2.301 2.302v10.172a2.302 2.302 0 002.302 2.302h10.173a2.302 2.302 0 002.301-2.302V7.775a2.302 2.302 0 00-2.302-2.301zM6.6 8.284a.75.75 0 01.75-.75h9.688a.75.75 0 110 1.5H7.35a.75.75 0 01-.75-.75zm3.701 2.381a.75.75 0 01.415.67v6.105a.75.75 0 01-1.5 0v-4.604l-.835.626a.75.75 0 01-.9-1.2l2.035-1.526a.75.75 0 01.785-.07zm5.595 0a.75.75 0 01.415.67v6.105a.75.75 0 01-1.5 0v-4.604l-.835.626a.75.75 0 01-.9-1.2l2.035-1.526a.75.75 0 01.785-.07z"
  }));
};

Calendar04.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Calendar04.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Shield = function Shield(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.514 1.829a.75.75 0 01.972 0c1.29 1.097 2.294 1.632 3.274 1.909 1 .282 2.028.312 3.44.312a.75.75 0 01.75.75v9.228c0 1.011-.177 1.876-.546 2.648-.369.77-.908 1.405-1.571 1.985-.657.575-1.455 1.11-2.353 1.673-.42.264-.837.518-1.275.785-.552.337-1.138.694-1.805 1.115a.75.75 0 01-.8 0c-.667-.42-1.253-.778-1.805-1.115-.438-.267-.855-.521-1.275-.785-.898-.563-1.695-1.098-2.353-1.673-.663-.58-1.202-1.214-1.57-1.985-.37-.772-.547-1.637-.547-2.648V4.8a.75.75 0 01.75-.75c1.412 0 2.44-.03 3.44-.312.98-.277 1.983-.812 3.274-1.91zm6.936 3.717c-1.097-.015-2.097-.082-3.097-.364C14.256 4.872 13.2 4.318 12 3.37c-1.2.948-2.256 1.502-3.353 1.812-1 .282-2 .349-3.097.364v8.482c0 .83.144 1.466.4 2.001.256.537.647 1.016 1.204 1.503.564.492 1.276.976 2.163 1.532.36.226.775.479 1.22.751.464.283.96.586 1.463.9.503-.314 1-.617 1.462-.9.446-.272.86-.525 1.221-.751.887-.556 1.6-1.04 2.163-1.532.557-.487.948-.966 1.205-1.503.255-.535.399-1.171.399-2.001V5.546z"
  }));
};

Shield.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Shield.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var ShieldCheck = function ShieldCheck(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.275 3.663a2.85 2.85 0 00-2.55 0L5.55 6.251v7.564c0 .791.474 1.771 1.649 2.98 1.091 1.123 2.7 2.352 4.802 3.704 2.128-1.352 3.728-2.443 4.817-3.495 1.135-1.099 1.632-2.077 1.632-3.189V6.252l-5.175-2.589zm6.675 2.124v8.028c0 1.661-.784 3.004-2.09 4.267-1.284 1.243-3.151 2.482-5.46 3.94a.75.75 0 01-.8 0c-2.338-1.477-4.196-2.864-5.477-4.182-1.266-1.302-2.073-2.643-2.073-4.025V5.787a.75.75 0 01.415-.67l5.59-2.795a4.35 4.35 0 013.89 0l5.59 2.795a.75.75 0 01.415.67zm-4.42 3.07a.75.75 0 010 1.06l-3.6 3.6a.75.75 0 01-1.06 0l-1.8-1.8a.75.75 0 111.06-1.06l1.27 1.27 3.07-3.07a.75.75 0 011.06 0z"
  }));
};

ShieldCheck.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ShieldCheck.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Scan = function Scan(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 5.778A2.528 2.528 0 015.778 3.25h3.555a.75.75 0 010 1.5H5.778c-.568 0-1.028.46-1.028 1.028v3.555a.75.75 0 01-1.5 0V5.778zM13.917 4a.75.75 0 01.75-.75h3.555a2.528 2.528 0 012.528 2.528v3.555a.75.75 0 01-1.5 0V5.778c0-.568-.46-1.028-1.028-1.028h-3.555a.75.75 0 01-.75-.75zM3.25 12a.75.75 0 01.75-.75h16a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75zM4 13.917a.75.75 0 01.75.75v3.555c0 .568.46 1.028 1.028 1.028h3.555a.75.75 0 010 1.5H5.778a2.528 2.528 0 01-2.528-2.528v-3.555a.75.75 0 01.75-.75zm16 0a.75.75 0 01.75.75v3.555a2.528 2.528 0 01-2.528 2.528h-3.555a.75.75 0 010-1.5h3.555c.568 0 1.028-.46 1.028-1.028v-3.555a.75.75 0 01.75-.75z"
  }));
};

Scan.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Scan.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Lock = function Lock(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85 7.886C5.85 4.444 8.583 1.65 12 1.65c3.417 0 6.15 2.794 6.15 6.236v.278a2.585 2.585 0 011.8 2.465v9.142c0 1.41-1.135 2.579-2.55 2.579H6.6c-1.415 0-2.55-1.17-2.55-2.579v-9.143c0-1.148.754-2.138 1.8-2.464v-.278zm1.5.164h9.3v-.164c0-2.636-2.084-4.736-4.65-4.736-2.566 0-4.65 2.1-4.65 4.736v.164zm-.75 1.5c-.565 0-1.05.476-1.05 1.079v9.142c0 .603.485 1.079 1.05 1.079h10.8c.565 0 1.05-.476 1.05-1.079v-9.143c0-.602-.485-1.078-1.05-1.078H6.6z"
  }));
};

Lock.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Lock.defaultProps = {
  color: 'currentColor',
  size: '24'
};

var Key = function Key(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.497 3.385c-3.037-.888-6.215.821-7.11 3.793-.893 2.968.82 6.102 3.852 6.989 1.39.406 2.738.547 3.798.136a.75.75 0 01.798.165l6.474 6.382h2.541v-2.484l-6.47-6.377a.75.75 0 01-.21-.67l.159-.866a.74.74 0 01.02-.08c.893-2.968-.82-6.101-3.852-6.988zM1.95 6.746C3.088 2.97 7.107.83 10.918 1.946c3.801 1.111 5.99 5.049 4.879 8.819l-.08.434 6.41 6.319a.75.75 0 01.223.534V21.6a.75.75 0 01-.75.75h-3.599a.75.75 0 01-.526-.216l-6.368-6.277c-1.41.384-2.955.14-4.29-.25-3.814-1.117-6.005-5.079-4.866-8.86zM8.25 9A.75.75 0 019 8.25h.12a.75.75 0 010 1.5h-.12A.75.75 0 018.25 9z"
  }));
};

Key.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Key.defaultProps = {
  color: 'currentColor',
  size: '24'
};

export { Add01, Add02, Add03, AddCircleContained, AddCircleContainedFill, AddSquareContained, AlarmCheck, AlarmMinus, AlarmOff, AlarmOn, AlarmPlus, AlertCircleContained, AlertCircleContainedFill, AlertSquareContained, Annotation, AnnotationAlert, AnnotationTyping, Arbitrum, ArbitrumFillBrand, ArrowDown, ArrowDown2, ArrowDownContained01, ArrowDownContained02, ArrowDownLeft, ArrowDownLeftContained02, ArrowDownLeftSm, ArrowDownRight, ArrowDownRightContained02, ArrowDownRightSm, ArrowLeft, ArrowLeft2, ArrowLeftContained01, ArrowLeftContained02, ArrowLeftSm, ArrowRefresh, ArrowRight, ArrowRight2, ArrowRightContained01, ArrowRightContained02, ArrowRightSm, ArrowRotateLeft, ArrowRotateRight, ArrowUp, ArrowUp2, ArrowUpContained01, ArrowUpContained02, ArrowUpLeft, ArrowUpLeftContained02, ArrowUpLeftSm, ArrowUpRight, ArrowUpRightContained02, ArrowUpRightSm, ArrowUpSm, AtSign, Bag, BarChartSquareDown01, BarChartSquareDown02, BarChartSquareUp01, BarChartSquareUp02, BarGroup01, BarGroup02, BarGroup03, Bell, BellOff, BitKeepFillBrand, Bnb, Box, Btc, Calendar01, Calendar02, Calendar03, Calendar04, Camera, Card, CardAdd, CardCheck, CardDown, CardEdit, CardLock, CardMinus, CardUp, CardX, Champion, Check, CheckBroken, CheckContained, CheckContainedFill, CheckSquareBroken, CheckSquareContained, ChevronDoubleDown, ChevronDoubleLeft, ChevronDoubleRight, ChevronDoubleUp, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Circle, ClockForward, ClockPlus, CoinBroken, CoinHand, Coins, CoinsRotate, Component, CopyLeft, CopyRight, CurrencyCoinDollar, CurrencyCoinEuro, CurrencyCoinPound, CurrencyCoinRubel, CurrencyCoinRupee, CurrencyDollar, CurrencyEuro, CurrencyPound, CurrencyRubel, CurrencyRupee, DiscordFillBrand, DownArrowSm, Download01, Download02, Edit, EmojiAdmissionTickets, EmojiAlarmClock, EmojiFire, EmojiRocket, EmojiTrophy, Eth, EyeClosed, EyeOpen, Favourite, File01, File02, File03, FileCheck01, FileCheck02, FileDown01, FileDown02, FileEdit01, FileEdit02, FileMultiple, FileNone, FilePlus01, FilePlus02, FileQuestion01, FileQuestion02, FileUp01, FileUp02, FileX01, FileX02, Filter02, Filter1, FilterFill, FlipLeft, FlipRight, Gift, Globe, GoogleFillBrand, Hash, HelpCircleContained, HelpCircleContainedFill, HelpSquareContained, Home, Image01, Image02, ImageAdd, ImageCheck, ImageDown, ImageMinus, ImageQuestion, ImageUp, ImageX, Inbox01, Inbox02, InformationCircleContained, InformationCircleContainedFill, InformationSquareContained, Key, LineChartDown01, LineChartDown02, LineChartUp01, LineChartUp02, Link, LinkAngled, LinkBroken, LinkExternal, Loader01, Loader02, Loader03, Lock, Logout01, Logout02, Mail01, Mail02, Mail03, Marker, Matic, Menu01, Menu02, Menu03, Menu04, MessageChat, MessageNotifySquare, MetamaskFillBrand, Minus01, Minus02, Minus03, MinusCircleContained, MinusCircleContainedFill, MinusSquareContained, MoonLine, More01, More02, OptimismFillBrand, Package02, Paperclip, Phone, PieChart01, PieChart02, PieChart03, Receipt, ReceiptLines, Reconnect, Rocket, SafepalFillBrand, Save, Scan, Search, Send01, Send02, Settings, Share, Shield, ShieldCheck, SmileyHappy, SmileyHappyPlus, SmileyNeutral, SmileySad, SmileyWink, SortVertical01, SortVertical02, Square, StarFill, StarLine, SunLine, Tag, TagFill, Target01, Target02, Ticket01, Ticket02, TokenpocketFillBrand, Trash01, Trash02, Trash03, Trash04, TrendDown01, TrendUp01, TwitterFillBrand, Upload01, Upload02, UserProfile01, UserProfile02, UserProfile03, UserProfileAdd, UserProfileCheck, UserProfileSquare, UsersProfiles01, UsersProfiles02, UsersProfiles03, Wallet, WalletConnectFill, X01, X02, X03, XCircleContained, XCircleContainedFill, XSquareContained, ZkSync };
